import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { AfterViewInit, ChangeDetectorRef, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FilesetResolver, HandLandmarker, HandLandmarkerResult, NormalizedLandmark } from '@mediapipe/tasks-vision';
import { Service } from "src/libs/portal/season/service";

type CameraOption = {
    deviceId: string;
    label: string;
    isLogitech: boolean;
    index: number;
};

type WandlessMode = 'magic' | 'desktop' | 'realDesktop';
type RealDesktopControllerPlatform = 'macos' | 'windows';
type RealDesktopEnableHoldSource = 'button' | 'gesture';
type RealDesktopClickMode = 'doubleTap' | 'pinchClick' | 'dwellClick';
type RealDesktopTargetMode = 'full' | 'current' | 'custom';

type ModeOption = {
    id: WandlessMode;
    label: string;
    icon: string;
};

type RealDesktopControllerPlatformOption = {
    id: RealDesktopControllerPlatform;
    label: string;
    icon: string;
};

type RealDesktopClickModeOption = {
    id: RealDesktopClickMode;
    label: string;
    icon: string;
    description: string;
};

type RealDesktopTargetModeOption = {
    id: RealDesktopTargetMode;
    label: string;
    icon: string;
};

type CanvasPoint = {
    x: number;
    y: number;
};

type RealDesktopPointerSettings = {
    sensitivity: number;
    deadZone: number;
    smoothing: number;
};

type DesktopPracticeState = 'idle' | 'hover' | 'dragging';

type DesktopIconTile = {
    id: string;
    label: string;
    icon: string;
    x: number;
    y: number;
    width: number;
    height: number;
    color: string;
};

type DesktopDragState = {
    iconId: string | null;
    offsetX: number;
    offsetY: number;
    trackId: number | null;
};

type DesktopCursorState = {
    visible: boolean;
    active: boolean;
    x: number;
    y: number;
    targetX: number;
    targetY: number;
    alpha: number;
    scale: number;
};

type RealDesktopControlState = 'disabled' | 'connecting' | 'ready' | 'moving' | 'dragging' | 'paused' | 'stopped' | 'permission' | 'error';
type RealDesktopPauseHoldTarget = 'pause' | 'resume';

type RealDesktopScreen = {
    x: number;
    y: number;
    width: number;
    height: number;
};

type RealDesktopTargetSettings = {
    mode: RealDesktopTargetMode;
    custom: RealDesktopScreen;
};

type RealDesktopMonitorEstimate = {
    width: number;
    height: number;
    scale: number;
};

type RealDesktopCommandType = 'move' | 'down' | 'drag' | 'up' | 'stop' | 'space_previous' | 'space_next';

type RealDesktopSpaceDirection = 'previous' | 'next';

type RealDesktopCommand = {
    type: RealDesktopCommandType;
    x?: number;
    y?: number;
    reason?: string;
};

type RealDesktopTapPhase = 'idle' | 'depthPressed';

type RealDesktopCalibrationPointId = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'center';

type RealDesktopCalibrationTarget = {
    id: RealDesktopCalibrationPointId;
    label: string;
    shortLabel: string;
    target: CanvasPoint;
};

type RealDesktopCalibrationSample = {
    id: RealDesktopCalibrationPointId;
    observed: CanvasPoint;
    target: CanvasPoint;
    capturedAt: number;
};

type RealDesktopCalibrationTransform = {
    x: [number, number, number];
    y: [number, number, number];
};

type RealDesktopCalibrationData = {
    version: 1;
    createdAt: number;
    screen: RealDesktopScreen | null;
    samples: RealDesktopCalibrationSample[];
    transform: RealDesktopCalibrationTransform;
};

type RealDesktopTapTracker = {
    trackId: number | null;
    phase: RealDesktopTapPhase;
    baselineZ: number | null;
    pressStartedAt: number;
    pressPoint: CanvasPoint | null;
    stableStartedAt: number;
    stablePoint: CanvasPoint | null;
    lastIndexOnlyAt: number;
    lastIndexPoint: CanvasPoint | null;
    lastScreenPoint: CanvasPoint | null;
    lastTapAt: number;
    lastTapPoint: CanvasPoint | null;
};

type RealDesktopPointerGesture = {
    isIndexOnly: boolean;
    isPinch: boolean;
    pinchStarted: boolean;
    pinchReleased: boolean;
    dragArming: boolean;
    dragReady: boolean;
};

type RealDesktopPinchClickTracker = {
    trackId: number | null;
    startedAt: number;
    startPoint: CanvasPoint | null;
    startScreenPoint: CanvasPoint | null;
    blocked: boolean;
};

type RealDesktopDwellClickTracker = {
    trackId: number | null;
    startedAt: number;
    anchorPoint: CanvasPoint | null;
    anchorScreenPoint: CanvasPoint | null;
    clicked: boolean;
    cooldownUntil: number;
};

type RealDesktopGestureHudItem = {
    id: string;
    label: string;
    active: boolean;
    tone: 'neutral' | 'live' | 'warn' | 'danger';
    help: string;
};

type RealDesktopControllerStatus = {
    ok?: boolean;
    platform?: string;
    message?: string;
    error?: string;
    mouseDown?: boolean;
    screen?: RealDesktopScreen;
    accessibility?: {
        trusted?: boolean | null;
    };
};

type FlameParticle = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    size: number;
    hue: number;
};

type EnergyParticle = {
    handIndex: number;
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    size: number;
};

type EnergyProjectile = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    radius: number;
    power: number;
};

type AimParticle = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    size: number;
};

type AimEffect = {
    active: boolean;
    x: number;
    y: number;
    targetX: number;
    targetY: number;
    dx: number;
    dy: number;
    targetDx: number;
    targetDy: number;
    alpha: number;
    scale: number;
};

type PortalGestureState = 'idle' | 'drawing' | 'portalOpen';

type OpenPalmMetrics = {
    isOpen: boolean;
    openFingers: number;
    score: number;
};

type HandFrame = {
    trackId: number;
    landmarks: NormalizedLandmark[];
    points: CanvasPoint[];
    palm: OpenPalmMetrics;
    center: CanvasPoint;
    motion: number;
    motionEnergy: number;
    scale: number;
};

type UntrackedHandFrame = Omit<HandFrame, 'trackId' | 'motion' | 'motionEnergy'>;

type HandTrack = {
    id: number;
    center: CanvasPoint;
    motion: number;
    motionEnergy: number;
    scale: number;
    lastSeen: number;
};

type PortalHandPair = {
    anchorIndex: number;
    drawingIndex: number;
    anchorTrackId: number;
    drawingTrackId: number;
};

type PortalTracePoint = CanvasPoint & {
    time: number;
};

type PortalCircleMetrics = {
    center: CanvasPoint;
    radius: number;
    angleTravel: number;
    closureRatio: number;
    radialVariance: number;
    directionConsistency: number;
    score: number;
    passed: boolean;
};

type PortalSparkParticle = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    size: number;
    hue: number;
};

type PortalEffect = {
    x: number;
    y: number;
    radius: number;
    life: number;
    maxLife: number;
    rotation: number;
    spin: number;
    scale: number;
};

type OrbCompressState = 'idle' | 'orb' | 'compressing';

type OrbCompressMetrics = {
    firstIndex: number;
    secondIndex: number;
    center: CanvasPoint;
    distance: number;
    radius: number;
    scale: number;
    compression: number;
    intensity: number;
    score: number;
};

type OrbCompressEffect = {
    active: boolean;
    x: number;
    y: number;
    targetX: number;
    targetY: number;
    radius: number;
    targetRadius: number;
    intensity: number;
    targetIntensity: number;
    compression: number;
    targetCompression: number;
    alpha: number;
    scale: number;
};

type OrbCompressParticle = {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    size: number;
    hue: number;
};

type OrbCompressPulse = {
    x: number;
    y: number;
    radius: number;
    maxRadius: number;
    life: number;
    maxLife: number;
    intensity: number;
};

type FingerMeasure = {
    ratio: number;
    folded: boolean;
    extended: boolean;
};

type IndexAimMetrics = {
    indexExtended: boolean;
    foldedFingers: number;
    extendedOtherFingers: number;
};

type FistMetrics = {
    foldedFingers: number;
    extendedFingers: number;
    averageTipRatio: number;
    indexFolded: boolean;
    indexExtended: boolean;
};

type MagicGestureName = 'portal' | 'orbCompress' | 'fistCharge' | 'pinchFire' | 'indexAim';
type GesturePhase = 'idle' | 'candidate' | 'active' | 'releasing' | 'cooldown';
type GestureReleaseReason = 'ended' | 'lost' | 'preempted' | 'reset';

type GestureDefinition = {
    priority: number;
    startThreshold: number;
    endThreshold: number;
    cooldownMs: number;
    releaseLockMs: number;
    locked: boolean;
};

type GestureCandidate = {
    name: MagicGestureName;
    confidence: number;
    hands: number[];
    trackIds: number[];
    priority: number;
    data?: unknown;
};

type GestureRelease = {
    name: MagicGestureName;
    hands: number[];
    trackIds: number[];
    reason: GestureReleaseReason;
};

type GestureArbiterDecision = {
    active: GestureCandidate | null;
    released: GestureRelease | null;
    phases: Record<MagicGestureName, GesturePhase>;
};

type HandGestureFeature = {
    hand: HandFrame;
    handIndex: number;
    pinchDistance: number;
    pinchConfidence: number;
    aimMetrics: IndexAimMetrics;
    aimConfidence: number;
    fistMetrics: FistMetrics;
    fistConfidence: number;
};

class GestureArbiter {
    private readonly definitions: Record<MagicGestureName, GestureDefinition> = {
        portal: {
            priority: 5,
            startThreshold: 0.5,
            endThreshold: 0.2,
            cooldownMs: 420,
            releaseLockMs: 160,
            locked: true
        },
        orbCompress: {
            priority: 4,
            startThreshold: 0.24,
            endThreshold: 0.12,
            cooldownMs: 180,
            releaseLockMs: 90,
            locked: true
        },
        fistCharge: {
            priority: 3,
            startThreshold: 0.82,
            endThreshold: 0.38,
            cooldownMs: 130,
            releaseLockMs: 70,
            locked: false
        },
        pinchFire: {
            priority: 2,
            startThreshold: 0.9,
            endThreshold: 0.12,
            cooldownMs: 90,
            releaseLockMs: 45,
            locked: false
        },
        indexAim: {
            priority: 1,
            startThreshold: 0.9,
            endThreshold: 0.58,
            cooldownMs: 90,
            releaseLockMs: 45,
            locked: false
        }
    };
    private readonly gestureNames: MagicGestureName[] = ['portal', 'orbCompress', 'fistCharge', 'pinchFire', 'indexAim'];
    private activeName: MagicGestureName | null = null;
    private activeHands: number[] = [];
    private activeTrackIds: number[] = [];
    private globalLockUntil: number = 0;
    private cooldownUntil: Record<MagicGestureName, number> = {
        portal: 0,
        orbCompress: 0,
        fistCharge: 0,
        pinchFire: 0,
        indexAim: 0
    };
    private releasingUntil: Record<MagicGestureName, number> = {
        portal: 0,
        orbCompress: 0,
        fistCharge: 0,
        pinchFire: 0,
        indexAim: 0
    };
    private phases: Record<MagicGestureName, GesturePhase> = {
        portal: 'idle',
        orbCompress: 'idle',
        fistCharge: 'idle',
        pinchFire: 'idle',
        indexAim: 'idle'
    };

    public getPriority(name: MagicGestureName): number {
        return this.definitions[name].priority;
    }

    public isActive(name: MagicGestureName): boolean {
        return this.activeName === name;
    }

    public get activeGesture(): MagicGestureName | null {
        return this.activeName;
    }

    public decide(candidates: GestureCandidate[], timestamp: number, detectedHandCount: number): GestureArbiterDecision {
        const normalized = this.normalizeCandidates(candidates);
        const available = this.getAvailableCandidates(normalized, timestamp);
        let released: GestureRelease | null = null;
        let nextActive: GestureCandidate | null = null;

        if (this.activeName) {
            const current = this.findBestCandidateForGesture(available, this.activeName);
            const currentDefinition = this.definitions[this.activeName];
            const higherPriority = this.pickStartCandidate(
                available.filter((candidate) => candidate.name !== this.activeName),
                timestamp,
                this.activeName
            );
            const canPreempt = !!higherPriority &&
                !currentDefinition.locked &&
                higherPriority.priority > currentDefinition.priority;

            if (canPreempt) {
                released = this.releaseActive(timestamp, 'preempted');
                nextActive = this.activateCandidate(higherPriority);
            } else if (current && current.confidence >= currentDefinition.endThreshold) {
                nextActive = this.activateCandidate(current);
            } else {
                released = this.releaseActive(timestamp, detectedHandCount > 0 ? 'ended' : 'lost');
                if (timestamp >= this.globalLockUntil) {
                    const next = this.pickStartCandidate(available, timestamp);
                    if (next) nextActive = this.activateCandidate(next);
                }
            }
        } else if (timestamp >= this.globalLockUntil) {
            const next = this.pickStartCandidate(available, timestamp);
            if (next) nextActive = this.activateCandidate(next);
        }

        this.refreshPhases(normalized, timestamp);
        return {
            active: nextActive,
            released,
            phases: { ...this.phases }
        };
    }

    public forceRelease(reason: GestureReleaseReason = 'reset', timestamp: number = performance.now()): GestureRelease | null {
        const released = this.releaseActive(timestamp, reason);
        this.refreshPhases([], timestamp);
        return released;
    }

    public reset() {
        this.activeName = null;
        this.activeHands = [];
        this.activeTrackIds = [];
        this.globalLockUntil = 0;
        this.gestureNames.forEach((name) => {
            this.cooldownUntil[name] = 0;
            this.releasingUntil[name] = 0;
            this.phases[name] = 'idle';
        });
    }

    private normalizeCandidates(candidates: GestureCandidate[]): GestureCandidate[] {
        const withPriority = candidates
            .filter((candidate) => candidate.confidence > 0)
            .map((candidate) => ({
                ...candidate,
                priority: this.definitions[candidate.name].priority
            }));
        const hasTwoHandCandidate = withPriority.some((candidate) =>
            candidate.hands.length >= 2 &&
            candidate.confidence >= this.definitions[candidate.name].startThreshold
        );

        if (!hasTwoHandCandidate) return withPriority;

        return withPriority.filter((candidate) => candidate.hands.length >= 2 || candidate.name === 'portal');
    }

    private getAvailableCandidates(candidates: GestureCandidate[], timestamp: number): GestureCandidate[] {
        return candidates.filter((candidate) => {
            if (this.activeName === candidate.name) return true;
            return timestamp >= this.cooldownUntil[candidate.name];
        });
    }

    private pickStartCandidate(
        candidates: GestureCandidate[],
        timestamp: number,
        currentName: MagicGestureName | null = null
    ): GestureCandidate | null {
        return candidates
            .filter((candidate) => {
                if (currentName && candidate.name === currentName) return false;
                const definition = this.definitions[candidate.name];
                return timestamp >= this.cooldownUntil[candidate.name] &&
                    candidate.confidence >= definition.startThreshold;
            })
            .sort((first, second) =>
                second.priority - first.priority ||
                second.confidence - first.confidence ||
                second.hands.length - first.hands.length
            )[0] || null;
    }

    private findBestCandidateForGesture(candidates: GestureCandidate[], name: MagicGestureName): GestureCandidate | null {
        return candidates
            .filter((candidate) => candidate.name === name)
            .sort((first, second) => {
                const firstOverlap = this.countTrackOverlap(first.trackIds);
                const secondOverlap = this.countTrackOverlap(second.trackIds);
                return secondOverlap - firstOverlap || second.confidence - first.confidence;
            })[0] || null;
    }

    private countTrackOverlap(trackIds: number[]): number {
        if (this.activeTrackIds.length === 0 || trackIds.length === 0) return 0;
        return trackIds.filter((trackId) => this.activeTrackIds.includes(trackId)).length;
    }

    private activateCandidate(candidate: GestureCandidate): GestureCandidate {
        this.activeName = candidate.name;
        this.activeHands = [...candidate.hands];
        this.activeTrackIds = [...candidate.trackIds];
        this.phases[candidate.name] = 'active';
        return candidate;
    }

    private releaseActive(timestamp: number, reason: GestureReleaseReason): GestureRelease | null {
        if (!this.activeName) return null;

        const name = this.activeName;
        const definition = this.definitions[name];
        const released: GestureRelease = {
            name,
            hands: [...this.activeHands],
            trackIds: [...this.activeTrackIds],
            reason
        };

        this.activeName = null;
        this.activeHands = [];
        this.activeTrackIds = [];
        this.releasingUntil[name] = timestamp + definition.releaseLockMs;
        this.cooldownUntil[name] = timestamp + definition.cooldownMs;
        this.globalLockUntil = Math.max(this.globalLockUntil, timestamp + definition.releaseLockMs);
        return released;
    }

    private refreshPhases(candidates: GestureCandidate[], timestamp: number) {
        this.gestureNames.forEach((name) => {
            if (this.activeName === name) {
                this.phases[name] = 'active';
            } else if (timestamp < this.releasingUntil[name]) {
                this.phases[name] = 'releasing';
            } else if (timestamp < this.cooldownUntil[name]) {
                this.phases[name] = 'cooldown';
            } else if (candidates.some((candidate) => candidate.name === name)) {
                this.phases[name] = 'candidate';
            } else {
                this.phases[name] = 'idle';
            }
        });
    }
}

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  --control-panel-width: 360px;
  --bg-deep: #0d0907;
  --bg-panel: #15100a;
  --bg-panel-soft: rgba(0, 0, 0, 0.3);
  --bg-panel-active: rgba(212, 162, 89, 0.08);
  --gold-primary: #d4a259;
  --gold-glow: #f4d28a;
  --gold-muted: #8b6a3a;
  --gold-shadow: rgba(212, 162, 89, 0.15);
  --text-parchment: #e8d5a8;
  --text-faded: #8b7355;
  --text-dim: #6b5840;
  --text-ghost: #4a3d2a;
  --border-soft: rgba(139, 106, 58, 0.2);
  --border-mid: rgba(139, 106, 58, 0.4);
  --border-strong: #8b6a3a;
  --parchment-base: #2a1f12;
  --parchment-warm: #3a2a18;
  --parchment-edge: #1a1208;
  --tag-verdigris: #5a7a5a;
  --tag-amber: #a88845;
  --tag-sealwax: #8a3a30;
  --tag-amethyst: #6a4a7a;
  --tag-copper: #3a6a6a;
  --tag-indigo: #3a4a7a;
  --font-ritual: Georgia, "Times New Roman", "Noto Serif KR", serif;
  --font-tech: "Courier New", "JetBrains Mono", monospace;
  display: block;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  color: var(--text-parchment);
  background: var(--bg-deep);
  font-family: var(--font-ritual);
}

:host * {
  box-sizing: border-box;
}

button,
select {
  font: inherit;
}

button {
  cursor: pointer;
}

.wandless-shell {
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1fr) var(--control-panel-width);
  background: var(--bg-deep);
}

.stage {
  min-width: 0;
  min-height: 100vh;
  padding: 24px;
  display: flex;
}

.camera-view {
  position: relative;
  width: 100%;
  height: calc(100vh - 48px);
  min-height: 480px;
  overflow: hidden;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: radial-gradient(ellipse at center, #1a1208 0%, #0a0604 70%, #050302 100%);
}

.camera-view::before,
.camera-view::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.camera-view::before {
  z-index: 4;
  opacity: 0.4;
  background-image: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.15) 2px, rgba(0, 0, 0, 0.15) 3px);
}

.camera-view::after {
  z-index: 5;
  background: radial-gradient(ellipse at center, transparent 52%, rgba(13, 9, 7, 0.58) 100%), linear-gradient(180deg, rgba(13, 9, 7, 0.12), rgba(13, 9, 7, 0.36));
}

.camera-view.desktop-view {
  background: radial-gradient(ellipse at 30% 20%, var(--parchment-warm) 0%, var(--parchment-base) 42%, var(--parchment-edge) 100%);
}

.camera-view.desktop-view::before {
  z-index: 4;
  opacity: 1;
  background-image: linear-gradient(rgba(212, 162, 89, 0.08) 0.3px, transparent 0.3px), linear-gradient(90deg, rgba(212, 162, 89, 0.08) 0.3px, transparent 0.3px), linear-gradient(rgba(212, 162, 89, 0.15) 0.5px, transparent 0.5px), linear-gradient(90deg, rgba(212, 162, 89, 0.15) 0.5px, transparent 0.5px);
  background-size: 20px 20px, 20px 20px, 100px 100px, 100px 100px;
}

.camera-view.desktop-view::after {
  z-index: 5;
  background: radial-gradient(circle at 15% 25%, rgba(139, 106, 58, 0.08) 0%, transparent 25%), radial-gradient(circle at 84% 70%, rgba(139, 106, 58, 0.06) 0%, transparent 30%), radial-gradient(circle at 50% 90%, rgba(139, 106, 58, 0.05) 0%, transparent 20%), radial-gradient(ellipse at center, transparent 58%, rgba(13, 9, 7, 0.35) 100%);
}

.camera-view video,
.camera-view canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.camera-view video {
  z-index: 1;
  object-fit: cover;
  transform: scaleX(-1);
  background: #0b0705;
  transition: opacity 0.3s ease;
}

.camera-view video.is-hidden-feed {
  opacity: 0;
}

.camera-view canvas {
  z-index: 2;
  pointer-events: none;
}

.stage-bracket {
  position: absolute;
  width: 22px;
  height: 22px;
  z-index: 9;
  border-color: var(--gold-muted);
  opacity: 0.58;
  pointer-events: none;
}

.stage-bracket.tl {
  top: 12px;
  left: 12px;
  border-top: 1px solid;
  border-left: 1px solid;
}

.stage-bracket.tr {
  top: 12px;
  right: 12px;
  border-top: 1px solid;
  border-right: 1px solid;
}

.stage-bracket.bl {
  bottom: 12px;
  left: 12px;
  border-bottom: 1px solid;
  border-left: 1px solid;
}

.stage-bracket.br {
  right: 12px;
  bottom: 12px;
  border-right: 1px solid;
  border-bottom: 1px solid;
}

.stage-header {
  position: absolute;
  top: 30px;
  left: 42px;
  right: 22px;
  z-index: 8;
  display: grid;
  grid-template-columns: minmax(150px, 1fr) auto;
  align-items: center;
  gap: 14px;
}

.lab-state,
.mode-button,
.camera-rune,
.section-meta,
.status-item .value {
  font-family: var(--font-tech);
}

.lab-state {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
  gap: 10px;
  color: var(--text-faded);
  font-size: 12px;
  letter-spacing: 0.06em;
  font-style: italic;
}

.lab-state span:last-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lab-state .dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--text-dim);
}

.lab-state.is-awake {
  color: var(--gold-glow);
}

.lab-state.is-awake .dot {
  background: var(--gold-glow);
  box-shadow: 0 0 14px var(--gold-shadow);
  animation: pulse 1.8s ease-in-out infinite;
}

.mode-switch {
  min-width: 0;
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  background: rgba(21, 16, 10, 0.72);
  backdrop-filter: blur(12px);
  justify-self: end;
}

.mode-button {
  min-height: 30px;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: var(--text-faded);
  background: transparent;
  font-size: 10px;
  letter-spacing: 0.08em;
  white-space: nowrap;
  transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

.mode-button.is-active {
  color: var(--gold-glow);
  border-color: var(--border-mid);
  background: var(--bg-panel-active);
  box-shadow: 0 0 14px var(--gold-shadow);
}

.mode-button:not(.is-active):hover {
  color: var(--text-parchment);
  background: rgba(139, 106, 58, 0.12);
}

.camera-rune {
  position: absolute;
  top: 70px;
  right: 24px;
  z-index: 8;
  color: var(--text-dim);
  font-size: 11px;
  letter-spacing: 0.2em;
}

.idle-state,
.loading-state,
.error-state,
.live-badge,
.practice-static,
.stage-controls,
.practice-badge {
  position: absolute;
}

.idle-state {
  inset: 0;
  z-index: 7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  padding: 70px 28px 42px;
  color: var(--text-parchment);
  text-align: center;
  background: rgba(13, 9, 7, 0.5);
}

.sigil {
  position: relative;
  width: 200px;
  height: 200px;
}

.sigil-ring {
  width: 100%;
  height: 100%;
  animation: rotate 60s linear infinite;
}

.sigil-ring circle,
.sigil-ring path {
  fill: none;
  stroke: var(--gold-muted);
  stroke-width: 0.5;
  opacity: 0.66;
}

.sigil-ring circle:nth-child(2),
.sigil-ring circle:nth-child(4) {
  stroke-dasharray: 2 4;
  opacity: 0.46;
}

.sigil-ring circle:nth-child(3),
.sigil-ring circle:last-child {
  stroke: var(--gold-primary);
  opacity: 0.78;
}

.sigil-ring circle:last-child {
  fill: var(--gold-glow);
  stroke: none;
}

.sigil-core {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}

.breath {
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(244, 210, 138, 0.34) 0%, rgba(244, 210, 138, 0.08) 44%, transparent 70%);
  animation: breathe 3s ease-in-out infinite;
}

.brand-block h1 {
  margin: 0;
  color: var(--text-parchment);
  font-family: var(--font-ritual);
  font-size: 34px;
  font-weight: 400;
  letter-spacing: 0.13em;
  text-shadow: 0 0 24px var(--gold-shadow);
}

.brand-block p {
  margin: 10px 0 0;
  color: var(--text-faded);
  font-size: 13px;
  font-style: italic;
  letter-spacing: 0.08em;
}

.loading-state,
.error-state {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  color: var(--text-parchment);
  background: rgba(21, 16, 10, 0.86);
  font-size: 13px;
}

.loading-state {
  left: 22px;
  bottom: 72px;
  z-index: 9;
  padding: 10px 12px;
  color: var(--gold-glow);
}

.error-state {
  left: 22px;
  right: 22px;
  bottom: 72px;
  z-index: 9;
  padding: 11px 13px;
  color: #eec0a4;
  background: rgba(54, 22, 14, 0.9);
}

.spinner {
  width: 16px;
  height: 16px;
  border: 1px solid rgba(212, 162, 89, 0.28);
  border-top-color: var(--gold-glow);
  border-radius: 50%;
  animation: rotate 3s linear infinite;
}

.live-badge {
  right: 22px;
  bottom: 20px;
  z-index: 8;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--border-soft);
  border-radius: 999px;
  color: var(--gold-glow);
  background: rgba(21, 16, 10, 0.78);
  font-family: var(--font-tech);
  font-size: 11px;
  letter-spacing: 0.12em;
}

.live-badge .dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--gold-glow);
  box-shadow: 0 0 12px var(--gold-shadow);
  animation: pulse 1.8s ease-in-out infinite;
}

.stage-controls {
  left: 22px;
  bottom: 18px;
  z-index: 8;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.stage-button {
  min-width: 92px;
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  border-radius: 6px;
  border: 1px solid var(--border-mid);
  font-family: var(--font-ritual);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  transition: border-color 0.3s ease, box-shadow 0.3s ease, color 0.3s ease, background 0.3s ease;
}

.stage-button-primary {
  color: var(--gold-glow);
  border-color: var(--border-strong);
  background: linear-gradient(180deg, #3a2818, #1f1409);
  box-shadow: inset 0 1px 0 rgba(244, 210, 138, 0.18), 0 0 16px var(--gold-shadow);
}

.stage-button-ghost {
  color: var(--text-dim);
  background: rgba(21, 16, 10, 0.5);
}

.real-desktop-stage-controls .stage-button-ghost {
  color: #9cdbff;
  border-color: rgba(88, 196, 255, 0.34);
  background: rgba(7, 16, 18, 0.68);
}

.stage-button-danger {
  color: #f1cab9;
  border-color: rgba(176, 78, 50, 0.64);
  background: rgba(84, 28, 18, 0.68);
}

.stage-button:not(:disabled):hover {
  border-color: var(--border-strong);
  color: var(--gold-glow);
  box-shadow: 0 0 18px rgba(212, 162, 89, 0.24);
}

.practice-badge,
.real-badge {
  right: 60px;
  bottom: 20px;
  z-index: 8;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 1px solid var(--border-mid);
  border-radius: 999px;
  color: var(--gold-glow);
  background: rgba(0, 0, 0, 0.5);
  font-family: var(--font-tech);
  font-size: 10px;
  letter-spacing: 0.18em;
}

.real-badge {
  color: #9cdbff;
  border-color: rgba(88, 196, 255, 0.42);
}

.practice-badge .dot,
.real-badge .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--gold-glow);
  box-shadow: 0 0 6px var(--gold-primary);
  animation: pulse 1.5s ease-in-out infinite;
}

.real-badge .dot {
  background: #9cdbff;
  box-shadow: 0 0 8px rgba(88, 196, 255, 0.8);
}

.gesture-preview-hud {
  position: absolute;
  left: 24px;
  bottom: 88px;
  z-index: 9;
  width: min(360px, 100% - 48px);
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid rgba(156, 219, 255, 0.28);
  border-radius: 8px;
  color: #d7f5fb;
  background: rgba(4, 10, 12, 0.74);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(10px);
  pointer-events: none;
}

.gesture-preview-header {
  min-width: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.gesture-preview-title {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.gesture-preview-header strong {
  min-width: 0;
  overflow: hidden;
  color: #d9fff5;
  font-family: var(--font-tech);
  font-size: 14px;
  letter-spacing: 0.04em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gesture-preview-kicker,
.gesture-preview-click-mode,
.gesture-preview-hud small {
  color: #8fb7c3;
  font-family: "Courier New", monospace;
  font-size: 10px;
  line-height: 1.35;
}

.gesture-preview-click-mode {
  color: #bdeaf4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gesture-preview-states {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.gesture-preview-chip {
  max-width: 100%;
  min-height: 22px;
  display: inline-flex;
  align-items: center;
  padding: 0 7px;
  border: 1px solid rgba(120, 174, 187, 0.2);
  border-radius: 999px;
  color: #7d9da8;
  background: rgba(120, 174, 187, 0.08);
  font-family: "Courier New", monospace;
  font-size: 10px;
  line-height: 1;
  white-space: nowrap;
}

.gesture-preview-chip.is-active {
  color: #d9fff5;
  border-color: rgba(114, 240, 198, 0.52);
  background: rgba(25, 120, 100, 0.32);
  box-shadow: 0 0 14px rgba(114, 240, 198, 0.18);
}

.gesture-preview-chip.is-warn.is-active {
  color: #ffe6b3;
  border-color: rgba(255, 194, 92, 0.55);
  background: rgba(124, 83, 21, 0.34);
  box-shadow: 0 0 14px rgba(255, 194, 92, 0.14);
}

.gesture-preview-chip.is-danger.is-active {
  color: #ffd5d8;
  border-color: rgba(255, 100, 120, 0.58);
  background: rgba(140, 36, 52, 0.34);
  box-shadow: 0 0 14px rgba(255, 100, 120, 0.16);
}

.real-desktop-safety {
  position: absolute;
  left: 42px;
  right: 42px;
  bottom: 86px;
  z-index: 7;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  gap: 16px;
  max-width: 760px;
  padding: 18px;
  border: 1px solid rgba(88, 196, 255, 0.24);
  border-radius: 8px;
  color: #cbe9f4;
  background: rgba(7, 16, 18, 0.78);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(12px);
}

.safety-mark {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(88, 196, 255, 0.34);
  border-radius: 8px;
  color: #9cdbff;
  background: rgba(88, 196, 255, 0.08);
}

.safety-copy {
  min-width: 0;
}

.safety-copy h2 {
  margin: 0;
  color: #e9f8fb;
  font-family: var(--font-tech);
  font-size: 15px;
  letter-spacing: 0.08em;
}

.safety-copy p {
  margin: 8px 0 0;
  color: #a9cbd5;
  font-size: 12px;
  line-height: 1.45;
}

.enable-hold-panel {
  display: grid;
  gap: 8px;
  margin-top: 12px;
  padding: 10px;
  border: 1px solid rgba(114, 240, 198, 0.24);
  border-radius: 6px;
  background: rgba(4, 10, 12, 0.38);
}

.enable-hold-header {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #8fb7c3;
  font-family: var(--font-tech);
  font-size: 10px;
}

.enable-hold-header strong {
  color: #d9fff5;
  font-size: 11px;
  white-space: nowrap;
}

.enable-hold-track {
  position: relative;
  height: 6px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(120, 174, 187, 0.18);
}

.enable-hold-track span {
  position: absolute;
  inset: 0 auto 0 0;
  width: 0;
  border-radius: inherit;
  background: linear-gradient(90deg, #72f0c6, #9cdbff);
  box-shadow: 0 0 12px rgba(114, 240, 198, 0.42);
  transition: width 0.08s linear;
}

.enable-hold-panel p {
  margin: 0;
}

.safety-copy ul {
  margin: 10px 0 0;
  padding-left: 17px;
  color: #8fb7c3;
  font-size: 11px;
  line-height: 1.55;
}

.setup-steps {
  margin: 10px 0 0;
  padding-left: 18px;
  color: #bdeaf4;
  font-size: 11px;
  line-height: 1.48;
}

.setup-steps li + li {
  margin-top: 5px;
}

.stage-setup-steps {
  color: #d7f5fb;
}

.practice-static {
  inset: 0;
  z-index: 3;
  pointer-events: none;
}

.practice-desktop {
  position: absolute;
  inset: 70px 30px 70px;
}

.desk-icon {
  position: absolute;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 14px 18px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  background: rgba(20, 14, 8, 0.35);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.desk-icon .tag {
  width: 56px;
  height: 56px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  color: rgba(255, 240, 210, 0.85);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), inset 0 -1px 0 rgba(0, 0, 0, 0.3);
  font-family: var(--font-tech);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
}

.desk-icon .label {
  color: var(--text-parchment);
  font-family: var(--font-ritual);
  font-size: 13px;
  font-style: italic;
  letter-spacing: 0.05em;
}

.tag-fol {
  background: var(--tag-verdigris);
}

.tag-txt {
  background: var(--tag-amber);
}

.tag-cfg {
  background: var(--tag-sealwax);
}

.tag-aud {
  background: var(--tag-amethyst);
}

.tag-web {
  background: var(--tag-copper);
}

.tag-img {
  background: var(--tag-indigo);
}

.pos-1 {
  top: 5%;
  left: 8%;
}

.pos-2 {
  top: 5%;
  left: 28%;
}

.pos-3 {
  top: 40%;
  left: 45%;
}

.pos-4 {
  top: 65%;
  left: 12%;
}

.pos-5 {
  top: 65%;
  left: 32%;
}

.pos-6 {
  top: 59%;
  left: 54%;
}

.control-panel {
  position: relative;
  width: var(--control-panel-width);
  min-width: 0;
  height: 100vh;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px 24px 24px;
  border-left: 1px solid var(--border-soft);
  background: linear-gradient(180deg, var(--bg-panel) 0%, var(--bg-deep) 100%);
}

.control-panel::before {
  content: "";
  position: absolute;
  left: 0;
  top: 18%;
  bottom: 18%;
  width: 1px;
  background: linear-gradient(180deg, transparent, var(--gold-shadow), transparent);
}

.panel-header,
.console-brand,
.status-item,
.status-item .label {
  display: flex;
  align-items: center;
}

.panel-header {
  justify-content: space-between;
  gap: 12px;
}

.console-brand {
  min-width: 0;
  gap: 12px;
}

.panel-seal {
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
  fill: rgba(212, 162, 89, 0.08);
  stroke: var(--gold-primary);
  stroke-width: 0.8;
}

.panel-header h1 {
  margin: 0;
  color: var(--text-parchment);
  font-family: var(--font-ritual);
  font-size: 25px;
  font-weight: 400;
  letter-spacing: 0.08em;
}

.panel-header p {
  margin: 5px 0 0;
  color: var(--text-faded);
  font-size: 11px;
  font-style: italic;
  letter-spacing: 0.08em;
}

.controls,
.status-grid {
  display: flex;
  flex-direction: column;
}

.cam-block {
  gap: 10px;
  padding-top: 18px;
  border-top: 1px solid var(--border-soft);
}

.real-desktop-block {
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid rgba(88, 196, 255, 0.18);
}

.cam-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.control-label,
.status-item .label {
  color: var(--text-faded);
  font-size: 12px;
  font-weight: 700;
}

.section-meta {
  color: var(--text-dim);
  font-size: 10px;
}

.select-wrap {
  position: relative;
}

.select-wrap select {
  width: 100%;
  min-height: 42px;
  padding: 0 40px 0 13px;
  border: 1px solid var(--border-mid);
  border-radius: 4px;
  appearance: none;
  color: var(--gold-primary);
  background: var(--bg-panel-soft);
  font-family: var(--font-ritual);
  font-size: 13px;
  outline: none;
}

.select-wrap select:focus {
  border-color: var(--gold-muted);
  box-shadow: 0 0 16px var(--gold-shadow);
}

.select-wrap select:disabled,
button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.select-wrap i {
  position: absolute;
  top: 50%;
  right: 13px;
  transform: translateY(-50%);
  color: var(--gold-muted);
  pointer-events: none;
}

.camera-note {
  min-height: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  color: var(--text-dim);
  font-size: 12px;
}

.camera-note strong {
  min-width: 0;
  color: var(--text-faded);
  font-weight: 600;
}

.controller-card {
  display: grid;
  gap: 8px;
  padding: 12px;
  border: 1px solid rgba(88, 196, 255, 0.2);
  border-radius: 6px;
  background: rgba(8, 16, 18, 0.42);
}

.controller-line {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  font-family: var(--font-tech);
  font-size: 10px;
}

.controller-line .label {
  color: #78aebb;
}

.controller-line .value {
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  color: #bdeaf4;
}

.controller-card p,
.accessibility-note {
  margin: 0;
  color: #8fb7c3;
  font-size: 11px;
  line-height: 1.45;
}

.pointer-settings-card {
  display: grid;
  gap: 10px;
  padding: 10px;
  border: 1px solid rgba(156, 219, 255, 0.18);
  border-radius: 6px;
  background: rgba(5, 10, 12, 0.48);
}

.pointer-settings-header {
  min-width: 0;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 10px;
}

.pointer-settings-header > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.pointer-settings-kicker,
.pointer-slider-label span {
  color: #78aebb;
  font-family: var(--font-tech);
  font-size: 10px;
}

.pointer-settings-header strong,
.pointer-slider-label strong {
  min-width: 0;
  color: #d9fff5;
  font-family: var(--font-tech);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pointer-settings-reset {
  min-width: 0;
  min-height: 28px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 8px;
  border: 1px solid rgba(120, 174, 187, 0.28);
  border-radius: 5px;
  color: #9cdbff;
  background: rgba(10, 24, 28, 0.58);
  font-family: var(--font-tech);
  font-size: 10px;
  white-space: nowrap;
}

.pointer-settings-reset:hover {
  border-color: rgba(156, 219, 255, 0.58);
  color: #d7f5fb;
  background: rgba(16, 38, 44, 0.74);
}

.pointer-slider {
  display: grid;
  gap: 6px;
}

.pointer-slider-label {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.pointer-slider input[type=range] {
  width: 100%;
  accent-color: #72f0c6;
}

.click-mode-selector {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.click-mode-button {
  min-width: 0;
  min-height: 72px;
  display: grid;
  grid-template-rows: auto auto 1fr;
  justify-items: center;
  gap: 4px;
  padding: 8px 6px;
  border: 1px solid rgba(120, 174, 187, 0.22);
  border-radius: 6px;
  color: #8fb7c3;
  background: rgba(10, 24, 28, 0.38);
  font-family: var(--font-tech);
  text-align: center;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.click-mode-button i {
  color: #9cdbff;
  font-size: 13px;
}

.click-mode-button span {
  max-width: 100%;
  color: #d7f5fb;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.click-mode-button small {
  color: #78aebb;
  font-size: 9px;
  line-height: 1.25;
}

.click-mode-button.is-active {
  border-color: rgba(114, 240, 198, 0.56);
  color: #d9fff5;
  background: rgba(25, 120, 100, 0.2);
  box-shadow: 0 0 14px rgba(114, 240, 198, 0.14);
}

.click-mode-button:not(.is-active):hover {
  border-color: rgba(156, 219, 255, 0.48);
  background: rgba(16, 38, 44, 0.62);
}

.controller-setup {
  display: grid;
  gap: 8px;
  padding: 12px;
  border: 1px solid rgba(156, 219, 255, 0.18);
  border-radius: 6px;
  background: rgba(5, 10, 12, 0.5);
}

.platform-selector {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.platform-button {
  min-width: 0;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid rgba(120, 174, 187, 0.28);
  border-radius: 5px;
  color: #9cdbff;
  background: rgba(10, 24, 28, 0.46);
  font-family: var(--font-tech);
  font-size: 10px;
  white-space: nowrap;
  cursor: pointer;
}

.platform-button.is-active {
  border-color: rgba(114, 240, 198, 0.68);
  color: #d9fff5;
  background: rgba(32, 91, 76, 0.44);
}

.target-mode-selector {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.target-mode-selector .platform-button {
  min-height: 48px;
  flex-direction: column;
  gap: 4px;
  padding: 6px 4px;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
}

.target-mode-selector .platform-button span {
  max-width: 100%;
  overflow-wrap: anywhere;
}

.target-region-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.target-region-grid label {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.target-region-grid span {
  color: #78aebb;
  font-family: var(--font-tech);
  font-size: 9px;
}

.target-region-input {
  min-width: 0;
  width: 100%;
  min-height: 30px;
  padding: 0 8px;
  border: 1px solid rgba(120, 174, 187, 0.26);
  border-radius: 5px;
  color: #d9fff5;
  background: rgba(10, 24, 28, 0.58);
  font-family: var(--font-tech);
  font-size: 11px;
  outline: none;
}

.target-region-input:focus {
  border-color: rgba(114, 240, 198, 0.62);
  box-shadow: 0 0 0 1px rgba(114, 240, 198, 0.18);
}

.target-preset-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.target-preset-button {
  min-width: 0;
  min-height: 28px;
  border: 1px solid rgba(120, 174, 187, 0.24);
  border-radius: 5px;
  color: #9cdbff;
  background: rgba(10, 24, 28, 0.42);
  font-family: var(--font-tech);
  font-size: 9px;
  cursor: pointer;
}

.target-preset-button:hover {
  border-color: rgba(156, 219, 255, 0.5);
  background: rgba(16, 38, 44, 0.68);
}

.setup-title {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  color: #bdeaf4;
  font-family: var(--font-tech);
  font-size: 10px;
}

.setup-title i {
  color: #9cdbff;
}

.panel-setup-steps {
  margin-top: 0;
  color: #9dc9d4;
}

.setup-help {
  margin: 0;
  color: #8fb7c3;
  font-size: 11px;
  line-height: 1.45;
}

.controller-command {
  display: block;
  max-height: 132px;
  overflow: auto;
  padding: 9px;
  border: 1px solid rgba(120, 174, 187, 0.2);
  border-radius: 4px;
  color: #d7f5fb;
  background: rgba(0, 0, 0, 0.34);
  font-family: var(--font-tech);
  font-size: 10px;
  line-height: 1.45;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.setup-links {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px;
}

.setup-link,
.copy-command-button,
.switch-button {
  min-width: 0;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid rgba(120, 174, 187, 0.28);
  border-radius: 5px;
  color: #9cdbff;
  background: rgba(10, 24, 28, 0.58);
  font-family: var(--font-tech);
  font-size: 10px;
  text-decoration: none;
  white-space: nowrap;
  transition: border-color 0.25s ease, color 0.25s ease, background 0.25s ease;
}

.copy-command-button {
  width: 100%;
  cursor: pointer;
}

.desktop-switch-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.switch-button {
  cursor: pointer;
}

.switch-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.setup-link:hover,
.copy-command-button:hover,
.switch-button:not(:disabled):hover {
  border-color: rgba(156, 219, 255, 0.58);
  color: #d7f5fb;
  background: rgba(16, 38, 44, 0.74);
}

.accessibility-note {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 8px;
  align-items: start;
}

.accessibility-note i {
  color: #9cdbff;
  line-height: 1.4;
}

.calibration-card {
  display: grid;
  gap: 10px;
  padding: 10px;
  border: 1px solid rgba(156, 219, 255, 0.18);
  border-radius: 6px;
  background: rgba(5, 10, 12, 0.48);
}

.calibration-header {
  min-width: 0;
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 10px;
}

.calibration-header > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.calibration-kicker,
.calibration-saved {
  color: #78aebb;
  font-family: var(--font-tech);
  font-size: 10px;
}

.calibration-header strong {
  min-width: 0;
  color: #d9fff5;
  font-family: var(--font-tech);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calibration-saved {
  flex: 0 0 auto;
  padding: 3px 6px;
  border: 1px solid rgba(114, 240, 198, 0.34);
  border-radius: 4px;
  color: #d9fff5;
  background: rgba(32, 91, 76, 0.34);
}

.calibration-points {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 5px;
}

.calibration-point {
  min-width: 0;
  min-height: 26px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(120, 174, 187, 0.2);
  border-radius: 4px;
  color: #78aebb;
  background: rgba(10, 24, 28, 0.34);
  font-family: var(--font-tech);
  font-size: 10px;
}

.calibration-point.is-active {
  border-color: rgba(156, 219, 255, 0.68);
  color: #d7f5fb;
  box-shadow: 0 0 14px rgba(88, 196, 255, 0.18);
}

.calibration-point.is-done {
  border-color: rgba(114, 240, 198, 0.48);
  color: #d9fff5;
  background: rgba(32, 91, 76, 0.34);
}

.calibration-card p {
  margin: 0;
  color: #8fb7c3;
  font-size: 10px;
  line-height: 1.42;
}

.calibration-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.action-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 42px;
  gap: 8px;
  margin-top: 4px;
}

.real-desktop-actions {
  margin-top: 0;
}

.primary-button,
.stop-button,
.icon-button {
  min-width: 0;
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid var(--border-mid);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  white-space: nowrap;
  transition: border-color 0.3s ease, box-shadow 0.3s ease, color 0.3s ease, background 0.3s ease;
}

.primary-button {
  color: var(--gold-glow);
  background: linear-gradient(180deg, #3a2818, #1f1409);
  box-shadow: inset 0 1px 0 rgba(244, 210, 138, 0.16), 0 0 16px var(--gold-shadow);
}

.stop-button,
.icon-button {
  color: var(--text-dim);
  background: rgba(48, 37, 24, 0.58);
}

.primary-button:not(:disabled):hover,
.stop-button:not(:disabled):hover,
.icon-button:not(:disabled):hover {
  border-color: var(--border-strong);
  color: var(--gold-glow);
  box-shadow: 0 0 18px rgba(212, 162, 89, 0.24);
}

.status-grid {
  gap: 9px;
  margin-top: 2px;
}

.status-item {
  min-height: 50px;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-left: 1px solid var(--border-mid);
  border-radius: 0 4px 4px 0;
  color: var(--text-faded);
  background: var(--bg-panel-soft);
  filter: saturate(0.62);
  transition: background 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease, filter 0.4s ease;
}

.status-item .label {
  min-width: 0;
  gap: 10px;
  font-family: var(--font-ritual);
}

.status-item .label .dot {
  width: 5px;
  height: 5px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--text-dim);
}

.status-item .value {
  max-width: 54%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-dim);
  font-size: 11px;
  font-style: italic;
}

.status-item.is-active {
  border-left-color: var(--gold-primary);
  background: var(--bg-panel-active);
  box-shadow: 0 0 14px var(--gold-shadow);
  filter: none;
}

.status-item.is-active .label,
.status-item.is-active .value {
  color: var(--gold-glow);
}

.status-item.is-active .label .dot {
  background: var(--gold-glow);
  box-shadow: 0 0 8px var(--gold-primary);
  animation: pulse 1.7s ease-in-out infinite;
}

.value.is-danger {
  color: #eec0a4;
}

.value.is-waiting {
  color: var(--gold-primary);
}

.console-footer {
  margin-top: auto;
  padding-top: 14px;
  border-top: 1px solid rgba(139, 106, 58, 0.16);
  color: var(--text-ghost);
  text-align: center;
  font-size: 10px;
  font-style: italic;
  letter-spacing: 0.14em;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes breathe {
  0%, 100% {
    transform: scale(1);
    opacity: 0.58;
  }
  50% {
    transform: scale(1.15);
    opacity: 1;
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.42;
  }
}
@media (max-width: 980px) {
  :host {
    position: static;
    width: 100%;
    height: auto;
    min-height: 100vh;
    overflow: auto;
  }
  .wandless-shell {
    width: 100%;
    height: auto;
    min-height: 100vh;
    grid-template-columns: 1fr;
  }
  .stage {
    min-height: auto;
    padding: 12px;
  }
  .camera-view {
    height: 62vh;
    min-height: 360px;
  }
  .control-panel {
    width: 100%;
    height: auto;
    min-height: auto;
    border-left: 0;
    border-top: 1px solid var(--border-soft);
  }
}
@media (max-width: 620px) {
  .stage-header {
    left: 22px;
    grid-template-columns: 1fr;
    align-items: start;
  }
  .mode-switch {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    justify-self: stretch;
  }
  .mode-button {
    padding: 0 8px;
  }
  .mode-button span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .camera-rune {
    display: none;
  }
  .idle-state {
    padding-top: 96px;
  }
  .sigil {
    width: 154px;
    height: 154px;
  }
  .brand-block h1 {
    font-size: 28px;
  }
  .action-row {
    grid-template-columns: 1fr 1fr 40px;
  }
  .stage-controls {
    right: 22px;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .stage-button {
    min-width: 0;
    padding: 0 12px;
  }
  .practice-badge {
    right: 22px;
    max-width: calc(100% - 44px);
  }
  .real-badge {
    right: 22px;
    max-width: calc(100% - 44px);
  }
  .real-desktop-safety {
    left: 18px;
    right: 18px;
    bottom: 86px;
    grid-template-columns: 1fr;
    padding: 14px;
  }
  .practice-desktop {
    inset: 96px 18px 74px;
  }
  .desk-icon {
    min-width: 82px;
    padding: 10px 12px;
  }
  .desk-icon .tag {
    width: 44px;
    height: 44px;
    font-size: 11px;
  }
}
:host-context(html.wandless-single-monitor-mode) {
  position: fixed !important;
  inset: auto 16px 16px auto !important;
  width: 340px !important;
  height: 500px !important;
  min-height: 0 !important;
  overflow: visible !important;
  background: transparent !important;
  pointer-events: none;
  z-index: 2147483000;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode {
  width: 340px !important;
  height: 500px !important;
  min-height: 0 !important;
  display: block !important;
  background: transparent !important;
  pointer-events: auto;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .stage {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  padding: 0 !important;
  display: block !important;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .camera-view {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  border-radius: 8px !important;
  border-color: rgba(156, 219, 255, 0.38) !important;
  background: #071011 !important;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(156, 219, 255, 0.16);
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .control-panel,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .stage-header,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .camera-rune,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .stage-bracket,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .stage-controls,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .real-badge,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .live-badge,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .practice-badge,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .real-desktop-safety,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .practice-static,
:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .idle-state {
  display: none !important;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .gesture-preview-hud {
  left: 10px;
  right: 10px;
  top: 10px;
  bottom: auto;
  width: auto;
  z-index: 13;
  gap: 6px;
  padding: 9px;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .gesture-preview-header strong {
  font-size: 12px;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .gesture-preview-states {
  max-height: 54px;
  overflow: hidden;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .gesture-preview-chip {
  min-height: 19px;
  padding: 0 6px;
  font-size: 9px;
}

:host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode .gesture-preview-hud small {
  display: none;
}

.single-monitor-hud {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
  z-index: 12;
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid rgba(156, 219, 255, 0.28);
  border-radius: 7px;
  color: #d7f5fb;
  background: rgba(4, 10, 12, 0.84);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.34);
  font-family: "Courier New", monospace;
}

.single-monitor-status {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.single-monitor-kicker,
.single-monitor-status small,
.single-monitor-hud p,
.single-monitor-esc {
  color: #8fb7c3;
  font-size: 10px;
  line-height: 1.35;
}

.single-monitor-status strong {
  min-width: 0;
  color: #d9fff5;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.single-monitor-status > span:not(.single-monitor-kicker) {
  min-width: 0;
  overflow: hidden;
  color: #bdeaf4;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.single-monitor-hud p {
  margin: 0;
}

.single-monitor-hold {
  display: grid;
  gap: 5px;
}

.single-monitor-hold .enable-hold-track {
  height: 5px;
}

.single-monitor-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(82px, 1fr));
  gap: 8px;
  align-items: center;
}

.single-monitor-enable,
.single-monitor-resume,
.single-monitor-stop {
  min-width: 0;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid rgba(120, 174, 187, 0.36);
  border-radius: 6px;
  color: #d9fff5;
  background: rgba(22, 72, 68, 0.72);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.single-monitor-stop {
  border-color: rgba(238, 192, 164, 0.52);
  color: #ffe0cf;
  background: rgba(86, 26, 22, 0.78);
}

.single-monitor-resume {
  border-color: rgba(114, 240, 198, 0.5);
  color: #d9fff5;
  background: rgba(22, 92, 72, 0.78);
}

.single-monitor-enable:disabled,
.single-monitor-resume:disabled,
.single-monitor-stop:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.single-monitor-tools {
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid rgba(156, 219, 255, 0.18);
  border-radius: 6px;
  background: rgba(5, 10, 12, 0.48);
}

.single-monitor-tool-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.72fr);
  gap: 8px;
}

.single-monitor-tools p {
  margin: 0;
  color: #8fb7c3;
  font-size: 10px;
  line-height: 1.42;
}

@media (max-width: 420px) {
  :host-context(html.wandless-single-monitor-mode) {
    inset: auto 8px 8px auto !important;
    width: calc(100vw - 16px) !important;
    height: min(500px, 100vh - 16px) !important;
  }
  :host-context(html.wandless-single-monitor-mode) .wandless-shell.single-monitor-mode {
    width: calc(100vw - 16px) !important;
    height: min(500px, 100vh - 16px) !important;
  }
}`],
})
export class PageDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('videoElement') public videoElement?: ElementRef<HTMLVideoElement>;
    @ViewChild('effectCanvas') public effectCanvas?: ElementRef<HTMLCanvasElement>;

    constructor(@Inject( Service)         public service: Service,@Inject( NgZone)         private zone: NgZone,@Inject( ChangeDetectorRef    )         private ref: ChangeDetectorRef    ) { }

    public cameras: CameraOption[] = [];
    public selectedDeviceId: string = '';
    public activeCameraLabel: string = '';
    public isRunning: boolean = false;
    public isLoading: boolean = false;
    public hasPermission: boolean = false;
    public cameraStatus: string = '대기';
    public modelStatus: string = '대기';
    public handStatus: string = '대기';
    public gestureStatus: string = 'inactive';
    public spellStatus: string = 'idle';
    public errorMessage: string = '';
    public activeMode: WandlessMode = 'magic';
    public readonly modeOptions: ModeOption[] = [
        { id: 'magic', label: 'Magic Mode', icon: 'fa-solid fa-wand-sparkles' },
        { id: 'desktop', label: 'Practice Mode', icon: 'fa-solid fa-display' },
        { id: 'realDesktop', label: 'Real Desktop', icon: 'fa-solid fa-computer-mouse' }
    ];
    private readonly realDesktopPointerSettingsDefaults: RealDesktopPointerSettings = {
        sensitivity: 1,
        deadZone: 3,
        smoothing: 25
    };
    private readonly realDesktopTargetSettingsDefaults: RealDesktopTargetSettings = {
        mode: 'full',
        custom: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }
    };
    public realDesktopEnabled: boolean = false;
    public realDesktopControllerUrl: string = 'http://127.0.0.1:17374';
    public realDesktopStatus: string = 'disabled';
    public realDesktopControllerMessage: string = '오른쪽 패널에서 OS를 선택하고 터미널 명령을 실행한 뒤 Enable을 누르세요.';
    public realDesktopScreenLabel: string = '컨트롤러 연결 전';
    public realDesktopSingleMonitorMode: boolean = false;
    public realDesktopVisibilityNotice: string = '';
    public realDesktopPaused: boolean = false;
    public realDesktopPauseHoldActive: boolean = false;
    public realDesktopPauseHoldProgress: number = 0;
    public realDesktopPauseHoldMessage: string = '열린 손바닥을 0.8초 유지하면 일시정지/재개합니다.';
    public realDesktopEnableHoldActive: boolean = false;
    public realDesktopEnableHoldProgress: number = 0;
    public realDesktopEnableHoldMessage: string = 'Enable을 1초 동안 누르거나 열린 손바닥을 화면에 유지하세요.';
    public realDesktopCalibrationActive: boolean = false;
    public realDesktopCalibrationStepIndex: number = 0;
    public realDesktopPointerSettings: RealDesktopPointerSettings = { ...this.realDesktopPointerSettingsDefaults };
    public realDesktopClickMode: RealDesktopClickMode = 'doubleTap';
    public realDesktopTargetSettings: RealDesktopTargetSettings = {
        mode: this.realDesktopTargetSettingsDefaults.mode,
        custom: { ...this.realDesktopTargetSettingsDefaults.custom }
    };
    public readonly realDesktopClickModeOptions: RealDesktopClickModeOption[] = [
        {
            id: 'doubleTap',
            label: 'Double Tap',
            icon: 'fa-solid fa-hand-pointer',
            description: '기존 검지 탭 두 번을 더블클릭으로 전송'
        },
        {
            id: 'pinchClick',
            label: 'Pinch Click',
            icon: 'fa-solid fa-circle-dot',
            description: '짧은 pinch release를 단일 클릭으로 전송'
        },
        {
            id: 'dwellClick',
            label: 'Dwell Click',
            icon: 'fa-solid fa-stopwatch',
            description: '손 커서가 같은 위치에 머물면 단일 클릭'
        }
    ];
    public readonly realDesktopTargetModeOptions: RealDesktopTargetModeOption[] = [
        { id: 'full', label: 'Full Screen', icon: 'fa-solid fa-expand' },
        { id: 'current', label: 'Current Monitor', icon: 'fa-solid fa-display' },
        { id: 'custom', label: 'Custom Region', icon: 'fa-solid fa-crop-simple' }
    ];
    public realDesktopControllerPlatform: RealDesktopControllerPlatform = this.detectRealDesktopControllerPlatform();
    public readonly realDesktopControllerPlatformOptions: RealDesktopControllerPlatformOption[] = [
        { id: 'macos', label: 'macOS', icon: 'fa-solid fa-laptop' },
        { id: 'windows', label: 'Windows', icon: 'fa-solid fa-desktop' }
    ];
    public readonly realDesktopMacControllerScriptPath: string = '/assets/real-desktop-controller/macos_controller.py';
    public readonly realDesktopWindowsControllerScriptPath: string = '/assets/real-desktop-controller/windows_controller.py';
    public readonly realDesktopMacControllerRequirementsPath: string = '/assets/real-desktop-controller/requirements.txt';
    public readonly realDesktopControllerReadmePath: string = '/assets/real-desktop-controller/README.md';
    public readonly realDesktopCalibrationTargets: RealDesktopCalibrationTarget[] = [
        { id: 'topLeft', label: '좌상단', shortLabel: 'TL', target: { x: 0, y: 0 } },
        { id: 'topRight', label: '우상단', shortLabel: 'TR', target: { x: 1, y: 0 } },
        { id: 'bottomLeft', label: '좌하단', shortLabel: 'BL', target: { x: 0, y: 1 } },
        { id: 'bottomRight', label: '우하단', shortLabel: 'BR', target: { x: 1, y: 1 } },
        { id: 'center', label: '중앙', shortLabel: 'C', target: { x: 0.5, y: 0.5 } }
    ];

    private stream: MediaStream | null = null;
    private handLandmarker: HandLandmarker | null = null;
    private animationFrame: number = 0;
    private resizeObserver: ResizeObserver | null = null;
    private particles: FlameParticle[] = [];
    private aimParticles: AimParticle[] = [];
    private energyParticles: EnergyParticle[] = [];
    private energyProjectiles: EnergyProjectile[] = [];
    private portalTrace: PortalTracePoint[] = [];
    private portalSparks: PortalSparkParticle[] = [];
    private portalEffects: PortalEffect[] = [];
    private portalState: PortalGestureState = 'idle';
    private portalAnchorTrackId: number | null = null;
    private portalDrawingTrackId: number | null = null;
    private portalCircleScore: number = 0;
    private portalCooldownUntil: number = 0;
    private handTracks: HandTrack[] = [];
    private nextHandTrackId: number = 1;
    private gestureArbiter: GestureArbiter = new GestureArbiter();
    private orbCompressState: OrbCompressState = 'idle';
    private orbCompressPair: [number, number] | null = null;
    private orbCompressEffect: OrbCompressEffect = {
        active: false,
        x: 0,
        y: 0,
        targetX: 0,
        targetY: 0,
        radius: 0,
        targetRadius: 0,
        intensity: 0,
        targetIntensity: 0,
        compression: 0,
        targetCompression: 0,
        alpha: 0,
        scale: 1
    };
    private orbCompressParticles: OrbCompressParticle[] = [];
    private orbCompressPulses: OrbCompressPulse[] = [];
    private orbPulseCooldownUntil: number = 0;
    private desktopState: DesktopPracticeState = 'idle';
    private desktopHoveredIconId: string | null = null;
    private desktopDrag: DesktopDragState = {
        iconId: null,
        offsetX: 0,
        offsetY: 0,
        trackId: null
    };
    private desktopPinchReadyByHand: boolean[] = [];
    private desktopCursor: DesktopCursorState = {
        visible: false,
        active: false,
        x: 0,
        y: 0,
        targetX: 0,
        targetY: 0,
        alpha: 0,
        scale: 1
    };
    private realDesktopState: RealDesktopControlState = 'disabled';
    private realDesktopScreen: RealDesktopScreen | null = null;
    private realDesktopCompactWindowMode: boolean = false;
    private realDesktopMouseDown: boolean = false;
    private realDesktopActiveTrackId: number | null = null;
    private realDesktopPinchReadyByHand: boolean[] = [];
    private realDesktopPinchActiveByHand: boolean[] = [];
    private realDesktopLastScreenPoint: CanvasPoint | null = null;
    private realDesktopLastDragScreenPoint: CanvasPoint | null = null;
    private realDesktopPendingMoveCommand: RealDesktopCommand | null = null;
    private realDesktopMoveFlushTimer: number = 0;
    private realDesktopCommandChain: Promise<void> = Promise.resolve();
    private realDesktopCommandSequence: number = 0;
    private realDesktopEnableHoldSource: RealDesktopEnableHoldSource | null = null;
    private realDesktopEnableHoldStartedAt: number = 0;
    private realDesktopEnableHoldTimer: number = 0;
    private realDesktopEnableHoldCompleting: boolean = false;
    private realDesktopEnableHoldTrackId: number | null = null;
    private realDesktopEnableHoldAnchor: CanvasPoint | null = null;
    private realDesktopPauseHoldTrackId: number | null = null;
    private realDesktopPauseHoldAnchor: CanvasPoint | null = null;
    private realDesktopPauseHoldStartedAt: number = 0;
    private realDesktopPauseHoldTarget: RealDesktopPauseHoldTarget | null = null;
    private realDesktopPauseGestureReleaseRequired: boolean = false;
    private realDesktopDragArmingTrackId: number | null = null;
    private realDesktopDragArmingStartedAt: number = 0;
    private realDesktopDragArmingPoint: CanvasPoint | null = null;
    private realDesktopPointerRawAnchor: CanvasPoint | null = null;
    private realDesktopPointerOutputPoint: CanvasPoint | null = null;
    private realDesktopCalibration: RealDesktopCalibrationData | null = null;
    private realDesktopCalibrationDraft: RealDesktopCalibrationSample[] = [];
    private realDesktopCalibrationCurrentObservedPoint: CanvasPoint | null = null;
    private realDesktopTap: RealDesktopTapTracker = {
        trackId: null,
        phase: 'idle',
        baselineZ: null,
        pressStartedAt: 0,
        pressPoint: null,
        stableStartedAt: 0,
        stablePoint: null,
        lastIndexOnlyAt: 0,
        lastIndexPoint: null,
        lastScreenPoint: null,
        lastTapAt: 0,
        lastTapPoint: null
    };
    private realDesktopPinchClick: RealDesktopPinchClickTracker = {
        trackId: null,
        startedAt: 0,
        startPoint: null,
        startScreenPoint: null,
        blocked: false
    };
    private realDesktopDwellClick: RealDesktopDwellClickTracker = {
        trackId: null,
        startedAt: 0,
        anchorPoint: null,
        anchorScreenPoint: null,
        clicked: false,
        cooldownUntil: 0
    };
    private realDesktopDwellClickProgress: number = 0;
    private realDesktopDwellClickMessage: string = 'Dwell Click 대기';
    private desktopIcons: DesktopIconTile[] = [
        { id: 'folder', label: 'Project', icon: 'FOL', x: 0.08, y: 0.14, width: 0.13, height: 0.13, color: '#5a7a5a' },
        { id: 'notes', label: 'Notes', icon: 'TXT', x: 0.26, y: 0.14, width: 0.13, height: 0.13, color: '#a88845' },
        { id: 'image', label: 'Images', icon: 'IMG', x: 0.44, y: 0.14, width: 0.13, height: 0.13, color: '#3a4a7a' },
        { id: 'browser', label: 'Browser', icon: 'WEB', x: 0.08, y: 0.34, width: 0.13, height: 0.13, color: '#3a6a6a' },
        { id: 'music', label: 'Audio', icon: 'AUD', x: 0.26, y: 0.34, width: 0.13, height: 0.13, color: '#6a4a7a' },
        { id: 'settings', label: 'Settings', icon: 'CFG', x: 0.44, y: 0.34, width: 0.13, height: 0.13, color: '#8a3a30' }
    ];
    private pinchActiveByHand: boolean[] = [];
    private aimActiveByHand: boolean[] = [];
    private aimEffectsByHand: AimEffect[] = [];
    private fistActiveByHand: boolean[] = [];
    private fistChargeByHand: number[] = [];
    private fistCenterByHand: CanvasPoint[] = [];
    private fistDirectionByHand: CanvasPoint[] = [];
    private fistScaleByHand: number[] = [];
    private lastFrameTime: number = 0;
    private destroyed: boolean = false;
    private readonly pinchStartThreshold: number = 0.055;
    private readonly pinchEndThreshold: number = 0.09;
    private readonly realDesktopPinchStartThreshold: number = 0.044;
    private readonly realDesktopPinchEndThreshold: number = 0.075;
    private readonly realDesktopIndexOnlyPinchStartThreshold: number = 0.032;
    private readonly realDesktopIndexOnlyPinchEndThreshold: number = 0.058;
    private readonly realDesktopEnableHoldDuration: number = 1000;
    private readonly realDesktopPauseHoldDuration: number = 800;
    private readonly realDesktopDragArmDuration: number = 260;
    private readonly realDesktopDragMoveThreshold: number = 1.5;
    private readonly realDesktopTapPressMinDuration: number = 35;
    private readonly realDesktopTapPressMaxDuration: number = 260;
    private readonly realDesktopTapStableMinDuration: number = 70;
    private readonly realDesktopTapStableMaxDuration: number = 320;
    private readonly realDesktopTapReleaseGraceMs: number = 150;
    private readonly realDesktopDoubleTapMaxInterval: number = 420;
    private readonly realDesktopTapDepthPressDelta: number = 0.035;
    private readonly realDesktopTapDepthReleaseDelta: number = 0.014;
    private readonly realDesktopPinchClickMinDuration: number = 35;
    private readonly realDesktopPinchClickMaxDuration: number = 230;
    private readonly realDesktopDwellClickDuration: number = 700;
    private readonly realDesktopDwellClickCooldown: number = 650;
    private readonly realDesktopPointerSettingsStorageKey: string = 'wandless.realDesktop.pointerSettings.v1';
    private readonly realDesktopTargetSettingsStorageKey: string = 'wandless.realDesktop.targetSettings.v1';
    private readonly realDesktopClickModeStorageKey: string = 'wandless.realDesktop.clickMode.v1';
    private readonly realDesktopCalibrationStorageKey: string = 'wandless.realDesktop.calibration.v1';
    private readonly aimIndexExtendRatio: number = 1.48;
    private readonly aimFoldedRatio: number = 1.33;
    private readonly aimEndFoldedRatio: number = 1.48;
    private readonly fistStartAverageRatio: number = 1.42;
    private readonly fistEndAverageRatio: number = 1.72;
    private readonly maxAimParticles: number = 260;
    private readonly maxEnergyParticles: number = 440;
    private readonly maxEnergyProjectiles: number = 8;
    private readonly maxPortalSparks: number = 180;
    private readonly maxPortalEffects: number = 1;
    private readonly maxOrbCompressParticles: number = 360;
    private readonly maxOrbCompressPulses: number = 5;
    private readonly portalTraceMaxAge: number = 2050;
    private readonly portalTraceMinDuration: number = 420;
    private readonly portalStillTimeout: number = 780;
    private readonly portalMinRadiusRatio: number = 0.038;
    private readonly handTrackRetention: number = 650;
    private readonly maxDetectedHands: number = 8;
    private readonly maxParticles: number = 560;
    private readonly handConnections: Array<[number, number]> = [
        [0, 1], [1, 2], [2, 3], [3, 4],
        [0, 5], [5, 6], [6, 7], [7, 8],
        [5, 9], [9, 10], [10, 11], [11, 12],
        [9, 13], [13, 14], [14, 15], [15, 16],
        [13, 17], [17, 18], [18, 19], [19, 20],
        [0, 17]
    ];

    private readonly resizeCanvas = () => {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const rect = canvas.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
        const width = Math.max(1, Math.floor(rect.width * ratio));
        const height = Math.max(1, Math.floor(rect.height * ratio));

        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
        }
    };

    private readonly renderFrame = (timestamp: number) => {
        if (!this.isRunning || this.destroyed) return;

        const video = this.videoElement?.nativeElement;
        if (!video || !this.handLandmarker || video.readyState < 2 || video.videoWidth === 0) {
            this.animationFrame = requestAnimationFrame(this.renderFrame);
            return;
        }

        this.resizeCanvas();
        const elapsed = this.lastFrameTime ? timestamp - this.lastFrameTime : 16.67;
        const delta = Math.max(8, Math.min(40, elapsed));
        this.lastFrameTime = timestamp;

        let result: HandLandmarkerResult | null = null;
        try {
            result = this.handLandmarker.detectForVideo(video, timestamp);
        } catch (error) {
            this.reportDetectionError(error);
            return;
        }

        this.drawFrame(result, delta, timestamp);
        this.animationFrame = requestAnimationFrame(this.renderFrame);
    };

    private readonly handleKeydown = (event: KeyboardEvent) => {
        if (this.activeMode !== 'realDesktop') return;

        if (this.realDesktopCalibrationActive && (event.key === 'Enter' || event.key === ' ' || event.code === 'Space')) {
            event.preventDefault();
            void this.captureRealDesktopCalibrationPoint();
            return;
        }

        if (event.key !== 'Escape') return;

        event.preventDefault();
        void this.stopRealDesktopControl('ESC 비상 정지');
    };

    private readonly handleVisibilityChange = () => {
        if (typeof document === 'undefined') return;

        const isHidden = document.visibilityState === 'hidden';
        if (isHidden) {
            if (this.realDesktopMouseDown) {
                this.releaseRealDesktopMouse('브라우저 hidden 전환으로 mouse up');
            }

            if (this.realDesktopEnabled) {
                this.realDesktopVisibilityNotice = '브라우저가 hidden 상태입니다. MediaPipe, requestAnimationFrame, 로컬 컨트롤러 fetch가 지연될 수 있습니다.';
                this.setRealDesktopStatus('ready', this.realDesktopVisibilityNotice);
                if (this.activeMode === 'realDesktop' && !this.destroyed) void this.service.render();
            }
            return;
        }

        this.realDesktopVisibilityNotice = '';
        if (this.activeMode === 'realDesktop' && !this.destroyed) void this.service.render();
    };

    public async ngOnInit() {
        await this.service.init(this);
        this.loadRealDesktopPointerSettings();
        this.loadRealDesktopTargetSettings();
        this.loadRealDesktopClickMode();
        this.loadRealDesktopCalibration();
        this.applyRealDesktopStartupMode();
        await this.refreshCameras(false);
    }

    public ngAfterViewInit() {
        this.resizeCanvas();

        const canvas = this.effectCanvas?.nativeElement;
        if (canvas && 'ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.resizeCanvas);
            this.resizeObserver.observe(canvas);
        }

        window.addEventListener('resize', this.resizeCanvas);
        window.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    public ngOnDestroy() {
        this.destroyed = true;
        void this.stopRealDesktopControl('컴포넌트 종료');
        this.stopTracking();
        this.stopActiveStream();
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.resizeCanvas);
        window.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.setRealDesktopSingleMonitorMode(false);
        this.handLandmarker?.close();
    }

    public get canStart(): boolean {
        return !this.isRunning && !this.isLoading;
    }

    public get currentModeLabel(): string {
        return this.modeOptions.find((mode) => mode.id === this.activeMode)?.label || 'Magic Mode';
    }

    public get currentModeIcon(): string {
        return this.modeOptions.find((mode) => mode.id === this.activeMode)?.icon || 'fa-solid fa-wand-sparkles';
    }

    public get stageName(): string {
        if (this.activeMode === 'realDesktop') return '실제 제어';
        return this.activeMode === 'desktop' ? '수련장' : '실험실';
    }

    public get stageStateText(): string {
        if (this.isLoading) return '조율 중';
        if (this.activeMode === 'desktop') return '깨어남';
        if (this.activeMode === 'realDesktop') return this.realDesktopControlLabel;
        return this.isRunning ? '깨어남' : '대기 중';
    }

    public get isStageAwake(): boolean {
        return this.isRunning || this.activeMode === 'desktop' || this.realDesktopEnabled || this.realDesktopEnableHoldActive;
    }

    public get stageRuneLabel(): string {
        if (this.activeMode === 'realDesktop') return 'REAL · DESKTOP';
        return this.activeMode === 'desktop' ? 'PRACTICE · TABULA' : 'CAM · I';
    }

    public get spellStatusLabel(): string {
        if (this.activeMode === 'magic') return '주문';
        return this.activeMode === 'desktop' ? '연습' : '실제 제어';
    }

    public get cameraSummary(): string {
        if (this.cameras.length === 0) return '카메라 목록 없음';
        return `${this.cameras.length}개 감지됨`;
    }

    public get canEnableRealDesktopControl(): boolean {
        return this.activeMode === 'realDesktop' &&
            !this.realDesktopEnabled &&
            !this.isLoading &&
            !this.realDesktopEnableHoldCompleting;
    }

    public get canStopRealDesktopControl(): boolean {
        return this.activeMode === 'realDesktop' &&
            (this.realDesktopEnabled ||
                this.realDesktopMouseDown ||
                this.realDesktopEnableHoldActive ||
                this.realDesktopState !== 'disabled');
    }

    public get canSwitchRealDesktopSpace(): boolean {
        return this.activeMode === 'realDesktop' && this.realDesktopEnabled && !this.realDesktopPaused && !this.isLoading;
    }

    public get realDesktopControlLabel(): string {
        if (this.realDesktopEnableHoldActive) return '안전 확인';
        if (this.realDesktopPauseHoldActive) return this.realDesktopPaused ? '재개 확인' : '일시정지 확인';
        if (this.realDesktopPaused) return '일시정지';

        const labels: Record<RealDesktopControlState, string> = {
            disabled: '비활성',
            connecting: '연결 확인',
            ready: '준비됨',
            moving: '마우스 이동',
            dragging: '드래그 중',
            paused: '일시정지',
            stopped: '정지',
            permission: '권한 필요',
            error: '오류'
        };
        return labels[this.realDesktopState];
    }

    public get realDesktopControlSummary(): string {
        if (this.realDesktopEnableHoldActive) return this.realDesktopEnableHoldLabel;
        if (this.realDesktopPauseHoldActive) return this.realDesktopPauseHoldLabel;
        if (this.realDesktopPaused) return '일시정지 상태';
        return this.realDesktopEnabled ? 'Enable 상태' : '기본 비활성';
    }

    public get realDesktopGestureHudItems(): RealDesktopGestureHudItem[] {
        const hasDetectedHand = this.realDesktopHasDetectedHand;
        const controllerDisconnected = this.isRealDesktopControllerDisconnected;
        const paused = this.isRealDesktopPaused;
        const noHand = this.isRealDesktopNoHand;

        return [
            {
                id: 'enable-hold',
                label: 'Enable Hold',
                active: this.realDesktopEnableHoldActive,
                tone: this.realDesktopEnableHoldActive ? 'live' : 'neutral',
                help: this.realDesktopEnableHoldMessage
            },
            {
                id: 'pause-hold',
                label: this.realDesktopPauseGestureReleaseRequired
                    ? 'Release Palm'
                    : this.realDesktopPaused ? 'Resume Hold' : 'Pause Hold',
                active: this.realDesktopPauseHoldActive || this.realDesktopPauseGestureReleaseRequired,
                tone: this.realDesktopPauseGestureReleaseRequired ? 'warn' : this.realDesktopPauseHoldActive ? 'live' : 'neutral',
                help: this.realDesktopPauseHoldMessage
            },
            {
                id: 'move',
                label: 'Move',
                active: this.realDesktopEnabled &&
                    !this.realDesktopPaused &&
                    hasDetectedHand &&
                    this.gestureStatus === 'index move' &&
                    !this.realDesktopMouseDown,
                tone: 'live',
                help: 'Index-only hand is moving the pointer.'
            },
            {
                id: 'pinch-ready',
                label: 'Pinch Ready',
                active: this.realDesktopEnabled &&
                    !this.realDesktopPaused &&
                    hasDetectedHand &&
                    this.isRealDesktopPinchReady &&
                    !this.realDesktopMouseDown,
                tone: 'live',
                help: 'A pinch can arm dragging from the current hand.'
            },
            {
                id: 'dragging',
                label: 'Dragging',
                active: !this.realDesktopPaused && (this.realDesktopMouseDown || this.gestureStatus === 'pinch drag'),
                tone: 'live',
                help: 'Mouse down is active until pinch release, Stop, ESC, or lost hand.'
            },
            {
                id: 'double-tap',
                label: 'Double Tap',
                active: this.realDesktopClickMode === 'doubleTap' && !this.realDesktopPaused && this.isRealDesktopDoubleTapCandidate,
                tone: 'live',
                help: 'One tap is waiting for a second tap inside the double-tap window.'
            },
            {
                id: 'pinch-click',
                label: 'Pinch Click',
                active: this.realDesktopClickMode === 'pinchClick' && !this.realDesktopPaused && this.isRealDesktopPinchClickCandidate,
                tone: 'live',
                help: 'Short pinch release sends one click; held pinch continues into drag arm.'
            },
            {
                id: 'dwell-click',
                label: `Dwell Click ${this.realDesktopDwellClickPercent}%`,
                active: this.realDesktopClickMode === 'dwellClick' && !this.realDesktopPaused && this.isRealDesktopDwellClickActive,
                tone: this.realDesktopDwellClickPercent >= 100 ? 'warn' : 'live',
                help: 'Holding the hand cursor still at one position sends one click.'
            },
            {
                id: 'paused',
                label: 'Paused',
                active: paused,
                tone: paused ? 'warn' : 'neutral',
                help: this.realDesktopPaused
                    ? '손 제어가 일시정지되었습니다. 열린 손바닥을 다시 유지하거나 Resume 버튼으로 재개하세요.'
                    : 'Real Desktop is stopped, disabled, or browser visibility is limiting control.'
            },
            {
                id: 'no-hand',
                label: 'No Hand',
                active: noHand,
                tone: noHand ? 'warn' : 'neutral',
                help: 'No usable hand is detected, so click and drag gestures are not sent.'
            },
            {
                id: 'controller-disconnected',
                label: 'Controller Disconnected',
                active: controllerDisconnected,
                tone: controllerDisconnected ? 'danger' : 'neutral',
                help: 'The localhost controller is unavailable or missing permission.'
            }
        ];
    }

    public get realDesktopGestureHudPrimaryItem(): RealDesktopGestureHudItem {
        return this.realDesktopGestureHudItems.find((item) => item.active) ||
            this.realDesktopGestureHudItems[0];
    }

    public get realDesktopGestureHudPrimaryLabel(): string {
        return this.realDesktopGestureHudPrimaryItem?.label || 'Paused';
    }

    public get realDesktopGestureHudReason(): string {
        return this.realDesktopGestureHudPrimaryItem?.help || 'Real Desktop gesture state is idle.';
    }

    public get realDesktopEnableHoldPercent(): number {
        return Math.round(this.clamp(this.realDesktopEnableHoldProgress, 0, 100));
    }

    public get realDesktopEnableHoldLabel(): string {
        if (this.realDesktopEnableHoldCompleting) return 'Safety 확인 완료';
        if (!this.realDesktopEnableHoldActive) return 'Hold 1s';
        return `Hold ${this.realDesktopEnableHoldPercent}%`;
    }

    public get realDesktopEnableHoldProgressStyle(): Record<string, string> {
        return {
            width: `${this.realDesktopEnableHoldPercent}%`
        };
    }

    public get realDesktopPauseHoldPercent(): number {
        return Math.round(this.clamp(this.realDesktopPauseHoldProgress, 0, 100));
    }

    public get realDesktopPauseHoldLabel(): string {
        if (!this.realDesktopPauseHoldActive) return this.realDesktopPaused ? 'Resume Hold' : 'Pause Hold';
        return `${this.realDesktopPaused ? 'Resume' : 'Pause'} ${this.realDesktopPauseHoldPercent}%`;
    }

    public get realDesktopPauseHoldProgressStyle(): Record<string, string> {
        return {
            width: `${this.realDesktopPauseHoldPercent}%`
        };
    }

    public get realDesktopHasDetectedHand(): boolean {
        return this.handStatus.includes('개 손 감지됨');
    }

    public get isRealDesktopPinchReady(): boolean {
        return this.realDesktopPinchReadyByHand.some((ready) => ready);
    }

    public get isRealDesktopNoHand(): boolean {
        if (this.activeMode !== 'realDesktop') return false;
        if (this.handStatus === '손 감지 안 됨' || this.handStatus === '손 감지 대기') return true;
        return this.realDesktopEnabled && !this.realDesktopHasDetectedHand;
    }

    public get isRealDesktopPaused(): boolean {
        if (this.activeMode !== 'realDesktop') return false;
        if (this.realDesktopVisibilityNotice) return true;
        if (this.realDesktopPaused) return true;
        if (this.realDesktopEnabled) return false;
        return this.realDesktopState === 'disabled' ||
            this.realDesktopState === 'stopped' ||
            this.realDesktopState === 'ready';
    }

    public get isRealDesktopControllerDisconnected(): boolean {
        if (this.activeMode !== 'realDesktop') return false;
        if (this.realDesktopState === 'error' || this.realDesktopState === 'permission') return true;
        return this.realDesktopEnabled && !this.realDesktopScreen;
    }

    public get isRealDesktopDoubleTapCandidate(): boolean {
        if (this.realDesktopClickMode !== 'doubleTap' || !this.realDesktopEnabled || this.realDesktopTap.lastTapAt <= 0) return false;
        return performance.now() - this.realDesktopTap.lastTapAt <= this.realDesktopDoubleTapMaxInterval;
    }

    public get isRealDesktopPinchClickCandidate(): boolean {
        return this.realDesktopClickMode === 'pinchClick' &&
            this.realDesktopPinchClick.trackId !== null &&
            !this.realDesktopPinchClick.blocked &&
            !this.realDesktopMouseDown;
    }

    public get isRealDesktopDwellClickActive(): boolean {
        return this.realDesktopClickMode === 'dwellClick' &&
            this.realDesktopDwellClickProgress > 0 &&
            this.realDesktopDwellClick.trackId !== null;
    }

    public get realDesktopDwellClickPercent(): number {
        return Math.round(this.clamp(this.realDesktopDwellClickProgress, 0, 100));
    }

    public get canEnterSingleMonitorMode(): boolean {
        return this.activeMode === 'realDesktop' && this.realDesktopEnabled && !this.isLoading;
    }

    public get realDesktopSingleMonitorButtonLabel(): string {
        return this.realDesktopSingleMonitorMode ? 'Compact ON' : 'Single Monitor Mode';
    }

    public get realDesktopSingleMonitorNotice(): string {
        if (this.realDesktopCalibrationActive) {
            return `${this.realDesktopCalibrationProgressLabel} 지점 보정 중입니다. 손 커서를 맞춘 뒤 Enter 또는 Space로 캡처하세요.`;
        }
        if (this.realDesktopEnableHoldActive) return this.realDesktopEnableHoldMessage;
        if (this.realDesktopPauseHoldActive) return this.realDesktopPauseHoldMessage;
        if (this.realDesktopPaused) {
            return 'Paused 상태입니다. 열린 손바닥을 0.8초 유지하거나 Resume 버튼을 눌러 다시 마우스 제어를 시작하세요.';
        }
        return this.realDesktopVisibilityNotice ||
            'Wandless 패널은 최소화하지 말고 작은 패널 또는 popup으로 화면 한쪽에 보이게 유지하세요. 브라우저가 hidden/백그라운드가 되면 손 인식과 localhost 전송이 지연될 수 있습니다.';
    }

    public get realDesktopTargetModeLabel(): string {
        return this.realDesktopTargetModeOptions.find((option) => option.id === this.realDesktopTargetSettings.mode)?.label || 'Full Screen';
    }

    public get realDesktopTargetRegionLabel(): string {
        const region = this.getRealDesktopActiveTargetRegion();
        return region ? this.formatRealDesktopRegion(region) : 'controller pending';
    }

    public get realDesktopTargetSummary(): string {
        return `${this.realDesktopTargetModeLabel} · ${this.realDesktopTargetRegionLabel}`;
    }

    public get realDesktopTargetNotice(): string {
        if (this.realDesktopTargetSettings.mode === 'current') {
            return '브라우저 창이 있는 모니터 영역으로 좌표를 제한합니다. 다중 모니터에서 popup을 목표 모니터에 두고 사용하세요.';
        }
        if (this.realDesktopTargetSettings.mode === 'custom') {
            return 'Windows virtual screen의 음수 origin과 macOS display bounds를 포함한 절대 screen 좌표를 입력하세요.';
        }
        return '컨트롤러가 보고한 전체 virtual screen bounds에 손 좌표를 매핑합니다.';
    }

    public get realDesktopPointerSettingsSummary(): string {
        return `S ${this.realDesktopSensitivityLabel} · DZ ${this.realDesktopDeadZoneLabel} · SM ${this.realDesktopSmoothingLabel}`;
    }

    public get realDesktopClickModeLabel(): string {
        return this.realDesktopClickModeOptions.find((option) => option.id === this.realDesktopClickMode)?.label || 'Double Tap';
    }

    public get realDesktopClickModeSummary(): string {
        return this.realDesktopClickModeLabel;
    }

    public get realDesktopClickModeHudText(): string {
        return `Click Mode: ${this.realDesktopClickModeLabel}`;
    }

    public get realDesktopClickModeHelp(): string {
        if (this.realDesktopClickMode === 'pinchClick') {
            return '짧은 pinch는 클릭, 길게 유지한 pinch는 drag arm으로 분리합니다.';
        }
        if (this.realDesktopClickMode === 'dwellClick') {
            return '커서가 같은 위치에 머물면 클릭하고, 클릭 후에는 움직여야 다시 클릭됩니다.';
        }
        return '기존 방식처럼 가까운 위치에서 검지 tap 두 번을 더블클릭으로 전송합니다.';
    }

    public get realDesktopSensitivityLabel(): string {
        return `${this.realDesktopPointerSettings.sensitivity.toFixed(2)}x`;
    }

    public get realDesktopDeadZoneLabel(): string {
        return `${Math.round(this.realDesktopPointerSettings.deadZone)}px`;
    }

    public get realDesktopSmoothingLabel(): string {
        return `${Math.round(this.realDesktopPointerSettings.smoothing)}%`;
    }

    public get canStartRealDesktopCalibration(): boolean {
        return this.activeMode === 'realDesktop' &&
            this.realDesktopEnabled &&
            !this.realDesktopPaused &&
            !!this.realDesktopScreen &&
            !this.isLoading &&
            !this.realDesktopCalibrationActive;
    }

    public get canCaptureRealDesktopCalibration(): boolean {
        return this.realDesktopCalibrationActive && !!this.realDesktopCalibrationCurrentObservedPoint;
    }

    public get canResetRealDesktopCalibration(): boolean {
        return this.realDesktopCalibrationActive || !!this.realDesktopCalibration;
    }

    public get realDesktopCalibrationSaved(): boolean {
        return !!this.realDesktopCalibration;
    }

    public get realDesktopCalibrationSummary(): string {
        if (this.realDesktopCalibrationActive) {
            return `${this.realDesktopCalibrationStepIndex + 1}/${this.realDesktopCalibrationTargets.length} · ${this.realDesktopCalibrationCurrentTargetLabel}`;
        }
        return this.realDesktopCalibration ? '저장됨' : '보정 없음';
    }

    public get realDesktopCalibrationHelp(): string {
        if (this.realDesktopCalibrationActive) {
            return `${this.realDesktopCalibrationCurrentTargetLabel} 지점에 손 커서를 맞춘 뒤 Capture 또는 Enter/Space를 누르세요.`;
        }
        if (this.realDesktopCalibration) {
            return '저장된 보정값이 현재 브라우저에 적용 중입니다. 화면 배치나 카메라 위치가 바뀌면 다시 보정하세요.';
        }
        return 'Enable 후 Start를 눌러 좌상단, 우상단, 좌하단, 우하단, 중앙 순서로 보정하세요.';
    }

    public get realDesktopCalibrationProgressLabel(): string {
        return this.realDesktopCalibrationCurrentTargetLabel;
    }

    public get realDesktopCalibrationCurrentTargetLabel(): string {
        return this.getCurrentRealDesktopCalibrationTarget()?.label || '보정';
    }

    public get realDesktopControllerPlatformLabel(): string {
        return this.realDesktopControllerPlatform === 'windows' ? 'Windows' : 'macOS';
    }

    public get realDesktopControllerDisplayUrl(): string {
        return `사용자 컴퓨터 로컬 · ${this.realDesktopControllerUrl}`;
    }

    public get realDesktopControllerScriptPath(): string {
        return this.realDesktopControllerPlatform === 'windows'
            ? this.realDesktopWindowsControllerScriptPath
            : this.realDesktopMacControllerScriptPath;
    }

    public get realDesktopControllerCommandTitle(): string {
        return this.realDesktopControllerPlatform === 'windows'
            ? 'Windows PowerShell에 붙여넣을 명령'
            : 'macOS Terminal에 붙여넣을 명령';
    }

    public get realDesktopControllerCommandHelp(): string {
        if (this.realDesktopControllerPlatform === 'windows') {
            return '터미널 명령은 Windows 컨트롤러 파일을 내려받고, 현재 로그인한 Windows 데스크톱 세션에서 마우스와 Virtual Desktop 전환 컨트롤러를 실행합니다.';
        }
        return '터미널 명령은 macOS 컨트롤러 파일을 내려받고, 필요한 Python 패키지를 설치한 뒤, Mac에서 마우스와 Space 전환 컨트롤러를 실행합니다.';
    }

    public get realDesktopAccessNote(): string {
        if (this.realDesktopControllerPlatform === 'windows') {
            return 'Windows 컨트롤러는 현재 로그인한 데스크톱 세션에서 실행되어야 합니다. 단일 모니터는 Wandless와 대상 앱을 서로 다른 Virtual Desktop에 두고 전환 버튼을 사용하세요.';
        }
        return 'macOS Accessibility 권한이 필요합니다. 단일 모니터는 Wandless와 대상 앱을 서로 다른 Space에 두고 전환 버튼을 사용하세요.';
    }

    public get realDesktopSetupSteps(): string[] {
        if (this.realDesktopControllerPlatform === 'windows') {
            return [
                'Real Desktop 패널에서 Windows를 선택하고 터미널 명령 복사를 누릅니다.',
                'Windows PowerShell을 열고 붙여넣은 뒤 Enter를 누릅니다.',
                'Python 실행 권한이나 방화벽 확인 창이 뜨면 로컬 실행을 허용합니다.',
                'PowerShell 창을 켜 둔 상태로 Wandless에 돌아와 Enable을 다시 누릅니다.',
                '단일 모니터라면 대상 앱을 옆 Virtual Desktop에 두고 이전/다음 버튼으로 전환합니다.'
            ];
        }

        return [
            'Real Desktop 패널에서 macOS를 선택하고 터미널 명령 복사를 누릅니다.',
            'Mac의 Terminal 앱을 열고 붙여넣은 뒤 Enter를 누릅니다.',
            '권한 창이 뜨면 시스템 설정의 손쉬운 사용에서 Terminal 또는 Python을 허용합니다.',
            '터미널 창을 켜 둔 상태로 Wandless에 돌아와 Enable을 다시 누릅니다.',
            '단일 모니터라면 대상 앱을 옆 Space에 두고 이전/다음 버튼으로 전환합니다.'
        ];
    }

    public get realDesktopSafetyNotes(): string[] {
        if (this.realDesktopControllerPlatform === 'windows') {
            return [
                'Enable 전에 오른쪽 패널의 명령을 Windows PowerShell에서 실행',
                'Enable은 버튼을 1초간 누르거나 열린 손바닥을 유지해야 활성화',
                '127.0.0.1은 Wandless 서버가 아니라 현재 Windows PC의 컨트롤러',
                '듀얼 모니터는 전체 가상 화면 좌표를 사용',
                '키보드는 Virtual Desktop 전환 고정 단축키만 사용하고, 임의 키 입력은 보내지 않음'
            ];
        }

        return [
            'macOS 시스템 설정 > 개인정보 보호 및 보안 > 손쉬운 사용에서 Terminal 또는 Python을 허용',
            'Enable 전에 오른쪽 패널의 명령을 Mac 터미널에서 실행',
            'Enable은 버튼을 1초간 누르거나 열린 손바닥을 유지해야 활성화',
            '127.0.0.1은 Wandless 서버가 아니라 현재 Mac의 컨트롤러',
            '듀얼 모니터는 전체 활성 디스플레이 좌표를 사용',
            '키보드는 Space 전환 고정 단축키만 사용하고, 임의 키 입력은 보내지 않음'
        ];
    }

    public get realDesktopControllerInstallCommand(): string {
        const origin = typeof window === 'undefined' || !window.location?.origin
            ? 'https://wandless.seasonai.net'
            : window.location.origin;
        if (this.realDesktopControllerPlatform === 'windows') {
            return [
                '$dir = "$env:USERPROFILE\\wandless-controller"',
                'New-Item -ItemType Directory -Force $dir | Out-Null',
                'Set-Location $dir',
                `Invoke-WebRequest -UseBasicParsing "${origin}${this.realDesktopWindowsControllerScriptPath}" -OutFile "windows_controller.py"`,
                'py -3 windows_controller.py'
            ].join('; ');
        }

        return [
            'mkdir -p ~/wandless-controller',
            'cd ~/wandless-controller',
            `curl -fsSL ${origin}${this.realDesktopMacControllerScriptPath} -o macos_controller.py`,
            `curl -fsSL ${origin}${this.realDesktopMacControllerRequirementsPath} -o requirements.txt`,
            'python3 -m venv .venv',
            '. .venv/bin/activate',
            'python -m pip install -r requirements.txt',
            'python macos_controller.py --prompt-accessibility'
        ].join(' && ');
    }

    public async setMode(mode: WandlessMode) {
        if (this.activeMode === mode) return;

        if (this.activeMode === 'realDesktop') {
            await this.stopRealDesktopControl('모드 전환으로 제어 중지');
        }

        this.resetModeEffects();
        this.activeMode = mode;
        if (mode === 'realDesktop') {
            this.resetRealDesktopControlState('오른쪽 패널에서 OS를 선택하고 터미널 명령을 실행한 뒤 Enable을 누르세요.');
        } else {
            this.resetRealDesktopGestureState();
        }
        this.gestureStatus = 'inactive';
        this.spellStatus = mode === 'realDesktop' ? this.realDesktopStatus : 'idle';
        this.clearCanvas();
        await this.service.render();
    }

    public async setRealDesktopControllerPlatform(platform: RealDesktopControllerPlatform) {
        if (this.realDesktopControllerPlatform === platform) return;

        if (this.realDesktopEnabled || this.realDesktopMouseDown) {
            await this.stopRealDesktopControl('컨트롤러 OS 변경으로 제어 중지');
        }

        this.realDesktopControllerPlatform = platform;
        this.resetRealDesktopControlState(`${this.realDesktopControllerPlatformLabel}용 터미널 명령을 실행한 뒤 Enable을 누르세요.`);
        await this.service.render();
    }

    public async start() {
        if (!this.hasCameraApi()) {
            this.setFailure('이 브라우저는 카메라 API를 지원하지 않습니다.');
            return;
        }

        this.errorMessage = '';
        this.isLoading = true;
        this.cameraStatus = '권한 요청 중';
        this.modelStatus = this.handLandmarker ? '준비됨' : '대기';
        this.handStatus = '대기';
        this.gestureStatus = 'inactive';
        this.spellStatus = this.activeMode === 'realDesktop' ? this.realDesktopStatus : 'idle';
        await this.service.render();

        let permissionStream: MediaStream | null = null;

        try {
            permissionStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            this.hasPermission = true;
            this.cameraStatus = '카메라 확인 중';
            await this.refreshCameras(true);

            if (this.cameras.length === 0) {
                throw new Error('NO_CAMERA');
            }

            if (!this.selectedDeviceId || !this.cameras.some((camera) => camera.deviceId === this.selectedDeviceId)) {
                this.selectedDeviceId = this.pickPreferredCamera();
            }

            this.stopMediaStream(permissionStream);
            permissionStream = null;

            this.modelStatus = this.handLandmarker ? '준비됨' : '손 인식 준비 중';
            await this.service.render();
            await this.loadHandLandmarker();

            this.cameraStatus = '연결 중';
            await this.openCamera(this.selectedDeviceId);

            this.isRunning = true;
            this.handStatus = '손 감지 대기';
            this.gestureStatus = 'inactive';
            this.spellStatus = this.activeMode === 'realDesktop' ? this.realDesktopStatus : 'idle';
            this.startTracking();
        } catch (error) {
            this.stopMediaStream(permissionStream);
            this.stopTracking();
            this.stopActiveStream();
            this.isRunning = false;
            this.handleStartError(error);
        } finally {
            this.isLoading = false;
            await this.service.render();
        }
    }

    public async stop() {
        await this.stopRealDesktopControl('Stop 버튼 비상 정지');
        this.stopTracking();
        this.stopActiveStream();
        this.particles = [];
        this.aimParticles = [];
        this.aimActiveByHand = [];
        this.aimEffectsByHand = [];
        this.energyParticles = [];
        this.energyProjectiles = [];
        this.resetPortalState();
        this.resetOrbCompressState();
        this.resetDesktopPracticeState();
        this.pinchActiveByHand = [];
        this.resetFistState();
        this.handTracks = [];
        this.gestureArbiter.reset();
        this.clearCanvas();
        this.isRunning = false;
        this.cameraStatus = this.hasPermission ? '정지' : '대기';
        this.handStatus = '대기';
        this.gestureStatus = 'inactive';
        this.spellStatus = this.activeMode === 'realDesktop' ? this.realDesktopStatus : 'idle';
        await this.service.render();
    }

    public async onCameraChange() {
        if (!this.selectedDeviceId || !this.isRunning) return;

        await this.stopRealDesktopControl('카메라 전환으로 제어 중지');
        this.errorMessage = '';
        this.isLoading = true;
        this.cameraStatus = '카메라 전환 중';
        await this.service.render();

        try {
            this.stopTracking();
            this.resetAimState();
            this.resetFistState();
            this.resetPortalState();
            this.resetOrbCompressState();
            this.resetDesktopPracticeState();
            this.gestureArbiter.reset();
            await this.openCamera(this.selectedDeviceId);
            this.handStatus = '손 감지 대기';
            this.gestureStatus = 'inactive';
            this.spellStatus = this.activeMode === 'realDesktop' ? this.realDesktopStatus : 'idle';
            this.startTracking();
        } catch (error) {
            this.stopTracking();
            this.stopActiveStream();
            this.isRunning = false;
            this.handleStartError(error);
        } finally {
            this.isLoading = false;
            await this.service.render();
        }
    }

    public async refreshCameras(showError: boolean = true) {
        if (!this.hasCameraApi()) {
            if (showError) this.setFailure('이 브라우저는 카메라 목록을 읽을 수 없습니다.');
            return;
        }

        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const videoInputs = devices.filter((device) => device.kind === 'videoinput');
            this.cameras = videoInputs.map((device, index) => {
                const label = device.label || `카메라 ${index + 1}`;
                return {
                    deviceId: device.deviceId,
                    label,
                    isLogitech: /logitech|logi/i.test(label),
                    index: index + 1
                };
            });

            if (this.selectedDeviceId && !this.cameras.some((camera) => camera.deviceId === this.selectedDeviceId)) {
                this.selectedDeviceId = '';
            }

            if (!this.selectedDeviceId && this.cameras.length > 0) {
                this.selectedDeviceId = this.pickPreferredCamera();
            }

            if (this.cameras.length === 0 && showError) {
                this.setFailure('사용 가능한 카메라가 없습니다. USB 연결 상태를 확인해주세요.');
            }
        } catch (error) {
            if (showError) this.setFailure('카메라 목록을 읽지 못했습니다. 브라우저 권한을 확인해주세요.');
        }
    }

    public async refreshRealDesktopControllerStatus(showError: boolean = true, promptForPermission: boolean = false): Promise<boolean> {
        this.setRealDesktopStatus('connecting', '로컬 컨트롤러 확인 중');
        await this.service.render();

        try {
            const suffix = promptForPermission ? '/status?prompt=1' : '/status';
            const response = await fetch(this.getRealDesktopControllerEndpoint(suffix), {
                method: 'GET',
                cache: 'no-store',
                mode: 'cors'
            });
            const status = await response.json() as RealDesktopControllerStatus;
            if (!response.ok || status.ok === false) {
                throw new Error(status.error || status.message || `HTTP_${response.status}`);
            }

            this.applyRealDesktopControllerStatus(status);

            if (status.accessibility?.trusted === false) {
                this.realDesktopEnabled = false;
                this.setRealDesktopStatus(
                    'permission',
                    'macOS 시스템 설정 > 개인정보 보호 및 보안 > 손쉬운 사용에서 Terminal 또는 Python을 허용하세요.'
                );
                await this.service.render();
                return false;
            }

            this.setRealDesktopStatus(
                this.realDesktopEnabled ? 'ready' : 'disabled',
                '로컬 컨트롤러 연결됨. Enable을 1초간 hold하면 실제 마우스 제어를 시작합니다.'
            );
            await this.service.render();
            return true;
        } catch (error) {
            if (showError) {
                this.realDesktopEnabled = false;
                this.setRealDesktopStatus(
                    'error',
                    '아래 선택한 OS용 터미널 명령을 실행한 뒤 Enable을 다시 누르세요.'
                );
                await this.service.render();
            }
            return false;
        }
    }

    public async copyRealDesktopInstallCommand() {
        try {
            if (!navigator.clipboard?.writeText) {
                throw new Error('Clipboard API unavailable');
            }
            await navigator.clipboard.writeText(this.realDesktopControllerInstallCommand);
            this.setRealDesktopStatus(
                this.realDesktopState,
                `터미널 명령을 복사했습니다. ${this.realDesktopControllerPlatformLabel}에서 실행하세요.`
            );
        } catch (error) {
            this.setRealDesktopStatus(
                this.realDesktopState,
                `복사가 막혔습니다. 아래 터미널 명령을 직접 복사해 ${this.realDesktopControllerPlatformLabel}에서 실행하세요.`
            );
        }
        await this.service.render();
    }

    public async startRealDesktopCalibration() {
        if (!this.canStartRealDesktopCalibration) {
            this.setRealDesktopStatus(
                this.realDesktopState,
                'Calibration은 Real Desktop Enable 후 로컬 컨트롤러 화면 bounds가 확인된 상태에서 시작할 수 있습니다.'
            );
            await this.service.render();
            return;
        }

        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse('Calibration Mode 시작으로 mouse up');
        }

        this.clearPendingRealDesktopMove();
        this.resetRealDesktopGestureState();
        this.realDesktopCalibrationActive = true;
        this.realDesktopCalibrationDraft = [];
        this.realDesktopCalibrationStepIndex = 0;
        this.realDesktopCalibrationCurrentObservedPoint = null;
        this.setRealDesktopStatus('ready', `${this.realDesktopCalibrationCurrentTargetLabel} 지점 보정 중`);
        this.gestureStatus = 'calibration';
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async captureRealDesktopCalibrationPoint() {
        if (!this.realDesktopCalibrationActive) return;

        const target = this.getCurrentRealDesktopCalibrationTarget();
        const observed = this.realDesktopCalibrationCurrentObservedPoint;
        if (!target || !observed) {
            this.setRealDesktopStatus('ready', '손 커서가 인식된 뒤 보정 지점을 캡처할 수 있습니다.');
            await this.service.render();
            return;
        }

        const sample: RealDesktopCalibrationSample = {
            id: target.id,
            observed: {
                x: this.clamp(observed.x, 0, 1),
                y: this.clamp(observed.y, 0, 1)
            },
            target: { ...target.target },
            capturedAt: Date.now()
        };
        this.realDesktopCalibrationDraft[this.realDesktopCalibrationStepIndex] = sample;

        if (this.realDesktopCalibrationStepIndex < this.realDesktopCalibrationTargets.length - 1) {
            this.realDesktopCalibrationStepIndex += 1;
            this.setRealDesktopStatus('ready', `${this.realDesktopCalibrationCurrentTargetLabel} 지점 보정 중`);
            await this.service.render();
            return;
        }

        const samples = this.realDesktopCalibrationDraft.slice(0, this.realDesktopCalibrationTargets.length);
        const transform = this.computeRealDesktopCalibrationTransform(samples);
        if (!transform) {
            this.realDesktopCalibrationDraft = [];
            this.realDesktopCalibrationStepIndex = 0;
            this.setRealDesktopStatus('error', '보정값을 계산하지 못했습니다. 손 위치를 더 넓게 맞춰 다시 캡처하세요.');
            await this.service.render();
            return;
        }

        this.realDesktopCalibration = {
            version: 1,
            createdAt: Date.now(),
            screen: this.realDesktopScreen ? { ...this.realDesktopScreen } : null,
            samples,
            transform
        };
        this.saveRealDesktopCalibration();
        this.clearRealDesktopCalibrationSession();
        this.resetRealDesktopGestureState();
        this.setRealDesktopStatus('ready', 'Calibration 저장됨. 이후 Real Desktop 좌표에 보정값을 적용합니다.');
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async cancelRealDesktopCalibration() {
        if (!this.realDesktopCalibrationActive) return;

        this.clearRealDesktopCalibrationSession();
        this.resetRealDesktopGestureState();
        this.setRealDesktopStatus(this.realDesktopEnabled ? 'ready' : this.realDesktopState, 'Calibration Mode를 취소했습니다.');
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async resetRealDesktopCalibration() {
        this.realDesktopCalibration = null;
        this.clearRealDesktopCalibrationSession();
        this.removeStoredRealDesktopCalibration();
        this.resetRealDesktopGestureState();
        this.setRealDesktopStatus(this.realDesktopEnabled ? 'ready' : this.realDesktopState, 'Calibration을 초기화했습니다.');
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public onRealDesktopPointerSettingsChange() {
        this.realDesktopPointerSettings = this.normalizeRealDesktopPointerSettings(this.realDesktopPointerSettings);
        this.anchorRealDesktopPointerSettingsToNextSample();
        this.saveRealDesktopPointerSettings();
    }

    public async setRealDesktopTargetMode(mode: RealDesktopTargetMode) {
        if (!this.realDesktopTargetModeOptions.some((option) => option.id === mode)) return;
        if (this.realDesktopTargetSettings.mode === mode) return;

        this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings({
            ...this.realDesktopTargetSettings,
            mode
        });
        this.ensureRealDesktopTargetCustomRegion(this.realDesktopScreen);
        this.applyRealDesktopTargetSettingsChange('Target Mode 변경으로 mouse up');
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            `${this.realDesktopTargetModeLabel}으로 손 좌표 target을 변경했습니다.`
        );
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public onRealDesktopTargetSettingsChange() {
        this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings(this.realDesktopTargetSettings);
        this.ensureRealDesktopTargetCustomRegion(this.realDesktopScreen);
        this.applyRealDesktopTargetSettingsChange('Target Region 변경으로 mouse up');
    }

    public async resetRealDesktopTargetSettings() {
        this.realDesktopTargetSettings = {
            mode: this.realDesktopTargetSettingsDefaults.mode,
            custom: this.realDesktopScreen
                ? { ...this.realDesktopScreen }
                : { ...this.realDesktopTargetSettingsDefaults.custom }
        };
        this.ensureRealDesktopTargetCustomRegion(this.realDesktopScreen);
        this.applyRealDesktopTargetSettingsChange('Target Mode 초기화로 mouse up');
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            'Target Mode를 Full Screen으로 초기화했습니다.'
        );
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async applyRealDesktopCustomRegionPreset(preset: 'full' | 'left' | 'right' | 'center') {
        const screen = this.realDesktopScreen;
        if (!screen || screen.width <= 0 || screen.height <= 0) return;

        const halfWidth = Math.max(1, Math.round(screen.width / 2));
        const halfHeight = Math.max(1, Math.round(screen.height / 2));
        let region: RealDesktopScreen;

        if (preset === 'left') {
            region = { x: screen.x, y: screen.y, width: halfWidth, height: screen.height };
        } else if (preset === 'right') {
            region = { x: screen.x + screen.width - halfWidth, y: screen.y, width: halfWidth, height: screen.height };
        } else if (preset === 'center') {
            region = {
                x: screen.x + Math.round((screen.width - halfWidth) / 2),
                y: screen.y + Math.round((screen.height - halfHeight) / 2),
                width: halfWidth,
                height: halfHeight
            };
        } else {
            region = { ...screen };
        }

        this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings({
            mode: 'custom',
            custom: this.constrainRealDesktopTargetRegion(region, screen)
        });
        this.applyRealDesktopTargetSettingsChange('Target Region preset 변경으로 mouse up');
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            `Custom Region preset을 ${preset}로 적용했습니다.`
        );
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async setRealDesktopClickMode(mode: RealDesktopClickMode) {
        if (!this.realDesktopClickModeOptions.some((option) => option.id === mode)) return;
        if (this.realDesktopClickMode === mode) return;

        this.clearPendingRealDesktopMove();
        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse('Click Mode 변경으로 mouse up');
        }

        this.realDesktopClickMode = mode;
        this.resetRealDesktopClickGestureState(false);
        this.saveRealDesktopClickMode();
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            `${this.realDesktopClickModeLabel} 모드로 변경했습니다.`
        );
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async resetRealDesktopPointerSettings() {
        this.realDesktopPointerSettings = { ...this.realDesktopPointerSettingsDefaults };
        this.anchorRealDesktopPointerSettingsToNextSample();
        this.saveRealDesktopPointerSettings();
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            'Sensitivity, Dead Zone, Smoothing을 기본값으로 초기화했습니다.'
        );
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public isRealDesktopCalibrationPointCaptured(index: number): boolean {
        return index < this.realDesktopCalibrationDraft.length &&
            !!this.realDesktopCalibrationDraft[index];
    }

    public async toggleRealDesktopSingleMonitorMode() {
        if (this.activeMode !== 'realDesktop') return;

        this.setRealDesktopSingleMonitorMode(
            !this.realDesktopSingleMonitorMode,
            'Single Monitor Mode 전환으로 mouse up'
        );
        this.setRealDesktopStatus(
            this.realDesktopEnabled ? 'ready' : this.realDesktopState,
            this.realDesktopSingleMonitorMode
                ? 'Single Monitor Mode 활성화. 작은 패널을 보이게 둔 상태에서 ESC 또는 Stop으로 해제하세요.'
                : 'Single Monitor Mode 해제.'
        );
        await this.service.render();
        window.setTimeout(() => this.resizeCanvas(), 0);
    }

    public async openRealDesktopCompactWindow() {
        let compactWindow: Window | null = null;

        try {
            const url = new URL(window.location.href);
            url.searchParams.set('wandlessCompact', '1');
            compactWindow = window.open(
                url.toString(),
                'wandless-real-desktop-compact',
                'popup=yes,width=360,height=520,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=no'
            );
        } catch (error) {
            this.setRealDesktopStatus(
                this.realDesktopState,
                'Popup을 열 수 없습니다. 현재 브라우저 창을 줄이고 Single Monitor Mode를 사용하세요.'
            );
            await this.service.render();
            return;
        }

        if (!compactWindow) {
            this.setRealDesktopStatus(
                this.realDesktopState,
                'Popup이 브라우저에 의해 차단되었습니다. 현재 창을 줄이고 Single Monitor Mode를 사용하세요.'
            );
            await this.service.render();
            return;
        }

        compactWindow.focus();
        if (this.realDesktopEnabled) {
            await this.stopRealDesktopControl('Compact popup 열기 전 기존 제어 중지');
        }

        this.setRealDesktopStatus(
            this.realDesktopState,
            'Compact popup을 열었습니다. 작은 창 안에서 Real Desktop을 Enable하세요.'
        );
        await this.service.render();
    }

    public beginRealDesktopEnableButtonHold(event?: Event) {
        event?.preventDefault();

        if (!this.canEnableRealDesktopControl) return;
        this.startRealDesktopEnableHold('button');
    }

    public cancelRealDesktopEnableButtonHold(event?: Event) {
        event?.preventDefault();

        if (this.realDesktopEnableHoldSource !== 'button') return;
        this.cancelRealDesktopEnableHold('Enable 버튼을 놓아 안전 확인을 취소했습니다.');
    }

    public handleRealDesktopEnableButtonKeydown(event: KeyboardEvent) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.code !== 'Space') return;
        this.beginRealDesktopEnableButtonHold(event);
    }

    public handleRealDesktopEnableButtonKeyup(event: KeyboardEvent) {
        if (event.key !== 'Enter' && event.key !== ' ' && event.code !== 'Space') return;
        this.cancelRealDesktopEnableButtonHold(event);
    }

    public async enableRealDesktopControl() {
        this.beginRealDesktopEnableButtonHold();
    }

    public async resumeRealDesktopControl(reason: string = 'Resume 버튼으로 재개') {
        if (!this.realDesktopEnabled || !this.realDesktopPaused) return;

        this.realDesktopPauseGestureReleaseRequired = false;
        this.resetRealDesktopPauseHold();
        this.resumeRealDesktopMouseControl(reason);
        if (!this.destroyed) await this.service.render();
    }

    private async activateRealDesktopControlAfterHold() {
        if (this.activeMode !== 'realDesktop') {
            await this.setMode('realDesktop');
        }

        this.errorMessage = '';
        this.realDesktopEnableHoldCompleting = true;
        this.setRealDesktopStatus('connecting', '안전 확인 완료. 로컬 컨트롤러 확인 중입니다.');
        await this.service.render();

        const controllerReady = await this.refreshRealDesktopControllerStatus(true, true);
        if (!controllerReady) {
            this.resetRealDesktopEnableHold();
            return;
        }

        if (!this.isRunning) {
            await this.start();
        }

        if (!this.isRunning) {
            this.realDesktopEnabled = false;
            this.resetRealDesktopEnableHold();
            this.setRealDesktopStatus('error', '카메라와 손 인식이 시작되어야 실제 제어를 켤 수 있습니다.');
            await this.service.render();
            return;
        }

        this.clearPendingRealDesktopMove();
        this.realDesktopEnabled = true;
        this.realDesktopPaused = false;
        this.resetRealDesktopPauseHold();
        this.resetRealDesktopEnableHold();
        this.resetRealDesktopGestureState();
        this.setRealDesktopStatus('ready', '안전 확인 완료. 검지로 이동하고 pinch를 짧게 유지하면 드래그합니다.');
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
        await this.service.render();
    }

    public async stopRealDesktopControl(reason: string = 'Stop 버튼 비상 정지') {
        const shouldNotifyController = this.activeMode === 'realDesktop' ||
            this.realDesktopEnabled ||
            this.realDesktopMouseDown ||
            this.realDesktopState === 'dragging';

        this.cancelRealDesktopEnableHold(reason, false);
        this.clearPendingRealDesktopMove();
        if (shouldNotifyController) {
            this.queueRealDesktopCommand({
                type: 'stop',
                x: this.realDesktopLastScreenPoint?.x,
                y: this.realDesktopLastScreenPoint?.y,
                reason
            }, true);
        }

        this.realDesktopEnabled = false;
        this.realDesktopPaused = false;
        this.clearRealDesktopCalibrationSession();
        this.resetRealDesktopGestureState();
        this.setRealDesktopSingleMonitorMode(this.realDesktopCompactWindowMode && this.activeMode === 'realDesktop', reason);
        this.setRealDesktopStatus('stopped', reason);

        if (this.activeMode === 'realDesktop') {
            this.gestureStatus = 'inactive';
            this.spellStatus = this.realDesktopStatus;
            if (!this.destroyed) await this.service.render();
        }
    }

    private startRealDesktopEnableHold(source: RealDesktopEnableHoldSource, hand?: HandFrame, point?: CanvasPoint, timestamp: number = performance.now()) {
        if (!this.canEnableRealDesktopControl) return;

        if (this.realDesktopEnableHoldActive && this.realDesktopEnableHoldSource === source) {
            return;
        }

        this.resetRealDesktopEnableHold();
        this.clearPendingRealDesktopMove();
        this.resetRealDesktopGestureState();
        this.realDesktopEnableHoldActive = true;
        this.realDesktopEnableHoldSource = source;
        this.realDesktopEnableHoldStartedAt = timestamp;
        this.realDesktopEnableHoldProgress = 0;
        this.realDesktopEnableHoldTrackId = hand?.trackId ?? null;
        this.realDesktopEnableHoldAnchor = point ? { ...point } : null;
        this.setRealDesktopStatus('connecting', this.getRealDesktopEnableHoldMessage(source));
        this.updateRealDesktopEnableHoldProgress(timestamp);

        if (source === 'button') {
            this.realDesktopEnableHoldTimer = window.setInterval(() => {
                this.updateRealDesktopEnableHoldProgress(performance.now());
            }, 50);
        }
    }

    private updateRealDesktopEnableHoldProgress(timestamp: number) {
        if (!this.realDesktopEnableHoldActive || this.realDesktopEnableHoldCompleting) return;

        const elapsed = Math.max(0, timestamp - this.realDesktopEnableHoldStartedAt);
        this.realDesktopEnableHoldProgress = this.clamp(elapsed / this.realDesktopEnableHoldDuration * 100, 0, 100);
        this.realDesktopEnableHoldMessage = this.getRealDesktopEnableHoldMessage(this.realDesktopEnableHoldSource);
        this.setRealDesktopStatus('connecting', this.realDesktopEnableHoldMessage);

        if (this.realDesktopEnableHoldProgress >= 100) {
            void this.completeRealDesktopEnableHold();
            return;
        }

        if (!this.destroyed) void this.service.render();
    }

    private async completeRealDesktopEnableHold() {
        if (!this.realDesktopEnableHoldActive || this.realDesktopEnableHoldCompleting) return;

        this.realDesktopEnableHoldProgress = 100;
        this.clearRealDesktopEnableHoldTimer();
        await this.activateRealDesktopControlAfterHold();
    }

    private cancelRealDesktopEnableHold(reason: string, render: boolean = true) {
        if (!this.realDesktopEnableHoldActive || this.realDesktopEnableHoldCompleting) return;

        this.resetRealDesktopEnableHold();
        this.resetRealDesktopGestureState();
        this.setRealDesktopStatus('disabled', reason);
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
        if (render && !this.destroyed) void this.service.render();
    }

    private resetRealDesktopEnableHold() {
        this.clearRealDesktopEnableHoldTimer();
        this.realDesktopEnableHoldActive = false;
        this.realDesktopEnableHoldProgress = 0;
        this.realDesktopEnableHoldMessage = 'Enable을 1초 동안 누르거나 열린 손바닥을 화면에 유지하세요.';
        this.realDesktopEnableHoldSource = null;
        this.realDesktopEnableHoldStartedAt = 0;
        this.realDesktopEnableHoldCompleting = false;
        this.realDesktopEnableHoldTrackId = null;
        this.realDesktopEnableHoldAnchor = null;
    }

    private clearRealDesktopEnableHoldTimer() {
        if (this.realDesktopEnableHoldTimer) {
            window.clearInterval(this.realDesktopEnableHoldTimer);
            this.realDesktopEnableHoldTimer = 0;
        }
    }

    private getRealDesktopEnableHoldMessage(source: RealDesktopEnableHoldSource | null): string {
        const remainingMs = Math.max(
            0,
            Math.ceil(this.realDesktopEnableHoldDuration * (1 - this.realDesktopEnableHoldProgress / 100))
        );
        const remainingLabel = (remainingMs / 1000).toFixed(1);

        if (source === 'gesture') {
            return `열린 손바닥 유지 중 ${this.realDesktopEnableHoldPercent}% · ${remainingLabel}s 남음`;
        }

        if (source === 'button') {
            return `Enable 버튼 hold 중 ${this.realDesktopEnableHoldPercent}% · ${remainingLabel}s 남음`;
        }

        return 'Enable을 1초 동안 누르거나 열린 손바닥을 화면에 유지하세요.';
    }

    private pauseRealDesktopMouseControl(reason: string) {
        this.clearPendingRealDesktopMove();
        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse(`${reason} 전 mouse up`);
        }

        this.realDesktopPaused = true;
        this.realDesktopPinchReadyByHand = [];
        this.realDesktopPinchActiveByHand = [];
        this.realDesktopActiveTrackId = null;
        this.realDesktopLastDragScreenPoint = null;
        this.resetRealDesktopPointerSettingsFilter();
        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(false);
        this.setRealDesktopStatus('paused', reason);
        this.gestureStatus = 'paused';
        this.spellStatus = this.realDesktopStatus;
    }

    private resumeRealDesktopMouseControl(reason: string) {
        this.clearPendingRealDesktopMove();
        this.realDesktopPaused = false;
        this.realDesktopPinchReadyByHand = [];
        this.realDesktopPinchActiveByHand = [];
        this.realDesktopActiveTrackId = null;
        this.realDesktopLastDragScreenPoint = null;
        this.resetRealDesktopPointerSettingsFilter();
        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(false);
        this.setRealDesktopStatus('ready', reason);
        this.gestureStatus = 'inactive';
        this.spellStatus = this.realDesktopStatus;
    }

    public async switchRealDesktopSpace(direction: RealDesktopSpaceDirection) {
        if (!this.canSwitchRealDesktopSpace) return;

        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse('데스크톱 전환 전 mouse up');
        }

        this.clearPendingRealDesktopMove();
        this.resetRealDesktopDragArming();
        this.queueRealDesktopCommand({
            type: direction === 'previous' ? 'space_previous' : 'space_next',
            reason: 'desktop switch'
        }, true);
        this.setRealDesktopStatus(
            'ready',
            direction === 'previous' ? '이전 데스크톱으로 전환했습니다.' : '다음 데스크톱으로 전환했습니다.'
        );
        await this.service.render();
    }

    public statusClass(value: string): string {
        if (/오류|거부|없음|실패|권한 필요|permission|error/.test(value)) return 'is-danger';
        if (/pinch|click|dwell|double tap|drag hold|index move|aim|fist|orb|compressing|charging|aiming|released|drawing|portalOpen|hover|dragging|moving|ready|calibration|감지됨|연결됨|준비됨|전환했습니다|보정/.test(value)) return 'is-live';
        if (/요청|확인|준비|전환|대기|연결 중|connecting/.test(value)) return 'is-waiting';
        return 'is-idle';
    }

    public isStatusActive(value: string): boolean {
        return this.statusClass(value) === 'is-live';
    }

    public ritualStatusValue(kind: string, value: string): string {
        const tone = this.statusClass(value);

        if (tone === 'is-danger') return '흐트러짐';

        if (tone === 'is-live') {
            if (kind === 'spell') return /released/.test(value) ? '잔향' : '발현';
            return '깨어남';
        }

        if (kind === 'gesture' || kind === 'spell') return '미발현';
        if (kind === 'hand' && /손 감지 안 됨|정지|inactive|idle/.test(value)) return '잠듦';

        return tone === 'is-waiting' ? '대기' : '잠듦';
    }

    public cameraOptionLabel(camera: CameraOption): string {
        const prefix = camera.isLogitech ? 'Logitech · ' : '';
        return `${prefix}${camera.label}`;
    }

    private hasCameraApi(): boolean {
        return !!navigator.mediaDevices?.getUserMedia && !!navigator.mediaDevices?.enumerateDevices;
    }

    private pickPreferredCamera(): string {
        const logitech = this.cameras.find((camera) => camera.isLogitech);
        return (logitech || this.cameras[0])?.deviceId || '';
    }

    private async loadHandLandmarker() {
        if (this.handLandmarker) {
            this.modelStatus = '준비됨';
            return;
        }

        try {
            const vision = await FilesetResolver.forVisionTasks('/assets/mediapipe/wasm');

            try {
                this.handLandmarker = await this.createHandLandmarker(vision, 'GPU');
            } catch (gpuError) {
                this.handLandmarker = await this.createHandLandmarker(vision, 'CPU');
            }

            this.modelStatus = '준비됨';
        } catch (error) {
            this.modelStatus = '오류';
            throw new Error('MODEL_LOAD_FAILED');
        }
    }

    private async createHandLandmarker(vision: any, delegate: 'GPU' | 'CPU'): Promise<HandLandmarker> {
        return await HandLandmarker.createFromOptions(vision, {
            baseOptions: {
                modelAssetPath: '/assets/mediapipe/hand_landmarker.task',
                delegate
            },
            runningMode: 'VIDEO',
            numHands: this.maxDetectedHands,
            minHandDetectionConfidence: 0.55,
            minHandPresenceConfidence: 0.55,
            minTrackingConfidence: 0.5
        });
    }

    private async openCamera(deviceId: string) {
        const video = this.videoElement?.nativeElement;
        if (!video) throw new Error('VIDEO_NOT_READY');

        this.stopActiveStream();

        const constraints: MediaStreamConstraints = {
            audio: false,
            video: {
                deviceId: deviceId ? { exact: deviceId } : undefined,
                width: { ideal: 1280 },
                height: { ideal: 720 },
                frameRate: { ideal: 30, max: 60 }
            }
        };

        this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        video.srcObject = this.stream;
        video.muted = true;
        video.playsInline = true;

        await new Promise<void>((resolve, reject) => {
            const timer = window.setTimeout(() => reject(new Error('VIDEO_TIMEOUT')), 8000);

            const done = () => {
                window.clearTimeout(timer);
                video.removeEventListener('loadedmetadata', done);
                resolve();
            };

            if (video.videoWidth > 0) {
                done();
                return;
            }

            video.addEventListener('loadedmetadata', done, { once: true });
        });

        await video.play();
        this.resizeCanvas();
        const active = this.cameras.find((camera) => camera.deviceId === deviceId);
        this.activeCameraLabel = active ? active.label : '선택한 카메라';
        this.cameraStatus = '연결됨';
    }

    private startTracking() {
        this.stopTracking();
        this.lastFrameTime = 0;
        this.pinchActiveByHand = [];
        this.aimParticles = [];
        this.resetAimState();
        this.resetFistState();
        this.resetPortalState();
        this.resetOrbCompressState();
        this.resetDesktopPracticeState();
        this.resetRealDesktopGestureState();
        this.gestureArbiter.reset();
        this.handTracks = [];
        this.nextHandTrackId = 1;

        this.zone.runOutsideAngular(() => {
            this.animationFrame = requestAnimationFrame(this.renderFrame);
        });
    }

    private stopTracking() {
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = 0;
        }
    }

    private drawFrame(result: HandLandmarkerResult | null, delta: number, timestamp: number) {
        const canvas = this.effectCanvas?.nativeElement;
        const context = canvas?.getContext('2d');
        if (!canvas || !context) return;

        context.clearRect(0, 0, canvas.width, canvas.height);
        const landmarkSets = (result?.landmarks || [])
            .filter((landmarks) => landmarks.length >= 21);
        const hands = this.buildTrackedHandFrames(landmarkSets, timestamp);

        if (this.activeMode === 'desktop') {
            this.drawDesktopPracticeFrame(context, hands, delta);
            return;
        }

        if (this.activeMode === 'realDesktop') {
            this.drawRealDesktopControlFrame(context, hands, timestamp);
            return;
        }

        this.drawMagicFrame(context, hands, delta, timestamp);
    }

    private drawMagicFrame(context: CanvasRenderingContext2D, hands: HandFrame[], delta: number, timestamp: number) {
        hands.forEach((hand) => this.drawHandOverlay(context, hand.points));

        const features = this.buildHandGestureFeatures(hands);
        const candidates = this.collectGestureCandidates(hands, features, timestamp);
        const decision = this.gestureArbiter.decide(candidates, timestamp, hands.length);

        this.applyReleasedGesture(decision.released);
        this.cleanupInactiveMagicGestures(decision.active, hands.length);
        this.applyActiveGesture(decision.active, hands, delta, timestamp);

        this.drawEnergyEffects(context, delta);
        this.drawAimEffects(context, delta);
        this.drawParticles(context, delta);
        this.drawOrbCompressEffects(context, delta);
        this.drawPortalEffects(context, delta, hands);

        const spellStatus = this.getMagicSpellStatus(decision.active);
        const gestureStatus = this.getMagicGestureStatus(decision.active, candidates, decision.phases);

        if (hands.length > 0) {
            this.updateDetectionState(`${hands.length}개 손 감지됨`, gestureStatus, spellStatus);
        } else {
            this.updateDetectionState('손 감지 안 됨', 'inactive', spellStatus);
        }
    }

    private buildHandGestureFeatures(hands: HandFrame[]): HandGestureFeature[] {
        return hands.map((hand, handIndex) => {
            const fistMetrics = this.measureFist(hand.landmarks);
            const aimMetrics = this.measureIndexAim(hand.landmarks);
            const pinchDistance = this.getPinchDistance(hand.landmarks);

            return {
                hand,
                handIndex,
                pinchDistance,
                pinchConfidence: this.getPinchConfidence(pinchDistance),
                aimMetrics,
                aimConfidence: this.getIndexAimConfidence(aimMetrics),
                fistMetrics,
                fistConfidence: this.getFistConfidence(fistMetrics)
            };
        });
    }

    private collectGestureCandidates(
        hands: HandFrame[],
        features: HandGestureFeature[],
        timestamp: number
    ): GestureCandidate[] {
        const candidates: GestureCandidate[] = [];
        const portalCandidate = this.recognizePortalCandidate(hands, timestamp);
        const orbCandidate = this.recognizeOrbCompressCandidate(hands);

        if (portalCandidate) candidates.push(portalCandidate);
        if (orbCandidate) candidates.push(orbCandidate);

        features.forEach((feature) => {
            if (feature.fistConfidence > 0) {
                candidates.push(this.createSingleHandCandidate('fistCharge', feature.fistConfidence, feature));
            }

            if (feature.pinchConfidence > 0) {
                candidates.push(this.createSingleHandCandidate('pinchFire', feature.pinchConfidence, feature));
            }

            if (feature.aimConfidence > 0) {
                candidates.push(this.createSingleHandCandidate('indexAim', feature.aimConfidence, feature));
            }
        });

        return candidates;
    }

    private createSingleHandCandidate(
        name: MagicGestureName,
        confidence: number,
        feature: HandGestureFeature
    ): GestureCandidate {
        return {
            name,
            confidence,
            hands: [feature.handIndex],
            trackIds: [feature.hand.trackId],
            priority: this.gestureArbiter.getPriority(name),
            data: feature
        };
    }

    private recognizePortalCandidate(hands: HandFrame[], timestamp: number): GestureCandidate | null {
        if (this.hasOpenPortal() && hands.length > 0) {
            return {
                name: 'portal',
                confidence: 1,
                hands: [],
                trackIds: [],
                priority: this.gestureArbiter.getPriority('portal'),
                data: null
            };
        }

        if (timestamp < this.portalCooldownUntil || hands.length < 2) return null;

        const pair = this.pickPortalHands(hands);
        if (!pair) return null;

        const anchor = hands[pair.anchorIndex];
        const drawing = hands[pair.drawingIndex];
        const scale = Math.max(1, (anchor.scale + drawing.scale) / 2);
        const motionScore = this.clamp(drawing.motionEnergy / Math.max(1, 18 * scale), 0, 1);
        const palmScore = this.clamp((anchor.palm.score + drawing.palm.score) / 15, 0, 1);
        const traceScore = this.portalTrace.length > 0 ? 1 : 0;
        const confidence = this.clamp(0.58 + motionScore * 0.22 + palmScore * 0.14 + traceScore * 0.12, 0, 1);

        return {
            name: 'portal',
            confidence,
            hands: [pair.anchorIndex, pair.drawingIndex],
            trackIds: [pair.anchorTrackId, pair.drawingTrackId],
            priority: this.gestureArbiter.getPriority('portal'),
            data: pair
        };
    }

    private recognizeOrbCompressCandidate(hands: HandFrame[]): GestureCandidate | null {
        if (hands.length < 2 || this.portalState === 'drawing' || this.hasOpenPortal()) return null;

        const metrics = this.pickOrbCompressHands(hands);
        if (!metrics) return null;

        return {
            name: 'orbCompress',
            confidence: this.getOrbCompressConfidence(metrics),
            hands: [metrics.firstIndex, metrics.secondIndex],
            trackIds: [hands[metrics.firstIndex].trackId, hands[metrics.secondIndex].trackId],
            priority: this.gestureArbiter.getPriority('orbCompress'),
            data: metrics
        };
    }

    private getPinchDistance(landmarks: NormalizedLandmark[]): number {
        const thumbTip = landmarks[4];
        const indexTip = landmarks[8];
        if (!thumbTip || !indexTip) return Number.POSITIVE_INFINITY;
        return Math.hypot(thumbTip.x - indexTip.x, thumbTip.y - indexTip.y);
    }

    private getPinchConfidence(distance: number): number {
        if (!Number.isFinite(distance) || distance >= this.pinchEndThreshold) return 0;
        if (distance <= this.pinchStartThreshold) return 1;
        return this.clamp(
            (this.pinchEndThreshold - distance) / Math.max(0.001, this.pinchEndThreshold - this.pinchStartThreshold),
            0,
            1
        );
    }

    private getIndexAimConfidence(metrics: IndexAimMetrics): number {
        if (!metrics.indexExtended || metrics.extendedOtherFingers >= 2 || metrics.foldedFingers < 2) return 0;

        const foldedScore = this.clamp(metrics.foldedFingers / 3, 0, 1);
        const otherPenalty = metrics.extendedOtherFingers * 0.22;
        return this.clamp(0.45 + foldedScore * 0.37 + (metrics.extendedOtherFingers === 0 ? 0.16 : 0) - otherPenalty, 0, 1);
    }

    private getFistConfidence(metrics: FistMetrics): number {
        if (!metrics.indexFolded || metrics.foldedFingers < 2 || metrics.averageTipRatio >= this.fistEndAverageRatio) return 0;

        const foldedScore = this.clamp(metrics.foldedFingers / 4, 0, 1);
        const closenessScore = this.clamp(
            (this.fistEndAverageRatio - metrics.averageTipRatio) /
            Math.max(0.001, this.fistEndAverageRatio - this.fistStartAverageRatio),
            0,
            1
        );
        const extendedPenalty = metrics.extendedFingers * 0.11 + (metrics.indexExtended ? 0.18 : 0);
        return this.clamp(foldedScore * 0.42 + closenessScore * 0.4 + 0.22 - extendedPenalty, 0, 1);
    }

    private getOrbCompressConfidence(metrics: OrbCompressMetrics): number {
        return this.clamp((metrics.score - 3.35) / 2.25 + metrics.compression * 0.08, 0, 1);
    }

    private applyReleasedGesture(released: GestureRelease | null) {
        if (!released) return;

        if (released.name === 'portal') {
            this.cancelPortalDrawing();
            return;
        }

        if (released.name === 'orbCompress') {
            this.deactivateOrbCompress();
            return;
        }

        if (released.name === 'fistCharge') {
            const shouldLaunch = released.reason === 'ended';
            const handIndexes = released.hands.length > 0 ?
                released.hands :
                this.fistActiveByHand.map((active, index) => active ? index : -1).filter((index) => index >= 0);
            handIndexes.forEach((handIndex) => this.releaseFistCharge(handIndex, shouldLaunch));
            return;
        }

        released.hands.forEach((handIndex) => {
            if (released.name === 'pinchFire') {
                this.pinchActiveByHand[handIndex] = false;
            } else if (released.name === 'indexAim') {
                this.cancelAim(handIndex);
            }
        });
    }

    private cleanupInactiveMagicGestures(active: GestureCandidate | null, detectedCount: number) {
        const activeHands = new Set(active?.hands || []);
        const maxHands = Math.max(
            detectedCount,
            this.pinchActiveByHand.length,
            this.aimActiveByHand.length,
            this.fistActiveByHand.length
        );

        for (let handIndex = 0; handIndex < maxHands; handIndex++) {
            if (!(active?.name === 'pinchFire' && activeHands.has(handIndex))) {
                this.pinchActiveByHand[handIndex] = false;
            }

            if (!(active?.name === 'indexAim' && activeHands.has(handIndex))) {
                this.cancelAim(handIndex);
            }

            if (!(active?.name === 'fistCharge' && activeHands.has(handIndex))) {
                this.cancelFistCharge(handIndex);
            }
        }

        this.pinchActiveByHand.length = detectedCount;
        this.cancelMissingAimStates(detectedCount);
        this.cancelMissingFistCharges(detectedCount);

        if (active?.name !== 'orbCompress') {
            this.deactivateOrbCompress();
        }

        if (active?.name !== 'portal' && this.portalState === 'drawing') {
            this.cancelPortalDrawing();
        }
    }

    private applyActiveGesture(
        active: GestureCandidate | null,
        hands: HandFrame[],
        delta: number,
        timestamp: number
    ) {
        if (!active) return;

        if (active.name === 'portal') {
            this.activatePortalCandidate(active, hands, delta, timestamp);
        } else if (active.name === 'orbCompress') {
            this.activateOrbCompressCandidate(active, delta, timestamp);
        } else if (active.name === 'fistCharge') {
            this.activateFistCandidate(active, delta);
        } else if (active.name === 'pinchFire') {
            this.activatePinchCandidate(active, delta);
        } else if (active.name === 'indexAim') {
            this.activateIndexAimCandidate(active, delta);
        }
    }

    private activatePortalCandidate(active: GestureCandidate, hands: HandFrame[], delta: number, timestamp: number) {
        if (this.hasOpenPortal()) return;

        const pair = active.data as PortalHandPair | null;
        if (!pair) return;

        const drawingHand = hands[pair.drawingIndex];
        if (!drawingHand) return;

        const drawingPoint = drawingHand.center;
        if (this.portalAnchorTrackId !== pair.anchorTrackId || this.portalDrawingTrackId !== pair.drawingTrackId) {
            this.startPortalDrawing(pair.anchorTrackId, pair.drawingTrackId, drawingPoint, timestamp);
        }

        this.portalState = 'drawing';
        this.addPortalTracePoint(drawingPoint, drawingHand.scale, timestamp);
        this.emitPortalSparks(drawingPoint, drawingHand.scale, delta);

        const metrics = this.measurePortalCircle(timestamp);
        if (metrics) {
            this.openPortal(metrics, drawingHand.scale, timestamp);
        }
    }

    private activateOrbCompressCandidate(active: GestureCandidate, delta: number, timestamp: number) {
        const metrics = active.data as OrbCompressMetrics | null;
        if (!metrics) return;

        this.orbCompressPair = [metrics.firstIndex, metrics.secondIndex];
        this.orbCompressState = metrics.compression >= 0.55 ? 'compressing' : 'orb';
        this.updateOrbCompressEffect(metrics);
        this.emitOrbCompressParticles(metrics, delta);

        if (metrics.compression >= 0.88 && timestamp >= this.orbPulseCooldownUntil) {
            this.emitOrbCompressionPulse(metrics);
            this.orbPulseCooldownUntil = timestamp + 460;
        }
    }

    private activateFistCandidate(active: GestureCandidate, delta: number) {
        const feature = active.data as HandGestureFeature | null;
        if (!feature) return;

        const handIndex = feature.handIndex;
        const points = feature.hand.points;
        const center = this.getPalmCenter(points);
        const direction = this.getPalmDirection(points);
        const scale = this.getHandScale(points);

        if (!this.fistActiveByHand[handIndex]) {
            this.fistChargeByHand[handIndex] = 0;
        }

        this.fistActiveByHand[handIndex] = true;
        this.fistChargeByHand[handIndex] = (this.fistChargeByHand[handIndex] || 0) + delta;
        this.fistCenterByHand[handIndex] = center;
        this.fistDirectionByHand[handIndex] = direction;
        this.fistScaleByHand[handIndex] = scale;
        this.emitEnergyParticles(handIndex, center, scale, delta);
    }

    private activatePinchCandidate(active: GestureCandidate, delta: number) {
        const feature = active.data as HandGestureFeature | null;
        const indexTip = feature?.hand.points[8];
        if (!feature || !indexTip) return;

        this.pinchActiveByHand[feature.handIndex] = true;
        this.emitFlame(indexTip.x, indexTip.y, delta);
    }

    private activateIndexAimCandidate(active: GestureCandidate, delta: number) {
        const feature = active.data as HandGestureFeature | null;
        const indexTip = feature?.hand.points[8];
        if (!feature || !indexTip) return;

        const direction = this.getIndexDirection(feature.hand.points);
        const scale = this.getHandScale(feature.hand.points);
        this.aimActiveByHand[feature.handIndex] = true;
        this.updateAimTarget(feature.handIndex, indexTip, direction, scale);
        this.emitAimParticles(indexTip, direction, scale, delta);
    }

    private getMagicSpellStatus(active: GestureCandidate | null): string {
        if (active?.name === 'portal') {
            return this.hasOpenPortal() ? 'portalOpen' : 'drawing';
        }

        if (active?.name === 'orbCompress') return this.orbCompressState;
        if (active?.name === 'fistCharge') return 'charging';
        if (active?.name === 'pinchFire') return 'pinchFire';
        if (active?.name === 'indexAim') return 'aiming';
        if (this.hasOpenPortal()) return 'portalOpen';
        return this.energyProjectiles.length > 0 ? 'released' : 'idle';
    }

    private getMagicGestureStatus(
        active: GestureCandidate | null,
        candidates: GestureCandidate[],
        phases: Record<MagicGestureName, GesturePhase>
    ): string {
        if (active) return this.getGestureStatusLabel(active.name);

        const visibleCandidate = candidates
            .filter((candidate) => phases[candidate.name] === 'candidate')
            .sort((first, second) =>
                second.priority - first.priority ||
                second.confidence - first.confidence
            )[0];

        return visibleCandidate ? `${this.getGestureStatusLabel(visibleCandidate.name)} candidate` : 'inactive';
    }

    private getGestureStatusLabel(name: MagicGestureName): string {
        const labels: Record<MagicGestureName, string> = {
            portal: this.hasOpenPortal() ? 'portalOpen' : 'portal drawing',
            orbCompress: this.orbCompressState === 'compressing' ? 'compressing' : 'orb',
            fistCharge: 'fist charging',
            pinchFire: 'pinch fire',
            indexAim: 'index aim'
        };
        return labels[name];
    }

    private buildTrackedHandFrames(landmarkSets: NormalizedLandmark[][], timestamp: number): HandFrame[] {
        const baseHands = landmarkSets.map((landmarks) => this.buildUntrackedHandFrame(landmarks));
        const activeTracks = this.handTracks.filter((track) => timestamp - track.lastSeen <= this.handTrackRetention);
        const candidates: Array<{ handIndex: number; track: HandTrack; distance: number }> = [];

        baseHands.forEach((hand, handIndex) => {
            activeTracks.forEach((track) => {
                const distance = this.canvasDistance(hand.center, track.center);
                const matchLimit = Math.max(
                    72 * Math.max(hand.scale, track.scale),
                    this.getCanvasBase() * 0.085
                );

                if (distance <= matchLimit) {
                    candidates.push({ handIndex, track, distance });
                }
            });
        });

        candidates.sort((first, second) => first.distance - second.distance);

        const assignedHands = new Set<number>();
        const assignedTrackIds = new Set<number>();
        const assignments = new Map<number, { track: HandTrack; distance: number }>();

        candidates.forEach((candidate) => {
            if (assignedHands.has(candidate.handIndex) || assignedTrackIds.has(candidate.track.id)) return;
            assignedHands.add(candidate.handIndex);
            assignedTrackIds.add(candidate.track.id);
            assignments.set(candidate.handIndex, {
                track: candidate.track,
                distance: candidate.distance
            });
        });

        const updatedTracks: HandTrack[] = [];
        const hands = baseHands.map((hand, handIndex) => {
            const assignment = assignments.get(handIndex);
            const track = assignment?.track || {
                id: this.nextHandTrackId++,
                center: hand.center,
                motion: 0,
                motionEnergy: 0,
                scale: hand.scale,
                lastSeen: timestamp
            };
            const motion = assignment ? assignment.distance : 0;
            const motionEnergy = assignment ?
                track.motionEnergy * 0.68 + motion * 0.32 :
                0;

            track.center = hand.center;
            track.motion = motion;
            track.motionEnergy = motionEnergy;
            track.scale = hand.scale;
            track.lastSeen = timestamp;
            updatedTracks.push(track);

            return {
                ...hand,
                trackId: track.id,
                motion,
                motionEnergy
            };
        });

        const retainedTracks = activeTracks
            .filter((track) => !assignedTrackIds.has(track.id))
            .map((track) => ({
                ...track,
                motion: 0,
                motionEnergy: track.motionEnergy * 0.72
            }));

        this.handTracks = [...updatedTracks, ...retainedTracks];
        return hands;
    }

    private buildUntrackedHandFrame(landmarks: NormalizedLandmark[]): UntrackedHandFrame {
        const points = landmarks.map((landmark) => this.landmarkToCanvas(landmark));
        const center = this.getPalmCenter(points);

        return {
            landmarks,
            points,
            palm: this.measureOpenPalm(landmarks),
            center,
            scale: this.getHandScale(points)
        };
    }

    private landmarkToCanvas(landmark: NormalizedLandmark): CanvasPoint {
        const canvas = this.effectCanvas?.nativeElement;
        const video = this.videoElement?.nativeElement;
        if (!canvas || !video || video.videoWidth === 0 || video.videoHeight === 0) {
            return { x: 0, y: 0 };
        }

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const videoAspect = video.videoWidth / video.videoHeight;
        const canvasAspect = canvasWidth / canvasHeight;

        let renderWidth = canvasWidth;
        let renderHeight = canvasHeight;
        let offsetX = 0;
        let offsetY = 0;

        if (videoAspect > canvasAspect) {
            renderHeight = canvasHeight;
            renderWidth = renderHeight * videoAspect;
            offsetX = (canvasWidth - renderWidth) / 2;
        } else {
            renderWidth = canvasWidth;
            renderHeight = renderWidth / videoAspect;
            offsetY = (canvasHeight - renderHeight) / 2;
        }

        const rawX = offsetX + landmark.x * renderWidth;
        const rawY = offsetY + landmark.y * renderHeight;

        return {
            x: canvasWidth - rawX,
            y: rawY
        };
    }

    private drawHandOverlay(context: CanvasRenderingContext2D, points: CanvasPoint[]) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 720);

        context.save();
        context.lineWidth = 2 * scale;
        context.strokeStyle = 'rgba(255, 216, 139, 0.58)';
        context.shadowColor = 'rgba(255, 136, 38, 0.35)';
        context.shadowBlur = 8 * scale;

        for (const [from, to] of this.handConnections) {
            const start = points[from];
            const end = points[to];
            if (!start || !end) continue;

            context.beginPath();
            context.moveTo(start.x, start.y);
            context.lineTo(end.x, end.y);
            context.stroke();
        }

        points.forEach((point, index) => {
            const isGesturePoint = index === 4 || index === 8;
            context.beginPath();
            context.fillStyle = isGesturePoint ? 'rgba(255, 244, 178, 0.95)' : 'rgba(255, 255, 255, 0.72)';
            context.arc(point.x, point.y, (isGesturePoint ? 4.2 : 2.4) * scale, 0, Math.PI * 2);
            context.fill();
        });

        context.restore();
    }

    private resolvePinch(landmarks: NormalizedLandmark[], handIndex: number): boolean {
        const thumbTip = landmarks[4];
        const indexTip = landmarks[8];
        if (!thumbTip || !indexTip) return false;

        const distance = Math.hypot(thumbTip.x - indexTip.x, thumbTip.y - indexTip.y);
        const wasActive = this.pinchActiveByHand[handIndex] || false;

        if (!wasActive && distance <= this.pinchStartThreshold) {
            this.pinchActiveByHand[handIndex] = true;
        } else if (wasActive && distance >= this.pinchEndThreshold) {
            this.pinchActiveByHand[handIndex] = false;
        } else {
            this.pinchActiveByHand[handIndex] = wasActive;
        }

        return this.pinchActiveByHand[handIndex];
    }

    private measureOpenPalm(landmarks: NormalizedLandmark[]): OpenPalmMetrics {
        const palmCenter = this.getLandmarkCenter(landmarks, [0, 5, 9, 13, 17]);
        const palmScale = this.getPalmScale(landmarks);
        const fingers = [
            this.measureFinger(landmarks, palmCenter, palmScale, 8, 6),
            this.measureFinger(landmarks, palmCenter, palmScale, 12, 10),
            this.measureFinger(landmarks, palmCenter, palmScale, 16, 14),
            this.measureFinger(landmarks, palmCenter, palmScale, 20, 18)
        ];
        const openFingers = fingers.filter((finger) => finger.extended && finger.ratio >= 1.32).length;
        const averageRatio = fingers.reduce((sum, finger) => sum + finger.ratio, 0) / fingers.length;
        const palmSpread = this.landmarkDistance(landmarks[5], landmarks[17]) / palmScale;
        const isOpen = (openFingers >= 4 && averageRatio >= 1.34 && palmSpread >= 0.46) ||
            (openFingers >= 3 && averageRatio >= 1.44 && palmSpread >= 0.52);

        return {
            isOpen,
            openFingers,
            score: openFingers * 2 + averageRatio + palmSpread
        };
    }

    private measureIndexAim(landmarks: NormalizedLandmark[]): IndexAimMetrics {
        const palmCenter = this.getLandmarkCenter(landmarks, [0, 5, 9, 13, 17]);
        const palmScale = this.getPalmScale(landmarks);
        const index = this.measureFinger(landmarks, palmCenter, palmScale, 8, 6);
        const otherFingers = [
            this.measureFinger(landmarks, palmCenter, palmScale, 12, 10),
            this.measureFinger(landmarks, palmCenter, palmScale, 16, 14),
            this.measureFinger(landmarks, palmCenter, palmScale, 20, 18)
        ];

        return {
            indexExtended: index.extended,
            foldedFingers: otherFingers.filter((finger) => finger.folded).length,
            extendedOtherFingers: otherFingers.filter((finger) => finger.extended && finger.ratio >= this.aimEndFoldedRatio).length
        };
    }

    private measureFinger(
        landmarks: NormalizedLandmark[],
        palmCenter: CanvasPoint,
        palmScale: number,
        tipIndex: number,
        pipIndex: number
    ): FingerMeasure {
        const tip = landmarks[tipIndex];
        const pip = landmarks[pipIndex];
        const tipDistance = this.pointDistance(tip, palmCenter);
        const pipDistance = this.pointDistance(pip, palmCenter);
        const ratio = tipDistance / palmScale;

        return {
            ratio,
            folded: ratio <= this.aimFoldedRatio || tipDistance <= pipDistance * 1.08,
            extended: ratio >= this.aimIndexExtendRatio && tipDistance >= pipDistance * 1.14
        };
    }

    private updateAimTarget(handIndex: number, tip: CanvasPoint, direction: CanvasPoint, scale: number) {
        const current = this.aimEffectsByHand[handIndex];
        if (!current) {
            this.aimEffectsByHand[handIndex] = {
                active: true,
                x: tip.x,
                y: tip.y,
                targetX: tip.x,
                targetY: tip.y,
                dx: direction.x,
                dy: direction.y,
                targetDx: direction.x,
                targetDy: direction.y,
                alpha: 0,
                scale
            };
            return;
        }

        current.active = true;
        current.targetX = tip.x;
        current.targetY = tip.y;
        current.targetDx = direction.x;
        current.targetDy = direction.y;
        current.scale = scale;
    }

    private getIndexDirection(points: CanvasPoint[]): CanvasPoint {
        const tip = points[8];
        const pip = points[6] || points[5];
        if (!tip || !pip) return { x: 0, y: -1 };

        const dx = tip.x - pip.x;
        const dy = tip.y - pip.y;
        const length = Math.hypot(dx, dy) || 1;

        return {
            x: dx / length,
            y: dy / length
        };
    }

    private measureFist(landmarks: NormalizedLandmark[]): FistMetrics {
        const palmCenter = this.getLandmarkCenter(landmarks, [0, 5, 9, 13, 17]);
        const palmScale = this.getPalmScale(landmarks);
        const fingers = [
            { tip: 8, pip: 6 },
            { tip: 12, pip: 10 },
            { tip: 16, pip: 14 },
            { tip: 20, pip: 18 }
        ];
        let foldedFingers = 0;
        let extendedFingers = 0;
        let ratioTotal = 0;
        let indexFolded = false;
        let indexExtended = false;

        fingers.forEach((finger, index) => {
            const tip = landmarks[finger.tip];
            const pip = landmarks[finger.pip];
            const tipDistance = this.pointDistance(tip, palmCenter);
            const pipDistance = this.pointDistance(pip, palmCenter);
            const ratio = tipDistance / palmScale;
            const folded = ratio <= this.fistStartAverageRatio || tipDistance <= pipDistance * 1.12;
            const extended = ratio >= this.fistEndAverageRatio && tipDistance >= pipDistance * 1.16;

            ratioTotal += ratio;
            if (folded) {
                foldedFingers += 1;
            }
            if (extended) {
                extendedFingers += 1;
            }
            if (index === 0) {
                indexFolded = folded;
                indexExtended = extended;
            }
        });

        return {
            foldedFingers,
            extendedFingers,
            averageTipRatio: ratioTotal / fingers.length,
            indexFolded,
            indexExtended
        };
    }

    private getPalmScale(landmarks: NormalizedLandmark[]): number {
        return Math.max(
            0.035,
            (this.landmarkDistance(landmarks[0], landmarks[9]) + this.landmarkDistance(landmarks[5], landmarks[17])) / 2
        );
    }

    private getLandmarkCenter(landmarks: NormalizedLandmark[], indexes: number[]): CanvasPoint {
        const total = indexes.reduce((sum, index) => {
            const landmark = landmarks[index];
            return {
                x: sum.x + (landmark?.x || 0),
                y: sum.y + (landmark?.y || 0)
            };
        }, { x: 0, y: 0 });

        return {
            x: total.x / indexes.length,
            y: total.y / indexes.length
        };
    }

    private landmarkDistance(first: NormalizedLandmark, second: NormalizedLandmark): number {
        if (!first || !second) return 0;
        return Math.hypot(first.x - second.x, first.y - second.y);
    }

    private pointDistance(first: Pick<NormalizedLandmark, 'x' | 'y'>, second: CanvasPoint): number {
        if (!first || !second) return 0;
        return Math.hypot(first.x - second.x, first.y - second.y);
    }

    private getPalmCenter(points: CanvasPoint[]): CanvasPoint {
        const indexes = [0, 5, 9, 13, 17];
        const total = indexes.reduce((sum, index) => {
            const point = points[index] || { x: 0, y: 0 };
            return {
                x: sum.x + point.x,
                y: sum.y + point.y
            };
        }, { x: 0, y: 0 });

        return {
            x: total.x / indexes.length,
            y: total.y / indexes.length
        };
    }

    private getPalmDirection(points: CanvasPoint[]): CanvasPoint {
        const wrist = points[0];
        const knuckles = this.getCanvasCenter(points, [5, 9, 13, 17]);
        if (!wrist || !knuckles) return { x: 0, y: -1 };

        const dx = knuckles.x - wrist.x;
        const dy = knuckles.y - wrist.y;
        const length = Math.hypot(dx, dy) || 1;

        return {
            x: dx / length,
            y: dy / length
        };
    }

    private getCanvasCenter(points: CanvasPoint[], indexes: number[]): CanvasPoint {
        const total = indexes.reduce((sum, index) => {
            const point = points[index] || { x: 0, y: 0 };
            return {
                x: sum.x + point.x,
                y: sum.y + point.y
            };
        }, { x: 0, y: 0 });

        return {
            x: total.x / indexes.length,
            y: total.y / indexes.length
        };
    }

    private averageCanvasPoints(points: CanvasPoint[]): CanvasPoint {
        const total = points.reduce((sum, point) => ({
            x: sum.x + point.x,
            y: sum.y + point.y
        }), { x: 0, y: 0 });

        return {
            x: total.x / points.length,
            y: total.y / points.length
        };
    }

    private midpoint(first: CanvasPoint, second: CanvasPoint): CanvasPoint {
        return {
            x: (first.x + second.x) / 2,
            y: (first.y + second.y) / 2
        };
    }

    private canvasDistance(first: CanvasPoint, second: CanvasPoint): number {
        return Math.hypot(first.x - second.x, first.y - second.y);
    }

    private normalizeVector(vector: CanvasPoint): CanvasPoint {
        const length = Math.hypot(vector.x, vector.y) || 1;
        return {
            x: vector.x / length,
            y: vector.y / length
        };
    }

    private dotVector(first: CanvasPoint, second: CanvasPoint): number {
        return first.x * second.x + first.y * second.y;
    }

    private clamp(value: number, min: number, max: number): number {
        return Math.max(min, Math.min(max, value));
    }

    private lerp(start: number, end: number, amount: number): number {
        return start + (end - start) * amount;
    }

    private getCanvasBase(): number {
        const canvas = this.effectCanvas?.nativeElement;
        return canvas ? Math.min(canvas.width, canvas.height) : 720;
    }

    private getHandScale(points: CanvasPoint[]): number {
        const wrist = points[0];
        const middleMcp = points[9];
        const indexMcp = points[5];
        const pinkyMcp = points[17];

        if (!wrist || !middleMcp || !indexMcp || !pinkyMcp) {
            return 1;
        }

        return Math.max(
            1,
            (Math.hypot(wrist.x - middleMcp.x, wrist.y - middleMcp.y) +
                Math.hypot(indexMcp.x - pinkyMcp.x, indexMcp.y - pinkyMcp.y)) / 150
        );
    }

    private pickOrbCompressHands(hands: HandFrame[]): OrbCompressMetrics | null {
        let best: OrbCompressMetrics | null = null;

        hands.forEach((_, firstIndex) => {
            for (let secondIndex = firstIndex + 1; secondIndex < hands.length; secondIndex++) {
                const loose = this.isCurrentOrbCompressPair(firstIndex, secondIndex);
                const metrics = this.measureOrbCompressPair(hands, firstIndex, secondIndex, loose);
                if (!metrics) continue;
                if (!best || metrics.score > best.score) {
                    best = metrics;
                }
            }
        });

        return best;
    }

    private measureOrbCompressPair(
        hands: HandFrame[],
        firstIndex: number,
        secondIndex: number,
        loose: boolean
    ): OrbCompressMetrics | null {
        const first = hands[firstIndex];
        const second = hands[secondIndex];
        const firstThumb = first.points[4];
        const firstIndexTip = first.points[8];
        const firstThumbJoint = first.points[3];
        const firstIndexJoint = first.points[7];
        const secondThumb = second.points[4];
        const secondIndexTip = second.points[8];
        const secondThumbJoint = second.points[3];
        const secondIndexJoint = second.points[7];

        if (!firstThumb || !firstIndexTip || !firstThumbJoint || !firstIndexJoint ||
            !secondThumb || !secondIndexTip || !secondThumbJoint || !secondIndexJoint) {
            return null;
        }

        const scale = Math.max(0.72, (first.scale + second.scale) / 2);
        const canvasBase = this.getCanvasBase();
        const palmDistance = this.canvasDistance(first.center, second.center);
        const minPalmDistance = Math.max(36 * scale, canvasBase * 0.032);
        const maxPalmDistance = Math.max(150 * scale, Math.min(canvasBase * 0.56, 340 * scale));

        if (palmDistance < minPalmDistance * (loose ? 0.52 : 0.62) ||
            palmDistance > maxPalmDistance * (loose ? 1.14 : 1)) {
            return null;
        }

        const firstGap = this.canvasDistance(firstThumb, firstIndexTip);
        const secondGap = this.canvasDistance(secondThumb, secondIndexTip);
        const minFingerGap = Math.max(16 * scale, palmDistance * 0.07);
        const maxFingerGap = Math.max(58 * scale, palmDistance * 0.62);

        if (firstGap < minFingerGap * (loose ? 0.82 : 1) ||
            secondGap < minFingerGap * (loose ? 0.82 : 1) ||
            firstGap > maxFingerGap * (loose ? 1.18 : 1) ||
            secondGap > maxFingerGap * (loose ? 1.18 : 1)) {
            return null;
        }

        const ringPoints = [firstThumb, firstIndexTip, secondThumb, secondIndexTip];
        const center = this.averageCanvasPoints(ringPoints);
        const palmMidpoint = this.midpoint(first.center, second.center);
        const centerOffsetRatio = this.canvasDistance(center, palmMidpoint) / Math.max(1, palmDistance);

        if (centerOffsetRatio > (loose ? 0.44 : 0.36)) return null;

        const ringDistances = ringPoints.map((point) => this.canvasDistance(point, center));
        const ringRadius = ringDistances.reduce((sum, distance) => sum + distance, 0) / ringDistances.length;
        const minRingRadius = Math.max(18 * scale, palmDistance * 0.09);
        const maxRingRadius = Math.max(54 * scale, palmDistance * 0.52);

        if (ringRadius < minRingRadius * (loose ? 0.82 : 1) ||
            ringRadius > maxRingRadius * (loose ? 1.16 : 1)) {
            return null;
        }

        const radialDeviation = Math.sqrt(
            ringDistances.reduce((sum, distance) => sum + Math.pow(distance - ringRadius, 2), 0) / ringDistances.length
        );
        const radialVariance = radialDeviation / Math.max(1, ringRadius);
        if (radialVariance > (loose ? 0.76 : 0.64)) return null;

        const centerClearance = Math.min(...ringDistances);
        if (centerClearance < Math.max(9 * scale, ringRadius * (loose ? 0.26 : 0.32))) {
            return null;
        }

        const supportPoints = [firstThumbJoint, firstIndexJoint, secondThumbJoint, secondIndexJoint];
        const supportDistances = supportPoints.map((point) => this.canvasDistance(point, center));
        const supportRadius = supportDistances.reduce((sum, distance) => sum + distance, 0) / supportDistances.length;
        const supportSpreadRatio = supportRadius / Math.max(1, ringRadius);
        if (supportSpreadRatio > (loose ? 2.85 : 2.45)) return null;

        const firstArcMidpoint = this.midpoint(firstThumb, firstIndexTip);
        const secondArcMidpoint = this.midpoint(secondThumb, secondIndexTip);
        const firstToSecond = this.normalizeVector({
            x: second.center.x - first.center.x,
            y: second.center.y - first.center.y
        });
        const secondToFirst = { x: -firstToSecond.x, y: -firstToSecond.y };
        const firstTowardCenter = this.normalizeVector({
            x: firstArcMidpoint.x - first.center.x,
            y: firstArcMidpoint.y - first.center.y
        });
        const secondTowardCenter = this.normalizeVector({
            x: secondArcMidpoint.x - second.center.x,
            y: secondArcMidpoint.y - second.center.y
        });
        const facingScore = (
            this.dotVector(firstTowardCenter, firstToSecond) +
            this.dotVector(secondTowardCenter, secondToFirst)
        ) / 2;

        if (facingScore < (loose ? 0.12 : 0.22)) return null;

        const firstCenterPull = 1 - this.clamp(
            this.canvasDistance(firstArcMidpoint, center) / Math.max(1, palmDistance * 0.52),
            0,
            1
        );
        const secondCenterPull = 1 - this.clamp(
            this.canvasDistance(secondArcMidpoint, center) / Math.max(1, palmDistance * 0.52),
            0,
            1
        );
        const centerPullScore = (firstCenterPull + secondCenterPull) / 2;
        const arcRatio = ((firstGap + secondGap) / 2) / Math.max(1, ringRadius);
        const arcShapeScore = 1 - this.clamp(Math.abs(arcRatio - 1.18) / 1.18, 0, 1);
        const offsetScore = 1 - this.clamp(centerOffsetRatio / 0.44, 0, 1);
        const radialScore = 1 - this.clamp(radialVariance / 0.76, 0, 1);
        const supportScore = 1 - this.clamp(Math.abs(supportSpreadRatio - 1.38) / 1.38, 0, 1);
        const facingScoreNormalized = this.clamp((facingScore + 0.08) / 1.08, 0, 1);
        const distanceScore = 1 - this.clamp(
            Math.abs(palmDistance - maxPalmDistance * 0.55) / Math.max(1, maxPalmDistance * 0.55),
            0,
            1
        );
        const score = offsetScore * 1.25 +
            radialScore * 1.3 +
            facingScoreNormalized * 1.65 +
            centerPullScore * 1.25 +
            arcShapeScore * 1.05 +
            supportScore * 0.55 +
            distanceScore * 0.9;

        if (score < (loose ? 3.45 : 3.95)) return null;

        const compressionStart = minPalmDistance * 1.1;
        const compressionEnd = maxPalmDistance * 0.9;
        const compression = this.clamp(
            1 - (palmDistance - compressionStart) / Math.max(1, compressionEnd - compressionStart),
            0,
            1
        );
        const expandedRadius = this.clamp(palmDistance * 0.26, 34 * scale, 82 * scale);
        const compressedRadius = Math.max(15 * scale, expandedRadius * 0.42);
        const radius = this.lerp(expandedRadius, compressedRadius, compression);
        const intensity = this.clamp(0.48 + compression * 0.72 + Math.max(0, score - 4) * 0.08, 0.48, 1.28);

        return {
            firstIndex,
            secondIndex,
            center,
            distance: palmDistance,
            radius,
            scale,
            compression,
            intensity,
            score
        };
    }

    private isCurrentOrbCompressPair(firstIndex: number, secondIndex: number): boolean {
        if (!this.orbCompressPair) return false;
        const [currentFirst, currentSecond] = this.orbCompressPair;
        return (currentFirst === firstIndex && currentSecond === secondIndex) ||
            (currentFirst === secondIndex && currentSecond === firstIndex);
    }

    private updateOrbCompressEffect(metrics: OrbCompressMetrics) {
        const effect = this.orbCompressEffect;
        if (effect.alpha <= 0.015) {
            effect.x = metrics.center.x;
            effect.y = metrics.center.y;
            effect.radius = metrics.radius;
            effect.intensity = metrics.intensity;
            effect.compression = metrics.compression;
        }

        effect.active = true;
        effect.targetX = metrics.center.x;
        effect.targetY = metrics.center.y;
        effect.targetRadius = metrics.radius;
        effect.targetIntensity = metrics.intensity;
        effect.targetCompression = metrics.compression;
        effect.scale = metrics.scale;
    }

    private deactivateOrbCompress() {
        this.orbCompressState = 'idle';
        this.orbCompressPair = null;
        this.orbCompressEffect.active = false;
    }

    private resetOrbCompressState() {
        this.deactivateOrbCompress();
        this.orbCompressParticles = [];
        this.orbCompressPulses = [];
        this.orbPulseCooldownUntil = 0;
        this.orbCompressEffect = {
            active: false,
            x: 0,
            y: 0,
            targetX: 0,
            targetY: 0,
            radius: 0,
            targetRadius: 0,
            intensity: 0,
            targetIntensity: 0,
            compression: 0,
            targetCompression: 0,
            alpha: 0,
            scale: 1
        };
    }

    private drawDesktopPracticeFrame(context: CanvasRenderingContext2D, hands: HandFrame[], delta: number) {
        this.drawDesktopBackdrop(context);
        this.resolveDesktopPracticeGesture(hands);
        this.drawDesktopIcons(context);
        this.drawDesktopCursor(context, delta);

        if (hands.length > 0) {
            this.updateDetectionState(`${hands.length}개 손 감지됨`, this.desktopState, this.desktopState);
        } else {
            this.updateDetectionState('손 감지 안 됨', 'idle', 'idle');
        }
    }

    private resolveDesktopPracticeGesture(hands: HandFrame[]) {
        if (hands.length === 0) {
            this.pinchActiveByHand = [];
            this.desktopPinchReadyByHand = [];
            this.desktopCursor.active = false;
            this.desktopHoveredIconId = null;
            this.finishDesktopDrag();
            this.setDesktopPracticeState('idle');
            return;
        }

        const selected = this.pickDesktopPracticeHand(hands);
        if (!selected) {
            this.desktopCursor.active = false;
            this.desktopHoveredIconId = null;
            this.desktopPinchReadyByHand.length = hands.length;
            this.finishDesktopDrag();
            this.setDesktopPracticeState('idle');
            return;
        }

        const { hand, handIndex } = selected;
        const cursorPoint = hand.points[8];
        if (!cursorPoint) {
            this.desktopCursor.active = false;
            this.desktopHoveredIconId = null;
            this.desktopPinchReadyByHand.length = hands.length;
            this.finishDesktopDrag();
            this.setDesktopPracticeState('idle');
            return;
        }

        this.setDesktopCursorTarget(cursorPoint, hand.scale);
        const wasPinch = this.pinchActiveByHand[handIndex] || false;
        const isPinch = this.resolvePinch(hand.landmarks, handIndex);
        const pinchWasReady = this.desktopPinchReadyByHand[handIndex] || false;
        if (!isPinch) {
            this.desktopPinchReadyByHand[handIndex] = true;
        }
        const pinchStarted = pinchWasReady && !wasPinch && isPinch;
        const hoveredIcon = this.findDesktopIconAtPoint(cursorPoint);
        this.desktopHoveredIconId = hoveredIcon?.id || null;

        if (this.desktopDrag.iconId && this.desktopDrag.trackId !== hand.trackId) {
            this.finishDesktopDrag();
        }

        if (pinchStarted && hoveredIcon) {
            this.startDesktopDrag(hoveredIcon, cursorPoint, hand.trackId);
        }

        if (this.desktopDrag.iconId) {
            if (isPinch) {
                this.updateDesktopDrag(cursorPoint);
                this.setDesktopPracticeState('dragging');
            } else {
                this.finishDesktopDrag();
                this.setDesktopPracticeState(hoveredIcon ? 'hover' : 'idle');
            }
        } else {
            this.setDesktopPracticeState(hoveredIcon ? 'hover' : 'idle');
        }

        this.pinchActiveByHand.length = hands.length;
        this.desktopPinchReadyByHand.length = hands.length;
    }

    private pickDesktopPracticeHand(hands: HandFrame[]): { hand: HandFrame; handIndex: number } | null {
        if (this.desktopDrag.trackId !== null) {
            const handIndex = hands.findIndex((hand) => hand.trackId === this.desktopDrag.trackId);
            if (handIndex >= 0) {
                return {
                    hand: hands[handIndex],
                    handIndex
                };
            }
        }

        const handIndex = hands.findIndex((hand) => !!hand.points[8]);
        if (handIndex < 0) return null;

        return {
            hand: hands[handIndex],
            handIndex
        };
    }

    private setDesktopCursorTarget(point: CanvasPoint, scale: number) {
        const cursor = this.desktopCursor;
        if (cursor.alpha <= 0.015) {
            cursor.x = point.x;
            cursor.y = point.y;
        }

        cursor.visible = true;
        cursor.active = true;
        cursor.targetX = point.x;
        cursor.targetY = point.y;
        cursor.scale = Math.max(0.8, scale);
    }

    private findDesktopIconAtPoint(point: CanvasPoint): DesktopIconTile | null {
        for (let index = this.desktopIcons.length - 1; index >= 0; index--) {
            const icon = this.desktopIcons[index];
            const rect = this.getDesktopIconRect(icon);
            if (!rect) continue;

            if (point.x >= rect.x &&
                point.x <= rect.x + rect.width &&
                point.y >= rect.y &&
                point.y <= rect.y + rect.height) {
                return icon;
            }
        }

        return null;
    }

    private startDesktopDrag(icon: DesktopIconTile, point: CanvasPoint, trackId: number) {
        const canvas = this.effectCanvas?.nativeElement;
        const rect = this.getDesktopIconRect(icon);
        if (!canvas || !rect) return;

        const normalizedX = rect.x / canvas.width;
        const normalizedY = rect.y / canvas.height;
        icon.x = normalizedX;
        icon.y = normalizedY;

        this.desktopDrag = {
            iconId: icon.id,
            offsetX: point.x / canvas.width - normalizedX,
            offsetY: point.y / canvas.height - normalizedY,
            trackId
        };
        this.desktopHoveredIconId = icon.id;
        this.setDesktopPracticeState('dragging');
    }

    private updateDesktopDrag(point: CanvasPoint) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas || !this.desktopDrag.iconId) return;

        const icon = this.desktopIcons.find((item) => item.id === this.desktopDrag.iconId);
        if (!icon) return;

        const rect = this.getDesktopIconRect(icon);
        if (!rect) return;

        const marginX = Math.min(0.035, 24 / canvas.width);
        const marginY = Math.min(0.05, 28 / canvas.height);
        const widthRatio = rect.width / canvas.width;
        const heightRatio = rect.height / canvas.height;

        icon.x = this.clamp(point.x / canvas.width - this.desktopDrag.offsetX, marginX, 1 - widthRatio - marginX);
        icon.y = this.clamp(point.y / canvas.height - this.desktopDrag.offsetY, marginY, 1 - heightRatio - marginY);
    }

    private finishDesktopDrag() {
        this.desktopDrag = {
            iconId: null,
            offsetX: 0,
            offsetY: 0,
            trackId: null
        };
    }

    private setDesktopPracticeState(state: DesktopPracticeState) {
        this.desktopState = state;
    }

    private resetDesktopPracticeState() {
        this.desktopState = 'idle';
        this.desktopHoveredIconId = null;
        this.finishDesktopDrag();
        this.desktopPinchReadyByHand = [];
        this.desktopCursor = {
            visible: false,
            active: false,
            x: 0,
            y: 0,
            targetX: 0,
            targetY: 0,
            alpha: 0,
            scale: 1
        };
    }

    private drawRealDesktopControlFrame(context: CanvasRenderingContext2D, hands: HandFrame[], timestamp: number) {
        hands.forEach((hand) => this.drawHandOverlay(context, hand.points));

        if (!this.realDesktopEnabled) {
            this.realDesktopCalibrationCurrentObservedPoint = null;
            if (this.realDesktopMouseDown) {
                this.releaseRealDesktopMouse('제어 비활성화로 mouse up');
            }
            this.handleRealDesktopEnableGestureFrame(context, hands, timestamp);
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState(
                hands.length > 0 ? `${hands.length}개 손 감지됨` : '손 감지 안 됨',
                this.realDesktopEnableHoldActive ? 'enable hold' : 'inactive',
                this.realDesktopStatus
            );
            return;
        }

        if (hands.length === 0) {
            this.realDesktopCalibrationCurrentObservedPoint = null;
            this.releaseRealDesktopMouse('손 사라짐으로 mouse up');
            this.cancelRealDesktopPauseHold('손이 사라져 pause/resume 확인을 취소했습니다.', false);
            this.realDesktopPinchReadyByHand = [];
            this.realDesktopPinchActiveByHand = [];
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState('손 감지 안 됨', 'inactive', this.realDesktopStatus);
            return;
        }

        const selected = this.pickRealDesktopControlHand(hands);
        const hand = selected?.hand;
        const handIndex = selected?.handIndex ?? -1;
        const indexTip = hand?.points[8];
        if (!hand || handIndex < 0 || !indexTip) {
            this.realDesktopCalibrationCurrentObservedPoint = null;
            this.releaseRealDesktopMouse('검지 위치 없음으로 mouse up');
            this.cancelRealDesktopPauseHold('검지 위치 없음으로 pause/resume 확인을 취소했습니다.', false);
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState(`${hands.length}개 손 감지됨`, 'inactive', this.realDesktopStatus);
            return;
        }

        this.realDesktopCalibrationCurrentObservedPoint = this.canvasPointToNormalized(indexTip);
        const mappedScreenPoint = this.mapCanvasPointToScreen(indexTip);
        if (!mappedScreenPoint) {
            this.realDesktopCalibrationCurrentObservedPoint = null;
            this.releaseRealDesktopMouse('화면 좌표 없음으로 mouse up');
            this.cancelRealDesktopPauseHold('화면 좌표 없음으로 pause/resume 확인을 취소했습니다.', false);
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState(`${hands.length}개 손 감지됨`, 'inactive', this.realDesktopStatus);
            return;
        }

        const screenPoint = this.realDesktopCalibrationActive
            ? mappedScreenPoint
            : this.applyRealDesktopPointerSettings(mappedScreenPoint);

        this.drawRealDesktopPointer(context, indexTip, screenPoint);
        this.realDesktopLastScreenPoint = screenPoint;

        if (this.realDesktopCalibrationActive) {
            this.resetRealDesktopPointerSettingsFilter();
            this.handleRealDesktopCalibrationFrame(context, indexTip, screenPoint);
            this.updateDetectionState(
                `${hands.length}개 손 감지됨`,
                `calibration ${this.realDesktopCalibrationProgressLabel}`,
                this.realDesktopStatus
            );
            return;
        }

        if (this.realDesktopMouseDown &&
            this.realDesktopActiveTrackId !== null &&
            this.realDesktopActiveTrackId !== hand.trackId) {
            this.releaseRealDesktopMouse('활성 손 추적 해제');
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState(`${hands.length}개 손 감지됨`, 'inactive', this.realDesktopStatus);
            return;
        }

        this.realDesktopActiveTrackId = this.realDesktopMouseDown ? hand.trackId : null;

        const pauseGestureHandled = this.handleRealDesktopPauseGestureFrame(context, hand, indexTip, timestamp);
        if (pauseGestureHandled || this.realDesktopPaused) {
            this.realDesktopPinchReadyByHand = [];
            this.realDesktopPinchActiveByHand = [];
            this.resetRealDesktopDragArming();
            this.resetRealDesktopClickGestureState(false);
            this.updateDetectionState(
                `${hands.length}개 손 감지됨`,
                this.getRealDesktopPauseGestureStatus(),
                this.realDesktopStatus
            );
            return;
        }

        const gesture = this.resolveRealDesktopPointerGesture(hand, handIndex, indexTip, timestamp);
        const sentDoubleClick = this.realDesktopClickMode === 'doubleTap' && this.updateRealDesktopTapGesture(
            hand,
            indexTip,
            screenPoint,
            gesture.isIndexOnly,
            gesture.isPinch,
            timestamp
        );
        if (this.realDesktopClickMode !== 'doubleTap') {
            this.resetRealDesktopTapCurrent(false);
        }
        const sentPinchClick = this.updateRealDesktopPinchClickGesture(hand, indexTip, screenPoint, gesture, timestamp);
        const sentDwellClick = this.updateRealDesktopDwellClickGesture(
            context,
            hand,
            indexTip,
            screenPoint,
            gesture,
            sentDoubleClick || sentPinchClick,
            timestamp
        );
        const sentClick = sentDoubleClick || sentPinchClick || sentDwellClick;

        if (gesture.dragReady && !this.realDesktopMouseDown) {
            this.clearPendingRealDesktopMove();
            this.resetRealDesktopClickGestureState(false);
            this.resetRealDesktopDragArming();
            this.realDesktopMouseDown = true;
            this.realDesktopActiveTrackId = hand.trackId;
            this.realDesktopLastDragScreenPoint = screenPoint;
            this.queueRealDesktopCommand({ type: 'down', x: screenPoint.x, y: screenPoint.y }, true);
            this.setRealDesktopStatus('dragging', `mouse down ${screenPoint.x}, ${screenPoint.y}`);
        } else if (gesture.dragArming && !this.realDesktopMouseDown) {
            this.setRealDesktopStatus('ready', 'pinch 유지 중 · 드래그 준비');
        } else if (gesture.isPinch && this.realDesktopMouseDown) {
            if (!this.realDesktopLastDragScreenPoint ||
                this.canvasDistance(this.realDesktopLastDragScreenPoint, screenPoint) >= this.realDesktopDragMoveThreshold) {
                this.realDesktopLastDragScreenPoint = screenPoint;
                this.queueRealDesktopCommand({ type: 'drag', x: screenPoint.x, y: screenPoint.y });
                this.setRealDesktopStatus('dragging', `drag ${screenPoint.x}, ${screenPoint.y}`);
            } else {
                this.setRealDesktopStatus('dragging', 'pinch 유지 중');
            }
        } else if (!gesture.isPinch && this.realDesktopMouseDown) {
            this.clearPendingRealDesktopMove();
            this.queueRealDesktopCommand({ type: 'up', x: screenPoint.x, y: screenPoint.y }, true);
            this.realDesktopMouseDown = false;
            this.realDesktopActiveTrackId = null;
            this.realDesktopLastDragScreenPoint = null;
            this.resetRealDesktopDragArming();
            this.setRealDesktopStatus('ready', 'pinch 해제로 mouse up');
        } else if (gesture.isIndexOnly && !sentClick) {
            this.resetRealDesktopDragArming();
            this.queueRealDesktopCommand({ type: 'move', x: screenPoint.x, y: screenPoint.y });
            this.setRealDesktopStatus(
                'moving',
                this.realDesktopClickMode === 'dwellClick' && this.realDesktopDwellClickProgress > 0
                    ? this.realDesktopDwellClickMessage
                    : `move ${screenPoint.x}, ${screenPoint.y}`
            );
        } else if (sentDoubleClick) {
            this.resetRealDesktopDragArming();
            this.setRealDesktopStatus('ready', `double click ${screenPoint.x}, ${screenPoint.y}`);
        } else if (sentPinchClick) {
            this.resetRealDesktopDragArming();
            this.setRealDesktopStatus('ready', `pinch click ${screenPoint.x}, ${screenPoint.y}`);
        } else if (sentDwellClick) {
            this.resetRealDesktopDragArming();
            this.setRealDesktopStatus('ready', `dwell click ${screenPoint.x}, ${screenPoint.y}`);
        } else {
            this.resetRealDesktopDragArming();
            this.resetRealDesktopClickGestureState(true);
            this.setRealDesktopStatus('ready', '검지 이동 또는 pinch 대기');
        }

        this.realDesktopPinchActiveByHand.length = hands.length;
        this.realDesktopPinchReadyByHand.length = hands.length;
        this.updateDetectionState(
            `${hands.length}개 손 감지됨`,
            this.getRealDesktopGestureStatus(gesture, this.getRealDesktopClickGestureStatus(sentDoubleClick, sentPinchClick, sentDwellClick)),
            this.realDesktopStatus
        );
    }

    private handleRealDesktopEnableGestureFrame(context: CanvasRenderingContext2D, hands: HandFrame[], timestamp: number) {
        if (this.realDesktopEnabled || this.realDesktopEnableHoldCompleting) return;
        if (this.realDesktopEnableHoldSource === 'button') return;

        if (hands.length === 0) {
            if (this.realDesktopEnableHoldSource === 'gesture') {
                this.cancelRealDesktopEnableHold('손이 사라져 안전 확인을 취소했습니다.');
            }
            return;
        }

        const selected = this.pickRealDesktopControlHand(hands);
        const hand = selected?.hand;
        const indexTip = hand?.points[8];
        const isConfirmGesture = !!hand && !!indexTip && hand.palm.isOpen;

        if (!hand || !indexTip || !isConfirmGesture) {
            if (this.realDesktopEnableHoldSource === 'gesture') {
                this.cancelRealDesktopEnableHold('확인 제스처가 해제되어 안전 확인을 취소했습니다.');
            }
            return;
        }

        if (!this.realDesktopEnableHoldActive) {
            this.startRealDesktopEnableHold('gesture', hand, indexTip, timestamp);
            this.drawRealDesktopEnableHoldOverlay(context, indexTip);
            return;
        }

        if (this.realDesktopEnableHoldTrackId !== hand.trackId ||
            !this.realDesktopEnableHoldAnchor ||
            this.canvasDistance(this.realDesktopEnableHoldAnchor, indexTip) > this.getRealDesktopEnableHoldMoveLimit()) {
            this.cancelRealDesktopEnableHold('확인 제스처가 흔들려 안전 확인을 취소했습니다.');
            return;
        }

        this.updateRealDesktopEnableHoldProgress(timestamp);
        this.drawRealDesktopEnableHoldOverlay(context, indexTip);
    }

    private handleRealDesktopPauseGestureFrame(
        context: CanvasRenderingContext2D,
        hand: HandFrame,
        point: CanvasPoint,
        timestamp: number
    ): boolean {
        if (!this.realDesktopEnabled || this.realDesktopCalibrationActive) return false;

        const isPauseGesture = this.isRealDesktopPauseResumeGesture(hand);
        if (!isPauseGesture) {
            this.realDesktopPauseGestureReleaseRequired = false;
            this.cancelRealDesktopPauseHold('Pause/Resume 제스처가 해제되었습니다.');
            return false;
        }

        if (this.realDesktopPauseGestureReleaseRequired) {
            this.realDesktopPauseHoldMessage = '손바닥을 한 번 내리면 다음 pause/resume 제스처를 사용할 수 있습니다.';
            this.drawRealDesktopHoldOverlay(context, point, 100, 'RELEASE');
            return true;
        }

        const target: RealDesktopPauseHoldTarget = this.realDesktopPaused ? 'resume' : 'pause';
        if (!this.realDesktopPauseHoldActive) {
            this.startRealDesktopPauseHold(target, hand, point, timestamp);
            this.drawRealDesktopPauseHoldOverlay(context, point);
            return true;
        }

        if (this.realDesktopPauseHoldTarget !== target ||
            this.realDesktopPauseHoldTrackId !== hand.trackId ||
            !this.realDesktopPauseHoldAnchor ||
            this.canvasDistance(this.realDesktopPauseHoldAnchor, point) > this.getRealDesktopPauseHoldMoveLimit()) {
            this.cancelRealDesktopPauseHold('Pause/Resume 제스처가 흔들려 취소되었습니다.');
            return true;
        }

        this.updateRealDesktopPauseHoldProgress(timestamp);
        this.drawRealDesktopPauseHoldOverlay(context, point);
        return true;
    }

    private startRealDesktopPauseHold(target: RealDesktopPauseHoldTarget, hand: HandFrame, point: CanvasPoint, timestamp: number) {
        this.clearPendingRealDesktopMove();
        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse('Pause 제스처 감지로 mouse up');
        }

        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(false);
        this.realDesktopPinchReadyByHand = [];
        this.realDesktopPinchActiveByHand = [];
        this.realDesktopPauseHoldActive = true;
        this.realDesktopPauseHoldTarget = target;
        this.realDesktopPauseHoldTrackId = hand.trackId;
        this.realDesktopPauseHoldAnchor = { ...point };
        this.realDesktopPauseHoldStartedAt = timestamp;
        this.realDesktopPauseHoldProgress = 0;
        this.updateRealDesktopPauseHoldProgress(timestamp);
    }

    private updateRealDesktopPauseHoldProgress(timestamp: number) {
        if (!this.realDesktopPauseHoldActive || !this.realDesktopPauseHoldTarget) return;

        const elapsed = Math.max(0, timestamp - this.realDesktopPauseHoldStartedAt);
        this.realDesktopPauseHoldProgress = this.clamp(elapsed / this.realDesktopPauseHoldDuration * 100, 0, 100);
        this.realDesktopPauseHoldMessage = this.getRealDesktopPauseHoldMessage(this.realDesktopPauseHoldTarget);
        this.setRealDesktopStatus(
            this.realDesktopPaused ? 'paused' : 'ready',
            this.realDesktopPauseHoldMessage
        );

        if (this.realDesktopPauseHoldProgress >= 100) {
            this.completeRealDesktopPauseHold();
        }
    }

    private completeRealDesktopPauseHold() {
        if (!this.realDesktopPauseHoldActive || !this.realDesktopPauseHoldTarget) return;

        const target = this.realDesktopPauseHoldTarget;
        this.resetRealDesktopPauseHold();
        this.realDesktopPauseGestureReleaseRequired = true;

        if (target === 'pause') {
            this.pauseRealDesktopMouseControl('열린 손바닥 hold로 일시정지');
        } else {
            this.resumeRealDesktopMouseControl('열린 손바닥 hold로 재개');
        }

        if (!this.destroyed) void this.service.render();
    }

    private cancelRealDesktopPauseHold(reason: string, updateStatus: boolean = true) {
        if (!this.realDesktopPauseHoldActive) return;

        this.resetRealDesktopPauseHold();
        if (!updateStatus) return;

        this.setRealDesktopStatus(this.realDesktopPaused ? 'paused' : 'ready', reason);
    }

    private resetRealDesktopPauseHold() {
        this.realDesktopPauseHoldActive = false;
        this.realDesktopPauseHoldProgress = 0;
        this.realDesktopPauseHoldMessage = '열린 손바닥을 0.8초 유지하면 일시정지/재개합니다.';
        this.realDesktopPauseHoldTrackId = null;
        this.realDesktopPauseHoldAnchor = null;
        this.realDesktopPauseHoldStartedAt = 0;
        this.realDesktopPauseHoldTarget = null;
    }

    private getRealDesktopPauseHoldMessage(target: RealDesktopPauseHoldTarget): string {
        const remainingMs = Math.max(
            0,
            Math.ceil(this.realDesktopPauseHoldDuration * (1 - this.realDesktopPauseHoldProgress / 100))
        );
        const remainingLabel = (remainingMs / 1000).toFixed(1);
        const actionLabel = target === 'resume' ? '재개' : '일시정지';

        return `열린 손바닥 ${actionLabel} 확인 ${this.realDesktopPauseHoldPercent}% · ${remainingLabel}s 남음`;
    }

    private getRealDesktopPauseGestureStatus(): string {
        if (this.realDesktopPauseHoldActive) return this.realDesktopPaused ? 'resume hold' : 'pause hold';
        if (this.realDesktopPauseGestureReleaseRequired) return 'gesture release';
        return this.realDesktopPaused ? 'paused' : 'inactive';
    }

    private isRealDesktopPauseResumeGesture(hand: HandFrame): boolean {
        return hand.palm.isOpen && hand.palm.openFingers >= 4;
    }

    private drawRealDesktopEnableHoldOverlay(context: CanvasRenderingContext2D, point: CanvasPoint) {
        if (!this.realDesktopEnableHoldActive) return;
        this.drawRealDesktopHoldOverlay(context, point, this.realDesktopEnableHoldPercent, 'HOLD');
    }

    private drawRealDesktopPauseHoldOverlay(context: CanvasRenderingContext2D, point: CanvasPoint) {
        if (!this.realDesktopPauseHoldActive) return;
        this.drawRealDesktopHoldOverlay(
            context,
            point,
            this.realDesktopPauseHoldPercent,
            this.realDesktopPaused ? 'RESUME' : 'PAUSE'
        );
    }

    private drawRealDesktopHoldOverlay(context: CanvasRenderingContext2D, point: CanvasPoint, percent: number, label: string) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const radius = 28 * scale;
        const progress = this.clamp(percent / 100, 0, 1);

        context.save();
        context.translate(point.x, point.y);
        context.lineWidth = 4 * scale;
        context.strokeStyle = 'rgba(120, 174, 187, 0.34)';
        context.beginPath();
        context.arc(0, 0, radius, 0, Math.PI * 2);
        context.stroke();
        context.strokeStyle = 'rgba(114, 240, 198, 0.95)';
        context.shadowColor = 'rgba(114, 240, 198, 0.62)';
        context.shadowBlur = 14 * scale;
        context.beginPath();
        context.arc(0, 0, radius, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2);
        context.stroke();
        context.shadowBlur = 0;
        context.fillStyle = 'rgba(4, 10, 12, 0.72)';
        context.fillRect(-34 * scale, radius + 8 * scale, 68 * scale, 20 * scale);
        context.fillStyle = 'rgba(217, 255, 245, 0.96)';
        context.font = `${11 * scale}px "Courier New", monospace`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(`${label} ${Math.round(percent)}%`, 0, radius + 18 * scale);
        context.restore();
    }

    private drawRealDesktopDwellClickOverlay(context: CanvasRenderingContext2D, point: CanvasPoint) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas || this.realDesktopClickMode !== 'dwellClick') return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const radius = 24 * scale;
        const progress = this.clamp(this.realDesktopDwellClickProgress / 100, 0, 1);

        context.save();
        context.translate(point.x, point.y);
        context.lineWidth = 3 * scale;
        context.strokeStyle = 'rgba(120, 174, 187, 0.3)';
        context.beginPath();
        context.arc(0, 0, radius, 0, Math.PI * 2);
        context.stroke();
        context.strokeStyle = progress >= 1 ? 'rgba(255, 194, 92, 0.95)' : 'rgba(114, 240, 198, 0.95)';
        context.shadowColor = progress >= 1 ? 'rgba(255, 194, 92, 0.48)' : 'rgba(114, 240, 198, 0.52)';
        context.shadowBlur = 12 * scale;
        context.beginPath();
        context.arc(0, 0, radius, -Math.PI / 2, -Math.PI / 2 + progress * Math.PI * 2);
        context.stroke();
        context.shadowBlur = 0;
        context.fillStyle = 'rgba(4, 10, 12, 0.7)';
        context.fillRect(-40 * scale, radius + 7 * scale, 80 * scale, 20 * scale);
        context.fillStyle = 'rgba(217, 255, 245, 0.96)';
        context.font = `${10 * scale}px "Courier New", monospace`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(`DWELL ${this.realDesktopDwellClickPercent}%`, 0, radius + 17 * scale);
        context.restore();
    }

    private resolveRealDesktopPointerGesture(
        hand: HandFrame,
        handIndex: number,
        indexPoint: CanvasPoint,
        timestamp: number
    ): RealDesktopPointerGesture {
        const isIndexOnly = this.isRealDesktopIndexOnly(hand.landmarks);
        const wasPinch = this.realDesktopPinchActiveByHand[handIndex] || false;
        const isPinch = this.resolveRealDesktopPinch(hand.landmarks, handIndex, isIndexOnly);
        const pinchWasReady = this.realDesktopPinchReadyByHand[handIndex] || false;
        const pinchStarted = pinchWasReady && !wasPinch && isPinch;
        const dragState = this.updateRealDesktopDragArming(
            hand.trackId,
            indexPoint,
            timestamp,
            isPinch && pinchWasReady
        );

        if (!isPinch) {
            this.realDesktopPinchReadyByHand[handIndex] = true;
        }

        return {
            isIndexOnly,
            isPinch,
            pinchStarted,
            pinchReleased: wasPinch && !isPinch,
            dragArming: dragState.arming,
            dragReady: dragState.ready
        };
    }

    private updateRealDesktopDragArming(
        trackId: number,
        point: CanvasPoint,
        timestamp: number,
        canArm: boolean
    ): { arming: boolean; ready: boolean } {
        if (!canArm || this.realDesktopMouseDown) {
            this.resetRealDesktopDragArming();
            return { arming: false, ready: false };
        }

        const moveLimit = this.getRealDesktopDragArmMoveLimit();
        const shouldStart =
            this.realDesktopDragArmingTrackId !== trackId ||
            !this.realDesktopDragArmingPoint ||
            this.canvasDistance(this.realDesktopDragArmingPoint, point) > moveLimit;

        if (shouldStart) {
            this.realDesktopDragArmingTrackId = trackId;
            this.realDesktopDragArmingStartedAt = timestamp;
            this.realDesktopDragArmingPoint = point;
            return { arming: true, ready: false };
        }

        return {
            arming: true,
            ready: timestamp - this.realDesktopDragArmingStartedAt >= this.realDesktopDragArmDuration
        };
    }

    private resetRealDesktopDragArming() {
        this.realDesktopDragArmingTrackId = null;
        this.realDesktopDragArmingStartedAt = 0;
        this.realDesktopDragArmingPoint = null;
    }

    private isRealDesktopIndexOnly(landmarks: NormalizedLandmark[]): boolean {
        const metrics = this.measureIndexAim(landmarks);
        return metrics.indexExtended &&
            metrics.foldedFingers >= 2 &&
            metrics.extendedOtherFingers <= 1 &&
            this.getIndexAimConfidence(metrics) > 0;
    }

    private resolveRealDesktopPinch(
        landmarks: NormalizedLandmark[],
        handIndex: number,
        isIndexOnly: boolean
    ): boolean {
        const distance = this.getPinchDistance(landmarks);
        const wasActive = this.realDesktopPinchActiveByHand[handIndex] || false;
        const startThreshold = isIndexOnly ?
            this.realDesktopIndexOnlyPinchStartThreshold :
            this.realDesktopPinchStartThreshold;
        const endThreshold = isIndexOnly ?
            this.realDesktopIndexOnlyPinchEndThreshold :
            this.realDesktopPinchEndThreshold;

        if (!Number.isFinite(distance)) {
            this.realDesktopPinchActiveByHand[handIndex] = false;
        } else if (!wasActive && distance <= startThreshold) {
            this.realDesktopPinchActiveByHand[handIndex] = true;
        } else if (wasActive && distance >= endThreshold) {
            this.realDesktopPinchActiveByHand[handIndex] = false;
        } else {
            this.realDesktopPinchActiveByHand[handIndex] = wasActive;
        }

        return this.realDesktopPinchActiveByHand[handIndex] || false;
    }

    private updateRealDesktopPinchClickGesture(
        hand: HandFrame,
        indexPoint: CanvasPoint,
        screenPoint: CanvasPoint,
        gesture: RealDesktopPointerGesture,
        timestamp: number
    ): boolean {
        if (this.realDesktopClickMode !== 'pinchClick' || this.realDesktopMouseDown) {
            this.resetRealDesktopPinchClickState();
            return false;
        }

        if (gesture.isPinch) {
            if (this.realDesktopPinchClick.trackId !== hand.trackId || !this.realDesktopPinchClick.startPoint) {
                if (!gesture.pinchStarted) {
                    this.resetRealDesktopPinchClickState();
                    return false;
                }
                this.realDesktopPinchClick = {
                    trackId: hand.trackId,
                    startedAt: timestamp,
                    startPoint: { ...indexPoint },
                    startScreenPoint: { ...screenPoint },
                    blocked: false
                };
            }

            const elapsed = timestamp - this.realDesktopPinchClick.startedAt;
            const moved = this.realDesktopPinchClick.startPoint
                ? this.canvasDistance(this.realDesktopPinchClick.startPoint, indexPoint)
                : Number.POSITIVE_INFINITY;
            if (elapsed > this.realDesktopPinchClickMaxDuration ||
                moved > this.getRealDesktopPinchClickMoveLimit() ||
                gesture.dragReady) {
                this.realDesktopPinchClick.blocked = true;
            }
            this.resetRealDesktopDwellClickState();
            return false;
        }

        if (!gesture.pinchReleased || this.realDesktopPinchClick.trackId !== hand.trackId) {
            this.resetRealDesktopPinchClickState();
            return false;
        }

        const elapsed = timestamp - this.realDesktopPinchClick.startedAt;
        const clickPoint = this.realDesktopPinchClick.startScreenPoint || screenPoint;
        const canClick = !this.realDesktopPinchClick.blocked &&
            elapsed >= this.realDesktopPinchClickMinDuration &&
            elapsed <= this.realDesktopPinchClickMaxDuration;
        this.resetRealDesktopPinchClickState();

        if (!canClick) return false;

        this.sendRealDesktopClick(clickPoint, 'pinch click');
        this.resetRealDesktopDwellClickState();
        return true;
    }

    private updateRealDesktopDwellClickGesture(
        context: CanvasRenderingContext2D,
        hand: HandFrame,
        indexPoint: CanvasPoint,
        screenPoint: CanvasPoint,
        gesture: RealDesktopPointerGesture,
        clickAlreadySent: boolean,
        timestamp: number
    ): boolean {
        if (!this.canUseRealDesktopDwellClick(gesture, clickAlreadySent)) {
            this.resetRealDesktopDwellClickState();
            return false;
        }

        const moveLimit = this.getRealDesktopDwellClickMoveLimit();
        const resetLimit = this.getRealDesktopDwellClickResetMoveLimit();
        const state = this.realDesktopDwellClick;

        if (timestamp < state.cooldownUntil) {
            this.realDesktopDwellClickProgress = 0;
            return false;
        }

        const shouldRestart =
            state.trackId !== hand.trackId ||
            !state.anchorPoint ||
            this.canvasDistance(state.anchorPoint, indexPoint) > (state.clicked ? resetLimit : moveLimit);

        if (shouldRestart) {
            this.realDesktopDwellClick = {
                trackId: hand.trackId,
                startedAt: timestamp,
                anchorPoint: { ...indexPoint },
                anchorScreenPoint: { ...screenPoint },
                clicked: false,
                cooldownUntil: 0
            };
            this.realDesktopDwellClickProgress = 0;
            this.realDesktopDwellClickMessage = 'Dwell Click hold 0%';
            this.drawRealDesktopDwellClickOverlay(context, indexPoint);
            return false;
        }

        if (state.clicked) {
            this.realDesktopDwellClickProgress = 100;
            this.realDesktopDwellClickMessage = 'Dwell Click 완료 · 커서를 움직이면 재준비';
            this.drawRealDesktopDwellClickOverlay(context, indexPoint);
            return false;
        }

        const elapsed = Math.max(0, timestamp - state.startedAt);
        this.realDesktopDwellClickProgress = this.clamp(elapsed / this.realDesktopDwellClickDuration * 100, 0, 100);
        this.realDesktopDwellClickMessage = `Dwell Click hold ${this.realDesktopDwellClickPercent}%`;
        this.drawRealDesktopDwellClickOverlay(context, indexPoint);

        if (this.realDesktopDwellClickProgress < 100) return false;

        state.clicked = true;
        state.cooldownUntil = timestamp + this.realDesktopDwellClickCooldown;
        this.sendRealDesktopClick(state.anchorScreenPoint || screenPoint, 'dwell click');
        return true;
    }

    private canUseRealDesktopDwellClick(gesture: RealDesktopPointerGesture, clickAlreadySent: boolean): boolean {
        return this.realDesktopClickMode === 'dwellClick' &&
            this.realDesktopEnabled &&
            !this.realDesktopPaused &&
            !this.realDesktopCalibrationActive &&
            !this.realDesktopMouseDown &&
            !clickAlreadySent &&
            gesture.isIndexOnly &&
            !gesture.isPinch &&
            !gesture.dragArming &&
            !gesture.dragReady;
    }

    private getRealDesktopClickGestureStatus(sentDoubleClick: boolean, sentPinchClick: boolean, sentDwellClick: boolean): string {
        if (sentDoubleClick) return 'double tap';
        if (sentPinchClick) return 'pinch click';
        if (sentDwellClick) return 'dwell click';
        return '';
    }

    private getRealDesktopGestureStatus(gesture: RealDesktopPointerGesture, clickStatus: string): string {
        if (clickStatus) return clickStatus;
        if (this.realDesktopMouseDown) return 'pinch drag';
        if (this.realDesktopClickMode === 'pinchClick' && this.isRealDesktopPinchClickCandidate) return 'pinch click';
        if (this.realDesktopClickMode === 'dwellClick' && this.realDesktopDwellClickProgress >= 100) return 'dwell clicked';
        if (this.realDesktopClickMode === 'dwellClick' && this.realDesktopDwellClickProgress > 0) return 'dwell hold';
        if (gesture.dragArming) return 'drag hold';
        if (gesture.isPinch) return 'pinch hold';
        if (gesture.isIndexOnly) return 'index move';
        return 'inactive';
    }

    private pickRealDesktopControlHand(hands: HandFrame[]): { hand: HandFrame; handIndex: number } | null {
        if (this.realDesktopMouseDown && this.realDesktopActiveTrackId !== null) {
            const handIndex = hands.findIndex((hand) => hand.trackId === this.realDesktopActiveTrackId);
            if (handIndex >= 0) {
                return {
                    hand: hands[handIndex],
                    handIndex
                };
            }
            return null;
        }

        const handIndex = hands.findIndex((hand) => !!hand.points[8]);
        if (handIndex < 0) return null;

        return {
            hand: hands[handIndex],
            handIndex
        };
    }

    private getRealDesktopActiveTargetRegion(): RealDesktopScreen | null {
        const screen = this.realDesktopScreen;
        if (!screen || screen.width <= 0 || screen.height <= 0) return null;

        if (this.realDesktopTargetSettings.mode === 'current') {
            return this.getRealDesktopCurrentMonitorRegion(screen);
        }

        if (this.realDesktopTargetSettings.mode === 'custom') {
            return this.getRealDesktopCustomTargetRegion(screen);
        }

        return { ...screen };
    }

    private getRealDesktopCustomTargetRegion(screen: RealDesktopScreen): RealDesktopScreen {
        return this.constrainRealDesktopTargetRegion(this.realDesktopTargetSettings.custom, screen);
    }

    private getRealDesktopCurrentMonitorRegion(screen: RealDesktopScreen): RealDesktopScreen {
        const monitor = this.getRealDesktopBrowserMonitorSize(screen);
        if (!monitor) return { ...screen };

        const browserScreen = window.screen as Screen & {
            availLeft?: number;
            availTop?: number;
            left?: number;
            top?: number;
        };
        const originX = Number(browserScreen.availLeft ?? browserScreen.left);
        const originY = Number(browserScreen.availTop ?? browserScreen.top);

        if (Number.isFinite(originX) && Number.isFinite(originY)) {
            return this.constrainRealDesktopTargetRegion({
                x: Math.round(originX * monitor.scale),
                y: Math.round(originY * monitor.scale),
                width: monitor.width,
                height: monitor.height
            }, screen);
        }

        const center = this.getRealDesktopBrowserCenterPoint(screen, monitor);
        const maxColumn = Math.max(0, Math.ceil(screen.width / monitor.width) - 1);
        const maxRow = Math.max(0, Math.ceil(screen.height / monitor.height) - 1);
        const column = Math.round(this.clamp(
            Math.floor((center.x - screen.x) / monitor.width),
            0,
            maxColumn
        ));
        const row = Math.round(this.clamp(
            Math.floor((center.y - screen.y) / monitor.height),
            0,
            maxRow
        ));

        return this.constrainRealDesktopTargetRegion({
            x: screen.x + column * monitor.width,
            y: screen.y + row * monitor.height,
            width: monitor.width,
            height: monitor.height
        }, screen);
    }

    private getRealDesktopBrowserMonitorSize(screen: RealDesktopScreen): RealDesktopMonitorEstimate | null {
        if (typeof window === 'undefined' || !window.screen) return null;

        const cssWidth = Number(window.screen.width);
        const cssHeight = Number(window.screen.height);
        if (!Number.isFinite(cssWidth) || !Number.isFinite(cssHeight) || cssWidth <= 0 || cssHeight <= 0) return null;

        const pixelRatio = this.clamp(Number(window.devicePixelRatio) || 1, 1, 4);
        const scaledWidth = Math.round(cssWidth * pixelRatio);
        const scaledHeight = Math.round(cssHeight * pixelRatio);
        const cssFits = cssWidth <= screen.width + 2 && cssHeight <= screen.height + 2;
        const scaledFits = scaledWidth <= screen.width + 2 && scaledHeight <= screen.height + 2;
        const cssDelta = Math.abs(screen.width - cssWidth) + Math.abs(screen.height - cssHeight);
        const scaledDelta = Math.abs(screen.width - scaledWidth) + Math.abs(screen.height - scaledHeight);
        const useScaled = scaledFits && (!cssFits || scaledDelta < cssDelta * 0.6);
        const scale = useScaled ? pixelRatio : 1;

        return {
            width: Math.max(1, Math.round(useScaled ? scaledWidth : cssWidth)),
            height: Math.max(1, Math.round(useScaled ? scaledHeight : cssHeight)),
            scale
        };
    }

    private getRealDesktopBrowserCenterPoint(screen: RealDesktopScreen, monitor: RealDesktopMonitorEstimate): CanvasPoint {
        if (typeof window === 'undefined') {
            return {
                x: screen.x + screen.width / 2,
                y: screen.y + screen.height / 2
            };
        }

        const outerWidth = Number(window.outerWidth);
        const outerHeight = Number(window.outerHeight);
        const windowX = Number(window.screenX);
        const windowY = Number(window.screenY);
        const width = Number.isFinite(outerWidth) && outerWidth > 0 ? outerWidth : monitor.width / monitor.scale;
        const height = Number.isFinite(outerHeight) && outerHeight > 0 ? outerHeight : monitor.height / monitor.scale;
        const x = Number.isFinite(windowX) ? windowX : screen.x / monitor.scale;
        const y = Number.isFinite(windowY) ? windowY : screen.y / monitor.scale;

        return {
            x: Math.round((x + width / 2) * monitor.scale),
            y: Math.round((y + height / 2) * monitor.scale)
        };
    }

    private normalizeRealDesktopRegion(region: Partial<RealDesktopScreen> | null | undefined): RealDesktopScreen {
        const fallback = this.realDesktopTargetSettingsDefaults.custom;
        const x = Number(region?.x);
        const y = Number(region?.y);
        const width = Number(region?.width);
        const height = Number(region?.height);

        return {
            x: Math.round(this.clamp(Number.isFinite(x) ? x : fallback.x, -32768, 32768)),
            y: Math.round(this.clamp(Number.isFinite(y) ? y : fallback.y, -32768, 32768)),
            width: Math.round(this.clamp(Number.isFinite(width) ? width : fallback.width, 0, 32768)),
            height: Math.round(this.clamp(Number.isFinite(height) ? height : fallback.height, 0, 32768))
        };
    }

    private constrainRealDesktopTargetRegion(region: Partial<RealDesktopScreen> | null | undefined, screen: RealDesktopScreen): RealDesktopScreen {
        const normalized = this.normalizeRealDesktopRegion(region);
        const maxWidth = Math.max(1, Math.round(screen.width));
        const maxHeight = Math.max(1, Math.round(screen.height));
        const width = Math.round(this.clamp(normalized.width > 0 ? normalized.width : maxWidth, 1, maxWidth));
        const height = Math.round(this.clamp(normalized.height > 0 ? normalized.height : maxHeight, 1, maxHeight));
        const minX = Math.round(screen.x);
        const minY = Math.round(screen.y);
        const maxX = Math.round(screen.x + screen.width - width);
        const maxY = Math.round(screen.y + screen.height - height);

        return {
            x: Math.round(this.clamp(normalized.x, minX, Math.max(minX, maxX))),
            y: Math.round(this.clamp(normalized.y, minY, Math.max(minY, maxY))),
            width,
            height
        };
    }

    private ensureRealDesktopTargetCustomRegion(screen: RealDesktopScreen | null) {
        this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings(this.realDesktopTargetSettings);
        if (!screen || screen.width <= 0 || screen.height <= 0) return;

        const custom = this.realDesktopTargetSettings.custom;
        const nextCustom = custom.width <= 0 || custom.height <= 0
            ? { ...screen }
            : this.constrainRealDesktopTargetRegion(custom, screen);
        if (
            nextCustom.x === custom.x &&
            nextCustom.y === custom.y &&
            nextCustom.width === custom.width &&
            nextCustom.height === custom.height
        ) return;

        this.realDesktopTargetSettings = {
            ...this.realDesktopTargetSettings,
            custom: nextCustom
        };
        this.saveRealDesktopTargetSettings();
    }

    private formatRealDesktopRegion(region: RealDesktopScreen): string {
        const width = Math.round(region.width);
        const height = Math.round(region.height);
        const originX = Math.round(region.x);
        const originY = Math.round(region.y);
        return originX || originY
            ? `${width} × ${height} @ ${originX},${originY}`
            : `${width} × ${height}`;
    }

    private mapCanvasPointToScreen(point: CanvasPoint, applyCalibration: boolean = true): CanvasPoint | null {
        const canvas = this.effectCanvas?.nativeElement;
        const targetRegion = this.getRealDesktopActiveTargetRegion();
        if (!canvas || !targetRegion || targetRegion.width <= 0 || targetRegion.height <= 0) return null;

        const rawPoint = this.canvasPointToNormalized(point);
        const calibratedPoint = applyCalibration ? this.applyRealDesktopCalibration(rawPoint) : rawPoint;
        const xRatio = this.clamp(calibratedPoint.x, 0, 1);
        const yRatio = this.clamp(calibratedPoint.y, 0, 1);

        return {
            x: Math.round(targetRegion.x + xRatio * targetRegion.width),
            y: Math.round(targetRegion.y + yRatio * targetRegion.height)
        };
    }

    private canvasPointToNormalized(point: CanvasPoint): CanvasPoint {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas || canvas.width <= 0 || canvas.height <= 0) return { x: 0, y: 0 };

        return {
            x: this.clamp(point.x / canvas.width, 0, 1),
            y: this.clamp(point.y / canvas.height, 0, 1)
        };
    }

    private applyRealDesktopCalibration(point: CanvasPoint): CanvasPoint {
        const transform = this.realDesktopCalibration?.transform;
        if (!transform) return point;

        const x = transform.x[0] * point.x + transform.x[1] * point.y + transform.x[2];
        const y = transform.y[0] * point.x + transform.y[1] * point.y + transform.y[2];

        if (!Number.isFinite(x) || !Number.isFinite(y)) return point;

        return {
            x: this.clamp(x, 0, 1),
            y: this.clamp(y, 0, 1)
        };
    }

    private applyRealDesktopPointerSettings(rawPoint: CanvasPoint): CanvasPoint {
        const raw = this.clampRealDesktopScreenPoint(rawPoint);

        if (!this.realDesktopPointerRawAnchor || !this.realDesktopPointerOutputPoint) {
            const output = this.realDesktopPointerOutputPoint
                ? this.clampRealDesktopScreenPoint(this.realDesktopPointerOutputPoint)
                : raw;
            this.realDesktopPointerRawAnchor = raw;
            this.realDesktopPointerOutputPoint = output;
            return output;
        }

        const delta = {
            x: raw.x - this.realDesktopPointerRawAnchor.x,
            y: raw.y - this.realDesktopPointerRawAnchor.y
        };
        const distance = Math.hypot(delta.x, delta.y);
        const deadZone = this.realDesktopPointerSettings.deadZone;

        if (distance < deadZone) {
            return this.realDesktopPointerOutputPoint;
        }

        const target = {
            x: this.realDesktopPointerOutputPoint.x + delta.x * this.realDesktopPointerSettings.sensitivity,
            y: this.realDesktopPointerOutputPoint.y + delta.y * this.realDesktopPointerSettings.sensitivity
        };
        const smoothingRatio = this.clamp(this.realDesktopPointerSettings.smoothing / 100, 0, 1);
        const interpolation = 1 - smoothingRatio * 0.82;
        const nextPoint = this.clampRealDesktopScreenPoint({
            x: this.lerp(this.realDesktopPointerOutputPoint.x, target.x, interpolation),
            y: this.lerp(this.realDesktopPointerOutputPoint.y, target.y, interpolation)
        });

        this.realDesktopPointerRawAnchor = raw;
        this.realDesktopPointerOutputPoint = nextPoint;
        return nextPoint;
    }

    private clampRealDesktopScreenPoint(point: CanvasPoint): CanvasPoint {
        const targetRegion = this.getRealDesktopActiveTargetRegion();
        if (!targetRegion || targetRegion.width <= 0 || targetRegion.height <= 0) {
            return {
                x: Math.round(point.x),
                y: Math.round(point.y)
            };
        }

        return {
            x: Math.round(this.clamp(point.x, targetRegion.x, targetRegion.x + targetRegion.width)),
            y: Math.round(this.clamp(point.y, targetRegion.y, targetRegion.y + targetRegion.height))
        };
    }

    private resetRealDesktopPointerSettingsFilter() {
        this.realDesktopPointerRawAnchor = null;
        this.realDesktopPointerOutputPoint = null;
    }

    private anchorRealDesktopPointerSettingsToNextSample() {
        this.realDesktopPointerRawAnchor = null;
    }

    private handleRealDesktopCalibrationFrame(
        context: CanvasRenderingContext2D,
        point: CanvasPoint,
        screenPoint: CanvasPoint
    ) {
        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(true);
        this.queueRealDesktopCommand({ type: 'move', x: screenPoint.x, y: screenPoint.y });
        this.drawRealDesktopCalibrationOverlay(context, point);
        this.setRealDesktopStatus('moving', `${this.realDesktopCalibrationProgressLabel} 지점 보정 중`);
    }

    private drawRealDesktopCalibrationOverlay(context: CanvasRenderingContext2D, point: CanvasPoint) {
        const canvas = this.effectCanvas?.nativeElement;
        const target = this.getCurrentRealDesktopCalibrationTarget();
        if (!canvas || !target) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const margin = 30 * scale;
        const targetX = this.clamp(target.target.x * canvas.width, margin, canvas.width - margin);
        const targetY = this.clamp(target.target.y * canvas.height, margin, canvas.height - margin);
        const radius = 18 * scale;

        context.save();
        context.lineWidth = 2 * scale;
        context.strokeStyle = 'rgba(217, 255, 245, 0.94)';
        context.fillStyle = 'rgba(4, 10, 12, 0.72)';
        context.shadowColor = 'rgba(114, 240, 198, 0.72)';
        context.shadowBlur = 18 * scale;
        context.beginPath();
        context.arc(targetX, targetY, radius, 0, Math.PI * 2);
        context.stroke();
        context.beginPath();
        context.moveTo(targetX - radius - 10 * scale, targetY);
        context.lineTo(targetX + radius + 10 * scale, targetY);
        context.moveTo(targetX, targetY - radius - 10 * scale);
        context.lineTo(targetX, targetY + radius + 10 * scale);
        context.stroke();
        context.shadowBlur = 0;
        context.beginPath();
        context.arc(point.x, point.y, 5 * scale, 0, Math.PI * 2);
        context.fillStyle = 'rgba(114, 240, 198, 0.92)';
        context.fill();
        context.font = `${12 * scale}px "Courier New", monospace`;
        context.textBaseline = 'top';
        context.fillStyle = 'rgba(4, 10, 12, 0.78)';
        context.fillRect(targetX + 12 * scale, targetY + 12 * scale, 112 * scale, 24 * scale);
        context.fillStyle = 'rgba(217, 255, 245, 0.96)';
        context.fillText(`${this.realDesktopCalibrationStepIndex + 1}/5 ${target.label}`, targetX + 18 * scale, targetY + 18 * scale);
        context.restore();
    }

    private drawRealDesktopPointer(context: CanvasRenderingContext2D, point: CanvasPoint, screenPoint: CanvasPoint) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const radius = (this.realDesktopMouseDown ? 18 : 13) * scale;

        context.save();
        context.translate(point.x, point.y);
        context.shadowColor = this.realDesktopMouseDown ? 'rgba(114, 240, 198, 0.74)' : 'rgba(88, 196, 255, 0.55)';
        context.shadowBlur = 16 * scale;
        context.strokeStyle = this.realDesktopMouseDown ? 'rgba(114, 240, 198, 0.95)' : 'rgba(156, 219, 255, 0.88)';
        context.lineWidth = 2 * scale;
        context.beginPath();
        context.arc(0, 0, radius, 0, Math.PI * 2);
        context.stroke();
        context.beginPath();
        context.moveTo(-radius - 6 * scale, 0);
        context.lineTo(-radius + 3 * scale, 0);
        context.moveTo(radius - 3 * scale, 0);
        context.lineTo(radius + 6 * scale, 0);
        context.moveTo(0, -radius - 6 * scale);
        context.lineTo(0, -radius + 3 * scale);
        context.moveTo(0, radius - 3 * scale);
        context.lineTo(0, radius + 6 * scale);
        context.stroke();
        context.shadowBlur = 0;
        context.fillStyle = 'rgba(8, 12, 12, 0.72)';
        context.font = `${10 * scale}px "Courier New", monospace`;
        context.textBaseline = 'top';
        context.fillText(`${screenPoint.x},${screenPoint.y}`, 10 * scale, 10 * scale);
        context.restore();
    }

    private updateRealDesktopTapGesture(
        hand: HandFrame,
        indexPoint: CanvasPoint,
        screenPoint: CanvasPoint,
        isIndexOnly: boolean,
        isPinch: boolean,
        timestamp: number
    ): boolean {
        if (this.realDesktopMouseDown || isPinch) {
            this.resetRealDesktopTapCurrent(false);
            return false;
        }

        if (this.realDesktopTap.trackId !== null && this.realDesktopTap.trackId !== hand.trackId) {
            this.resetRealDesktopTapCurrent(false);
        }

        if (!isIndexOnly) {
            const sentDoubleClick = this.tryCompleteRealDesktopStillReleaseTap(timestamp);
            this.resetRealDesktopTapCurrent(true);
            return sentDoubleClick;
        }

        const tap = this.realDesktopTap;
        const z = hand.landmarks[8]?.z || 0;
        const stableMoveLimit = this.getRealDesktopStableMoveLimit();

        tap.trackId = hand.trackId;
        tap.lastIndexOnlyAt = timestamp;
        tap.lastIndexPoint = indexPoint;
        tap.lastScreenPoint = screenPoint;

        if (!tap.stablePoint || this.canvasDistance(tap.stablePoint, indexPoint) > stableMoveLimit) {
            tap.stableStartedAt = timestamp;
            tap.stablePoint = indexPoint;
        }

        if (tap.baselineZ === null) {
            tap.baselineZ = z;
        }

        if (tap.phase === 'depthPressed') {
            return this.tryCompleteRealDesktopDepthTap(indexPoint, screenPoint, z, timestamp);
        }

        const depthDelta = Math.abs(z - tap.baselineZ);
        if (depthDelta >= this.realDesktopTapDepthPressDelta) {
            tap.phase = 'depthPressed';
            tap.pressStartedAt = timestamp;
            tap.pressPoint = indexPoint;
            return false;
        }

        tap.baselineZ = this.lerp(tap.baselineZ, z, 0.12);
        return false;
    }

    private tryCompleteRealDesktopDepthTap(
        indexPoint: CanvasPoint,
        screenPoint: CanvasPoint,
        indexZ: number,
        timestamp: number
    ): boolean {
        const tap = this.realDesktopTap;
        const pressDuration = timestamp - tap.pressStartedAt;
        const pressMove = tap.pressPoint ? this.canvasDistance(tap.pressPoint, indexPoint) : Number.POSITIVE_INFINITY;
        const depthDelta = Math.abs(indexZ - (tap.baselineZ ?? indexZ));

        if (pressDuration > this.realDesktopTapPressMaxDuration ||
            pressMove > this.getRealDesktopTapMoveLimit()) {
            this.resetRealDesktopTapCurrent(true);
            return false;
        }

        if (pressDuration >= this.realDesktopTapPressMinDuration &&
            depthDelta <= this.realDesktopTapDepthReleaseDelta) {
            return this.registerRealDesktopTap(screenPoint, indexPoint, timestamp);
        }

        return false;
    }

    private tryCompleteRealDesktopStillReleaseTap(timestamp: number): boolean {
        const tap = this.realDesktopTap;
        if (!tap.stablePoint || !tap.lastIndexPoint || !tap.lastScreenPoint) return false;

        const stableDuration = timestamp - tap.stableStartedAt;
        const releaseDelay = timestamp - tap.lastIndexOnlyAt;
        const stableMove = this.canvasDistance(tap.stablePoint, tap.lastIndexPoint);

        if (stableDuration >= this.realDesktopTapStableMinDuration &&
            stableDuration <= this.realDesktopTapStableMaxDuration &&
            releaseDelay <= this.realDesktopTapReleaseGraceMs &&
            stableMove <= this.getRealDesktopStableMoveLimit()) {
            return this.registerRealDesktopTap(tap.lastScreenPoint, tap.lastIndexPoint, timestamp);
        }

        return false;
    }

    private registerRealDesktopTap(screenPoint: CanvasPoint, canvasPoint: CanvasPoint, timestamp: number): boolean {
        const previousTapAt = this.realDesktopTap.lastTapAt;
        const previousTapPoint = this.realDesktopTap.lastTapPoint;
        const isDoubleTap = previousTapAt > 0 &&
            timestamp - previousTapAt <= this.realDesktopDoubleTapMaxInterval &&
            !!previousTapPoint &&
            this.canvasDistance(previousTapPoint, canvasPoint) <= this.getRealDesktopDoubleTapMoveLimit();

        if (isDoubleTap) {
            this.sendRealDesktopDoubleClick(screenPoint);
            this.resetRealDesktopTapCurrent(false);
            return true;
        }

        this.realDesktopTap.lastTapAt = timestamp;
        this.realDesktopTap.lastTapPoint = canvasPoint;
        this.resetRealDesktopTapCurrent(true);
        return false;
    }

    private sendRealDesktopDoubleClick(screenPoint: CanvasPoint) {
        this.clearPendingRealDesktopMove();
        this.queueRealDesktopCommand({ type: 'down', x: screenPoint.x, y: screenPoint.y, reason: 'double tap' }, true);
        this.queueRealDesktopCommand({ type: 'up', x: screenPoint.x, y: screenPoint.y, reason: 'double tap' }, true);
        this.queueRealDesktopCommand({ type: 'down', x: screenPoint.x, y: screenPoint.y, reason: 'double tap' }, true);
        this.queueRealDesktopCommand({ type: 'up', x: screenPoint.x, y: screenPoint.y, reason: 'double tap' }, true);
    }

    private sendRealDesktopClick(screenPoint: CanvasPoint, reason: string) {
        this.clearPendingRealDesktopMove();
        this.queueRealDesktopCommand({ type: 'down', x: screenPoint.x, y: screenPoint.y, reason }, true);
        this.queueRealDesktopCommand({ type: 'up', x: screenPoint.x, y: screenPoint.y, reason }, true);
    }

    private resetRealDesktopTapCurrent(keepLastTap: boolean) {
        const lastTapAt = keepLastTap ? this.realDesktopTap.lastTapAt : 0;
        const lastTapPoint = keepLastTap ? this.realDesktopTap.lastTapPoint : null;

        this.realDesktopTap = {
            trackId: null,
            phase: 'idle',
            baselineZ: null,
            pressStartedAt: 0,
            pressPoint: null,
            stableStartedAt: 0,
            stablePoint: null,
            lastIndexOnlyAt: 0,
            lastIndexPoint: null,
            lastScreenPoint: null,
            lastTapAt,
            lastTapPoint
        };
    }

    private resetRealDesktopClickGestureState(keepLastTap: boolean) {
        this.resetRealDesktopTapCurrent(keepLastTap && this.realDesktopClickMode === 'doubleTap');
        this.resetRealDesktopPinchClickState();
        this.resetRealDesktopDwellClickState();
    }

    private resetRealDesktopPinchClickState() {
        this.realDesktopPinchClick = {
            trackId: null,
            startedAt: 0,
            startPoint: null,
            startScreenPoint: null,
            blocked: false
        };
    }

    private resetRealDesktopDwellClickState() {
        this.realDesktopDwellClick = {
            trackId: null,
            startedAt: 0,
            anchorPoint: null,
            anchorScreenPoint: null,
            clicked: false,
            cooldownUntil: 0
        };
        this.realDesktopDwellClickProgress = 0;
        this.realDesktopDwellClickMessage = 'Dwell Click 대기';
    }

    private getRealDesktopStableMoveLimit(): number {
        return Math.max(7, this.getCanvasBase() * 0.008);
    }

    private getRealDesktopEnableHoldMoveLimit(): number {
        return Math.max(28, this.getCanvasBase() * 0.04);
    }

    private getRealDesktopPauseHoldMoveLimit(): number {
        return Math.max(24, this.getCanvasBase() * 0.035);
    }

    private getRealDesktopTapMoveLimit(): number {
        return Math.max(24, this.getCanvasBase() * 0.035);
    }

    private getRealDesktopDragArmMoveLimit(): number {
        return Math.max(18, this.getCanvasBase() * 0.026);
    }

    private getRealDesktopDoubleTapMoveLimit(): number {
        return Math.max(36, this.getCanvasBase() * 0.055);
    }

    private getRealDesktopPinchClickMoveLimit(): number {
        return Math.max(20, this.getCanvasBase() * 0.028);
    }

    private getRealDesktopDwellClickMoveLimit(): number {
        return Math.max(14, this.getCanvasBase() * 0.018);
    }

    private getRealDesktopDwellClickResetMoveLimit(): number {
        return Math.max(32, this.getCanvasBase() * 0.05);
    }

    private releaseRealDesktopMouse(reason: string) {
        this.clearPendingRealDesktopMove();

        if (this.realDesktopMouseDown) {
            this.queueRealDesktopCommand({
                type: 'up',
                x: this.realDesktopLastScreenPoint?.x,
                y: this.realDesktopLastScreenPoint?.y,
                reason
            }, true);
        }

        this.realDesktopMouseDown = false;
        this.realDesktopActiveTrackId = null;
        this.realDesktopLastDragScreenPoint = null;
        this.resetRealDesktopPointerSettingsFilter();
        this.resetRealDesktopClickGestureState(false);
        this.setRealDesktopStatus(this.realDesktopPaused ? 'paused' : this.realDesktopEnabled ? 'ready' : this.realDesktopState, reason);
    }

    private queueRealDesktopCommand(command: RealDesktopCommand, urgent: boolean = false) {
        if (!this.shouldSendRealDesktopCommand(command)) return;

        if (!urgent && (command.type === 'move' || command.type === 'drag')) {
            this.realDesktopPendingMoveCommand = command;
            if (!this.realDesktopMoveFlushTimer) {
                this.realDesktopMoveFlushTimer = window.setTimeout(() => {
                    const nextCommand = this.realDesktopPendingMoveCommand;
                    this.realDesktopPendingMoveCommand = null;
                    this.realDesktopMoveFlushTimer = 0;
                    if (nextCommand) this.enqueueRealDesktopCommand(nextCommand);
                }, 32);
            }
            return;
        }

        this.enqueueRealDesktopCommand(command);
    }

    private enqueueRealDesktopCommand(command: RealDesktopCommand) {
        this.realDesktopCommandChain = this.realDesktopCommandChain
            .catch(() => undefined)
            .then(() => this.postRealDesktopCommand(command));
    }

    private async postRealDesktopCommand(command: RealDesktopCommand) {
        try {
            const response = await fetch(this.getRealDesktopControllerEndpoint('/event'), {
                method: 'POST',
                cache: 'no-store',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...command,
                    sequence: ++this.realDesktopCommandSequence,
                    source: 'wandless-browser',
                    timestamp: Date.now()
                })
            });
            const status = await response.json() as RealDesktopControllerStatus;
            if (!response.ok || status.ok === false) {
                throw new Error(status.error || status.message || `HTTP_${response.status}`);
            }
            this.applyRealDesktopControllerStatus(status);
        } catch (error) {
            this.clearPendingRealDesktopMove();
            this.realDesktopEnabled = false;
            this.realDesktopPaused = false;
            this.realDesktopMouseDown = false;
            this.realDesktopActiveTrackId = null;
            this.resetRealDesktopPauseHold();
            this.resetRealDesktopClickGestureState(false);
            this.setRealDesktopStatus('error', '로컬 컨트롤러 전송 실패로 제어를 중지했습니다.');
            this.updateDetectionState(this.handStatus, 'inactive', this.realDesktopStatus);
        }
    }

    private shouldSendRealDesktopCommand(command: RealDesktopCommand): boolean {
        if (command.type === 'stop' || command.type === 'up') return true;
        if (this.realDesktopPaused) return false;
        return this.realDesktopEnabled && this.activeMode === 'realDesktop';
    }

    private clearPendingRealDesktopMove() {
        if (this.realDesktopMoveFlushTimer) {
            window.clearTimeout(this.realDesktopMoveFlushTimer);
            this.realDesktopMoveFlushTimer = 0;
        }
        this.realDesktopPendingMoveCommand = null;
    }

    private applyRealDesktopTargetSettingsChange(releaseReason: string) {
        this.clearPendingRealDesktopMove();
        if (this.realDesktopCalibrationActive) {
            this.clearRealDesktopCalibrationSession();
        }
        if (this.realDesktopMouseDown) {
            this.releaseRealDesktopMouse(releaseReason);
        }

        this.resetRealDesktopPointerSettingsFilter();
        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(false);
        this.saveRealDesktopTargetSettings();
    }

    private applyRealDesktopControllerStatus(status: RealDesktopControllerStatus) {
        if (status.screen) {
            const previousScreen = this.realDesktopScreen;
            const screenChanged = !previousScreen ||
                previousScreen.x !== status.screen.x ||
                previousScreen.y !== status.screen.y ||
                previousScreen.width !== status.screen.width ||
                previousScreen.height !== status.screen.height;
            this.realDesktopScreen = status.screen;
            if (screenChanged) {
                this.resetRealDesktopPointerSettingsFilter();
            }
            this.ensureRealDesktopTargetCustomRegion(status.screen);
            const width = Math.round(status.screen.width);
            const height = Math.round(status.screen.height);
            const originX = Math.round(status.screen.x || 0);
            const originY = Math.round(status.screen.y || 0);
            this.realDesktopScreenLabel = originX || originY
                ? `${width} × ${height} @ ${originX},${originY}`
                : `${width} × ${height}`;
        }
    }

    private getCurrentRealDesktopCalibrationTarget(): RealDesktopCalibrationTarget | null {
        return this.realDesktopCalibrationTargets[this.realDesktopCalibrationStepIndex] || null;
    }

    private loadRealDesktopPointerSettings() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            const raw = storage.getItem(this.realDesktopPointerSettingsStorageKey);
            if (!raw) {
                this.realDesktopPointerSettings = { ...this.realDesktopPointerSettingsDefaults };
                return;
            }

            const parsed = JSON.parse(raw) as Partial<RealDesktopPointerSettings>;
            this.realDesktopPointerSettings = this.normalizeRealDesktopPointerSettings(parsed);
        } catch (error) {
            this.realDesktopPointerSettings = { ...this.realDesktopPointerSettingsDefaults };
        }
    }

    private saveRealDesktopPointerSettings() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            storage.setItem(this.realDesktopPointerSettingsStorageKey, JSON.stringify(this.realDesktopPointerSettings));
        } catch (error) {
            // Settings still apply for the current tab when storage is unavailable.
        }
    }

    private normalizeRealDesktopPointerSettings(settings: Partial<RealDesktopPointerSettings> | null): RealDesktopPointerSettings {
        const sensitivity = Number(settings?.sensitivity);
        const deadZone = Number(settings?.deadZone);
        const smoothing = Number(settings?.smoothing);

        return {
            sensitivity: Math.round(this.clamp(Number.isFinite(sensitivity) ? sensitivity : this.realDesktopPointerSettingsDefaults.sensitivity, 0.5, 2) * 100) / 100,
            deadZone: Math.round(this.clamp(Number.isFinite(deadZone) ? deadZone : this.realDesktopPointerSettingsDefaults.deadZone, 0, 24)),
            smoothing: Math.round(this.clamp(Number.isFinite(smoothing) ? smoothing : this.realDesktopPointerSettingsDefaults.smoothing, 0, 90))
        };
    }

    private loadRealDesktopTargetSettings() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            const raw = storage.getItem(this.realDesktopTargetSettingsStorageKey);
            if (!raw) {
                this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings(this.realDesktopTargetSettingsDefaults);
                return;
            }

            const parsed = JSON.parse(raw) as Partial<RealDesktopTargetSettings>;
            this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings(parsed);
        } catch (error) {
            this.realDesktopTargetSettings = this.normalizeRealDesktopTargetSettings(this.realDesktopTargetSettingsDefaults);
        }
    }

    private saveRealDesktopTargetSettings() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            storage.setItem(this.realDesktopTargetSettingsStorageKey, JSON.stringify(this.realDesktopTargetSettings));
        } catch (error) {
            // Target mode still applies for the current tab when storage is unavailable.
        }
    }

    private normalizeRealDesktopTargetSettings(settings: Partial<RealDesktopTargetSettings> | null): RealDesktopTargetSettings {
        const mode = this.realDesktopTargetModeOptions.some((option) => option.id === settings?.mode)
            ? (settings?.mode as RealDesktopTargetMode)
            : this.realDesktopTargetSettingsDefaults.mode;

        return {
            mode,
            custom: this.normalizeRealDesktopRegion(settings?.custom || this.realDesktopTargetSettingsDefaults.custom)
        };
    }

    private loadRealDesktopClickMode() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            this.realDesktopClickMode = this.normalizeRealDesktopClickMode(storage.getItem(this.realDesktopClickModeStorageKey));
        } catch (error) {
            this.realDesktopClickMode = 'doubleTap';
        }
    }

    private saveRealDesktopClickMode() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            storage.setItem(this.realDesktopClickModeStorageKey, this.realDesktopClickMode);
        } catch (error) {
            // Click mode still applies for the current tab when storage is unavailable.
        }
    }

    private normalizeRealDesktopClickMode(value: string | null | undefined): RealDesktopClickMode {
        return this.realDesktopClickModeOptions.some((option) => option.id === value)
            ? (value as RealDesktopClickMode)
            : 'doubleTap';
    }

    private clearRealDesktopCalibrationSession() {
        this.realDesktopCalibrationActive = false;
        this.realDesktopCalibrationStepIndex = 0;
        this.realDesktopCalibrationDraft = [];
        this.realDesktopCalibrationCurrentObservedPoint = null;
    }

    private loadRealDesktopCalibration() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            const raw = storage.getItem(this.realDesktopCalibrationStorageKey);
            if (!raw) return;

            const parsed = JSON.parse(raw) as RealDesktopCalibrationData;
            if (this.isValidRealDesktopCalibration(parsed)) {
                this.realDesktopCalibration = parsed;
            }
        } catch (error) {
            this.realDesktopCalibration = null;
        }
    }

    private saveRealDesktopCalibration() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage || !this.realDesktopCalibration) return;

        try {
            storage.setItem(this.realDesktopCalibrationStorageKey, JSON.stringify(this.realDesktopCalibration));
        } catch (error) {
            // Calibration still applies for the current tab when storage is unavailable.
        }
    }

    private removeStoredRealDesktopCalibration() {
        const storage = this.getRealDesktopLocalStorage();
        if (!storage) return;

        try {
            storage.removeItem(this.realDesktopCalibrationStorageKey);
        } catch (error) {
            // Ignore storage failures; in-memory calibration has already been cleared.
        }
    }

    private getRealDesktopLocalStorage(): Storage | null {
        if (typeof window === 'undefined') return null;

        try {
            return window.localStorage || null;
        } catch (error) {
            return null;
        }
    }

    private isValidRealDesktopCalibration(value: RealDesktopCalibrationData | null): value is RealDesktopCalibrationData {
        if (!value || value.version !== 1 || !Array.isArray(value.samples) || value.samples.length < 3) return false;
        return this.isValidRealDesktopCalibrationTransform(value.transform);
    }

    private isValidRealDesktopCalibrationTransform(transform: RealDesktopCalibrationTransform | null): transform is RealDesktopCalibrationTransform {
        return !!transform &&
            Array.isArray(transform.x) &&
            Array.isArray(transform.y) &&
            transform.x.length === 3 &&
            transform.y.length === 3 &&
            transform.x.every((value) => Number.isFinite(value)) &&
            transform.y.every((value) => Number.isFinite(value));
    }

    private computeRealDesktopCalibrationTransform(samples: RealDesktopCalibrationSample[]): RealDesktopCalibrationTransform | null {
        if (samples.length < 3) return null;

        const x = this.solveRealDesktopCalibrationAxis(samples, 'x');
        const y = this.solveRealDesktopCalibrationAxis(samples, 'y');
        if (!x || !y) return null;

        return { x, y };
    }

    private solveRealDesktopCalibrationAxis(
        samples: RealDesktopCalibrationSample[],
        axis: 'x' | 'y'
    ): [number, number, number] | null {
        const matrix = [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
        ];
        const vector = [0, 0, 0];

        samples.forEach((sample) => {
            const row = [sample.observed.x, sample.observed.y, 1];
            const target = sample.target[axis];

            for (let rowIndex = 0; rowIndex < 3; rowIndex++) {
                vector[rowIndex] += row[rowIndex] * target;
                for (let columnIndex = 0; columnIndex < 3; columnIndex++) {
                    matrix[rowIndex][columnIndex] += row[rowIndex] * row[columnIndex];
                }
            }
        });

        return this.solveRealDesktopCalibrationLinearSystem(matrix, vector);
    }

    private solveRealDesktopCalibrationLinearSystem(matrix: number[][], vector: number[]): [number, number, number] | null {
        const augmented = matrix.map((row, index) => [...row, vector[index]]);

        for (let column = 0; column < 3; column++) {
            let pivotRow = column;
            for (let row = column + 1; row < 3; row++) {
                if (Math.abs(augmented[row][column]) > Math.abs(augmented[pivotRow][column])) {
                    pivotRow = row;
                }
            }

            if (Math.abs(augmented[pivotRow][column]) < 1e-8) return null;

            if (pivotRow !== column) {
                const swap = augmented[column];
                augmented[column] = augmented[pivotRow];
                augmented[pivotRow] = swap;
            }

            const pivot = augmented[column][column];
            for (let cell = column; cell < 4; cell++) {
                augmented[column][cell] /= pivot;
            }

            for (let row = 0; row < 3; row++) {
                if (row === column) continue;

                const factor = augmented[row][column];
                for (let cell = column; cell < 4; cell++) {
                    augmented[row][cell] -= factor * augmented[column][cell];
                }
            }
        }

        const result: [number, number, number] = [augmented[0][3], augmented[1][3], augmented[2][3]];
        return result.every((value) => Number.isFinite(value)) ? result : null;
    }

    private setRealDesktopStatus(state: RealDesktopControlState, message: string) {
        this.realDesktopState = state;
        this.realDesktopStatus = state;
        this.realDesktopControllerMessage = message;
    }

    private resetRealDesktopGestureState() {
        this.realDesktopPaused = false;
        this.resetRealDesktopPauseHold();
        this.realDesktopPauseGestureReleaseRequired = false;
        this.realDesktopMouseDown = false;
        this.realDesktopActiveTrackId = null;
        this.realDesktopPinchReadyByHand = [];
        this.realDesktopPinchActiveByHand = [];
        this.realDesktopLastScreenPoint = null;
        this.realDesktopLastDragScreenPoint = null;
        this.resetRealDesktopPointerSettingsFilter();
        this.resetRealDesktopDragArming();
        this.resetRealDesktopClickGestureState(false);
    }

    private resetRealDesktopControlState(message: string = '오른쪽 패널에서 OS를 선택하고 터미널 명령을 실행한 뒤 Enable을 누르세요.') {
        this.clearPendingRealDesktopMove();
        this.realDesktopEnabled = false;
        this.resetRealDesktopEnableHold();
        this.clearRealDesktopCalibrationSession();
        this.resetRealDesktopGestureState();
        this.realDesktopScreenLabel = '컨트롤러 연결 전';
        this.setRealDesktopSingleMonitorMode(false);
        this.setRealDesktopStatus('disabled', message);
    }

    private setRealDesktopSingleMonitorMode(enabled: boolean, releaseReason: string = 'Single Monitor Mode 전환으로 mouse up') {
        if (this.realDesktopSingleMonitorMode !== enabled) {
            this.clearPendingRealDesktopMove();
            if (this.realDesktopCalibrationActive) {
                this.clearRealDesktopCalibrationSession();
            }
            if (this.realDesktopMouseDown) {
                this.releaseRealDesktopMouse(releaseReason);
            }
            this.resetRealDesktopDragArming();
            this.resetRealDesktopClickGestureState(false);
            this.realDesktopSingleMonitorMode = enabled;
        }

        this.syncRealDesktopSingleMonitorClass();
    }

    private syncRealDesktopSingleMonitorClass() {
        if (typeof document === 'undefined') return;
        document.documentElement.classList.toggle('wandless-single-monitor-mode', this.realDesktopSingleMonitorMode);
    }

    private applyRealDesktopStartupMode() {
        if (typeof window === 'undefined') return;

        try {
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.get('wandlessCompact') !== '1') return;

            this.realDesktopCompactWindowMode = true;
            this.activeMode = 'realDesktop';
            this.realDesktopSingleMonitorMode = true;
            this.syncRealDesktopSingleMonitorClass();
            this.setRealDesktopStatus(
                'disabled',
                'Compact popup mode입니다. 로컬 컨트롤러를 실행하고 카메라 권한을 허용한 뒤 Enable하세요.'
            );
        } catch (error) {
            // Ignore malformed URL state and continue with the default mode.
        }
    }

    private getRealDesktopControllerEndpoint(path: string): string {
        return `${this.realDesktopControllerUrl.replace(/\/+$/, '')}${path}`;
    }

    private detectRealDesktopControllerPlatform(): RealDesktopControllerPlatform {
        if (typeof navigator !== 'undefined' && /windows/i.test(navigator.userAgent || '')) {
            return 'windows';
        }
        return 'macos';
    }

    private drawDesktopBackdrop(context: CanvasRenderingContext2D) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const width = canvas.width;
        const height = canvas.height;
        const pixelRatio = canvas.clientWidth ? width / canvas.clientWidth : 1;
        const gridSize = 20 * pixelRatio;
        const majorGridSize = 100 * pixelRatio;

        const background = context.createRadialGradient(
            width * 0.3,
            height * 0.2,
            width * 0.04,
            width * 0.3,
            height * 0.2,
            Math.max(width, height) * 0.92
        );
        background.addColorStop(0, '#3a2a18');
        background.addColorStop(0.44, '#2a1f12');
        background.addColorStop(1, '#1a1208');
        context.fillStyle = background;
        context.fillRect(0, 0, width, height);

        [
            { x: 0.15, y: 0.25, r: 0.24, a: 0.08 },
            { x: 0.85, y: 0.7, r: 0.3, a: 0.06 },
            { x: 0.5, y: 0.9, r: 0.2, a: 0.05 }
        ].forEach((spot) => {
            const radius = Math.max(width, height) * spot.r;
            const stain = context.createRadialGradient(
                width * spot.x,
                height * spot.y,
                0,
                width * spot.x,
                height * spot.y,
                radius
            );
            stain.addColorStop(0, `rgba(139, 106, 58, ${spot.a})`);
            stain.addColorStop(1, 'rgba(139, 106, 58, 0)');
            context.fillStyle = stain;
            context.fillRect(0, 0, width, height);
        });

        context.save();
        context.lineWidth = Math.max(0.5, pixelRatio * 0.3);
        context.strokeStyle = 'rgba(212, 162, 89, 0.08)';
        for (let x = 0; x <= width; x += gridSize) {
            context.beginPath();
            context.moveTo(x, 0);
            context.lineTo(x, height);
            context.stroke();
        }
        for (let y = 0; y <= height; y += gridSize) {
            context.beginPath();
            context.moveTo(0, y);
            context.lineTo(width, y);
            context.stroke();
        }

        context.lineWidth = Math.max(0.5, pixelRatio * 0.5);
        context.strokeStyle = 'rgba(212, 162, 89, 0.15)';
        for (let x = 0; x <= width; x += majorGridSize) {
            context.beginPath();
            context.moveTo(x, 0);
            context.lineTo(x, height);
            context.stroke();
        }
        for (let y = 0; y <= height; y += majorGridSize) {
            context.beginPath();
            context.moveTo(0, y);
            context.lineTo(width, y);
            context.stroke();
        }
        context.restore();
    }

    private drawDesktopIcons(context: CanvasRenderingContext2D) {
        const draggingIconId = this.desktopDrag.iconId;
        const normalIcons = this.desktopIcons.filter((icon) => icon.id !== draggingIconId);
        const draggingIcon = draggingIconId ? this.desktopIcons.find((icon) => icon.id === draggingIconId) : null;

        normalIcons.forEach((icon) => this.drawDesktopIcon(context, icon));
        if (draggingIcon) {
            this.drawDesktopIcon(context, draggingIcon);
        }
    }

    private drawDesktopIcon(context: CanvasRenderingContext2D, icon: DesktopIconTile) {
        const rect = this.getDesktopIconRect(icon);
        const canvas = this.effectCanvas?.nativeElement;
        if (!rect || !canvas) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const isHovered = this.desktopHoveredIconId === icon.id && this.desktopState !== 'dragging';
        const isDragging = this.desktopDrag.iconId === icon.id;
        const radius = 8 * scale;
        const lift = isDragging ? -5 * scale : 0;
        const x = rect.x;
        const y = rect.y + lift;

        context.save();
        context.shadowColor = isDragging ? 'rgba(212, 162, 89, 0.32)' : 'rgba(0, 0, 0, 0.22)';
        context.shadowBlur = isDragging ? 24 * scale : 10 * scale;
        context.shadowOffsetY = isDragging ? 10 * scale : 4 * scale;

        this.roundRect(context, x, y, rect.width, rect.height, radius);
        context.fillStyle = isDragging ?
            'rgba(20, 14, 8, 0.62)' :
            isHovered ?
                'rgba(20, 14, 8, 0.55)' :
                'rgba(20, 14, 8, 0.35)';
        context.fill();
        context.strokeStyle = isDragging ?
            'rgba(212, 162, 89, 0.62)' :
            isHovered ?
                'rgba(139, 106, 58, 0.48)' :
                'rgba(139, 106, 58, 0.24)';
        context.lineWidth = Math.max(0.5, scale);
        context.stroke();
        context.shadowBlur = 0;
        context.shadowOffsetY = 0;

        const glyphSize = Math.min(rect.width * 0.44, rect.height * 0.42);
        const glyphX = x + (rect.width - glyphSize) / 2;
        const glyphY = y + 15 * scale;
        this.roundRect(context, glyphX, glyphY, glyphSize, glyphSize, 6 * scale);
        context.fillStyle = icon.color;
        context.fill();
        context.strokeStyle = 'rgba(0, 0, 0, 0.4)';
        context.stroke();

        context.fillStyle = 'rgba(255, 240, 210, 0.85)';
        context.font = `700 ${Math.max(10, glyphSize * 0.26)}px "Courier New", monospace`;
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(icon.icon, glyphX + glyphSize / 2, glyphY + glyphSize / 2);

        context.fillStyle = '#e8d5a8';
        context.font = `italic ${13 * scale}px Georgia, serif`;
        context.textBaseline = 'top';
        context.fillText(icon.label, x + rect.width / 2, y + rect.height - 27 * scale);
        context.restore();
    }

    private drawDesktopCursor(context: CanvasRenderingContext2D, delta: number) {
        const cursor = this.desktopCursor;
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        if (cursor.active) {
            const follow = Math.min(1, 0.42 * frameScale);
            cursor.x += (cursor.targetX - cursor.x) * follow;
            cursor.y += (cursor.targetY - cursor.y) * follow;
            cursor.alpha += (1 - cursor.alpha) * Math.min(1, 0.26 * frameScale);
        } else {
            cursor.alpha *= Math.pow(0.78, frameScale);
        }

        const alpha = this.clamp(cursor.alpha, 0, 1);
        if (alpha <= 0.015) {
            cursor.visible = false;
            return;
        }

        const scale = Math.max(1, cursor.scale);
        const size = (15 + (this.desktopState === 'dragging' ? 5 : 0)) * scale;

        context.save();
        context.globalAlpha = alpha;
        context.translate(cursor.x, cursor.y);
        context.shadowColor = this.desktopState === 'dragging' ?
            'rgba(244, 210, 138, 0.72)' :
            'rgba(212, 162, 89, 0.5)';
        context.shadowBlur = 14 * scale;
        context.fillStyle = this.desktopState === 'dragging' ? '#f4d28a' : '#d4a259';
        context.strokeStyle = 'rgba(13, 9, 7, 0.86)';
        context.lineWidth = 2.2 * scale;
        context.beginPath();
        context.moveTo(0, 0);
        context.lineTo(size * 0.86, size * 0.32);
        context.lineTo(size * 0.42, size * 0.52);
        context.lineTo(size * 0.68, size * 1.08);
        context.lineTo(size * 0.45, size * 1.18);
        context.lineTo(size * 0.18, size * 0.62);
        context.lineTo(-size * 0.16, size * 0.96);
        context.closePath();
        context.fill();
        context.stroke();

        if (this.desktopState === 'hover' || this.desktopState === 'dragging') {
            context.shadowBlur = 0;
            context.strokeStyle = this.desktopState === 'dragging' ?
                'rgba(244, 210, 138, 0.8)' :
                'rgba(212, 162, 89, 0.72)';
            context.lineWidth = 2 * scale;
            context.beginPath();
            context.arc(0, 0, 17 * scale, 0, Math.PI * 2);
            context.stroke();
        }

        context.restore();
    }

    private getDesktopIconRect(icon: DesktopIconTile): { x: number; y: number; width: number; height: number } | null {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return null;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const width = Math.max(98 * scale, canvas.width * icon.width);
        const height = Math.max(92 * scale, canvas.height * icon.height);
        const margin = 18 * scale;
        const x = this.clamp(icon.x * canvas.width, margin, Math.max(margin, canvas.width - width - margin));
        const y = this.clamp(icon.y * canvas.height, 56 * scale, Math.max(56 * scale, canvas.height - height - 78 * scale));

        return { x, y, width, height };
    }

    private roundRect(context: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number) {
        const safeRadius = Math.min(radius, width / 2, height / 2);
        context.beginPath();
        context.moveTo(x + safeRadius, y);
        context.lineTo(x + width - safeRadius, y);
        context.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
        context.lineTo(x + width, y + height - safeRadius);
        context.quadraticCurveTo(x + width, y + height, x + width - safeRadius, y + height);
        context.lineTo(x + safeRadius, y + height);
        context.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
        context.lineTo(x, y + safeRadius);
        context.quadraticCurveTo(x, y, x + safeRadius, y);
        context.closePath();
    }

    private pickPortalHands(hands: HandFrame[]): PortalHandPair | null {
        if (this.portalAnchorTrackId !== null && this.portalDrawingTrackId !== null) {
            const anchorIndex = hands.findIndex((hand) => hand.trackId === this.portalAnchorTrackId);
            const drawingIndex = hands.findIndex((hand) => hand.trackId === this.portalDrawingTrackId);
            const anchor = anchorIndex >= 0 ? hands[anchorIndex] : null;
            const drawing = drawingIndex >= 0 ? hands[drawingIndex] : null;

            if (anchor && drawing && anchor.palm.isOpen && drawing.palm.isOpen) {
                const scale = Math.max(1, (anchor.scale + drawing.scale) / 2);
                const anchorLooksStable = anchor.motionEnergy <= Math.max(drawing.motionEnergy * 1.08, 9 * scale);
                const drawingIsMoving = drawing.motionEnergy >= Math.max(1.05 * scale, anchor.motionEnergy * 0.92);

                if (this.portalTrace.length > 0 || (anchorLooksStable && drawingIsMoving)) {
                    return {
                        anchorIndex,
                        drawingIndex,
                        anchorTrackId: anchor.trackId,
                        drawingTrackId: drawing.trackId
                    };
                }
            }
        }

        const lastTracePoint = this.portalTrace[this.portalTrace.length - 1];
        const openHandIndexes = hands
            .map((hand, index) => ({ hand, index }))
            .filter((item) => item.hand.palm.isOpen);
        if (lastTracePoint && openHandIndexes.length >= 2) {
            const drawingCandidate = openHandIndexes
                .map((item) => ({
                    ...item,
                    distance: this.canvasDistance(item.hand.center, lastTracePoint)
                }))
                .sort((first, second) => first.distance - second.distance)[0];
            if (!drawingCandidate) return null;
            const anchorCandidate = openHandIndexes
                .filter((item) => item.index !== drawingCandidate.index)
                .sort((first, second) => first.hand.motionEnergy - second.hand.motionEnergy)[0];
            if (!anchorCandidate) return null;
            const scale = Math.max(1, (drawingCandidate.hand.scale + anchorCandidate.hand.scale) / 2);
            const relinkLimit = Math.max(80 * scale, this.getCanvasBase() * 0.06);

            if (drawingCandidate.distance <= relinkLimit) {
                return {
                    anchorIndex: anchorCandidate.index,
                    drawingIndex: drawingCandidate.index,
                    anchorTrackId: anchorCandidate.hand.trackId,
                    drawingTrackId: drawingCandidate.hand.trackId
                };
            }
        }

        let bestPair: PortalHandPair | null = null;
        let bestScore = -Infinity;

        hands.forEach((anchor, anchorIndex) => {
            if (!anchor.palm.isOpen) return;

            hands.forEach((drawing, drawingIndex) => {
                if (anchorIndex === drawingIndex || !drawing.palm.isOpen) return;

                const scale = Math.max(1, (anchor.scale + drawing.scale) / 2);
                const minDrawingMotion = Math.max(1.05 * scale, this.getCanvasBase() * 0.0009);
                const motionGap = drawing.motionEnergy - anchor.motionEnergy;

                if (drawing.motionEnergy < minDrawingMotion) return;
                if (motionGap < Math.max(0.35 * scale, anchor.motionEnergy * 0.12)) return;

                const anchorStability = 1 - this.clamp(anchor.motionEnergy / Math.max(1, 18 * scale), 0, 1);
                const drawingMotionScore = this.clamp(drawing.motionEnergy / Math.max(1, 14 * scale), 0, 1.8);
                const motionGapScore = this.clamp(motionGap / Math.max(1, 10 * scale), 0, 1.4);
                const palmScore = (anchor.palm.score + drawing.palm.score) * 0.08;
                const score = anchorStability * 1.45 +
                    drawingMotionScore * 1.65 +
                    motionGapScore * 1.25 +
                    palmScore;

                if (score > bestScore) {
                    bestScore = score;
                    bestPair = {
                        anchorIndex,
                        drawingIndex,
                        anchorTrackId: anchor.trackId,
                        drawingTrackId: drawing.trackId
                    };
                }
            });
        });

        return bestPair;
    }

    private startPortalDrawing(anchorTrackId: number, drawingTrackId: number, point: CanvasPoint, timestamp: number) {
        this.portalAnchorTrackId = anchorTrackId;
        this.portalDrawingTrackId = drawingTrackId;
        this.portalTrace = [{ x: point.x, y: point.y, time: timestamp }];
        this.portalCircleScore = 0;
        this.portalState = 'drawing';
    }

    private addPortalTracePoint(point: CanvasPoint, scale: number, timestamp: number) {
        this.portalTrace = this.portalTrace.filter((tracePoint) => timestamp - tracePoint.time <= this.portalTraceMaxAge);

        const last = this.portalTrace[this.portalTrace.length - 1];
        const minStep = Math.max(1.35 * scale, 1.6);

        if (last) {
            const distance = Math.hypot(point.x - last.x, point.y - last.y);
            const jumpLimit = Math.max(150 * scale, this.getPortalMinRadius() * 1.8);

            if (distance > jumpLimit) {
                this.portalTrace = [{ x: point.x, y: point.y, time: timestamp }];
                this.portalCircleScore = 0;
                return;
            }

            if (distance < minStep) {
                if (timestamp - last.time > this.portalStillTimeout) {
                    this.cancelPortalDrawing();
                }
                return;
            }
        }

        this.portalTrace.push({ x: point.x, y: point.y, time: timestamp });

        if (this.portalTrace.length > 90) {
            this.portalTrace.splice(0, this.portalTrace.length - 90);
        }
    }

    private measurePortalCircle(timestamp: number): PortalCircleMetrics | null {
        const metrics = this.analyzePortalCircle(timestamp);
        this.portalCircleScore = metrics?.score || 0;
        return metrics?.passed ? metrics : null;
    }

    private analyzePortalCircle(timestamp: number): PortalCircleMetrics | null {
        const points = this.portalTrace.filter((point) => timestamp - point.time <= this.portalTraceMaxAge);
        if (points.length < 6) return null;

        const first = points[0];
        const last = points[points.length - 1];
        const duration = last.time - first.time;
        const averageCenter = points.reduce((sum, point) => ({
            x: sum.x + point.x,
            y: sum.y + point.y
        }), { x: 0, y: 0 });
        averageCenter.x /= points.length;
        averageCenter.y /= points.length;

        const bounds = points.reduce((box, point) => ({
            minX: Math.min(box.minX, point.x),
            maxX: Math.max(box.maxX, point.x),
            minY: Math.min(box.minY, point.y),
            maxY: Math.max(box.maxY, point.y)
        }), {
            minX: Number.POSITIVE_INFINITY,
            maxX: Number.NEGATIVE_INFINITY,
            minY: Number.POSITIVE_INFINITY,
            maxY: Number.NEGATIVE_INFINITY
        });
        const boundsCenter = {
            x: (bounds.minX + bounds.maxX) / 2,
            y: (bounds.minY + bounds.maxY) / 2
        };
        const center = {
            x: (averageCenter.x + boundsCenter.x) / 2,
            y: (averageCenter.y + boundsCenter.y) / 2
        };

        const distances = points.map((point) => Math.hypot(point.x - center.x, point.y - center.y));
        const radius = distances.reduce((sum, distance) => sum + distance, 0) / distances.length;
        const minRadius = this.getPortalMinRadius();
        const radialDeviation = Math.sqrt(
            distances.reduce((sum, distance) => sum + Math.pow(distance - radius, 2), 0) / distances.length
        );
        const radialVariance = radius > 0 ? radialDeviation / radius : 1;
        const closureRatio = radius > 0 ? Math.hypot(first.x - last.x, first.y - last.y) / radius : Infinity;

        let signedTravel = 0;
        let absoluteTravel = 0;
        let pathLength = 0;

        for (let i = 1; i < points.length; i++) {
            const previous = points[i - 1];
            const current = points[i];
            const previousAngle = Math.atan2(previous.y - center.y, previous.x - center.x);
            const currentAngle = Math.atan2(current.y - center.y, current.x - center.x);
            const deltaAngle = this.normalizeAngle(currentAngle - previousAngle);

            signedTravel += deltaAngle;
            absoluteTravel += Math.abs(deltaAngle);
            pathLength += Math.hypot(current.x - previous.x, current.y - previous.y);
        }

        const angleTravel = Math.abs(signedTravel);
        const directionConsistency = angleTravel / Math.max(absoluteTravel, 0.001);
        const radiusScore = this.clamp((radius - minRadius * 0.64) / Math.max(1, minRadius * 0.48), 0, 1);
        const angleScore = this.clamp((angleTravel - Math.PI * 0.92) / Math.max(0.001, Math.PI * 0.68), 0, 1);
        const closureScore = 1 - this.clamp((closureRatio - 0.38) / 0.78, 0, 1);
        const radialScore = 1 - this.clamp(radialVariance / 0.68, 0, 1);
        const directionScore = this.clamp((directionConsistency - 0.28) / 0.46, 0, 1);
        const durationScore = this.clamp(duration / this.portalTraceMinDuration, 0, 1);
        const pointScore = this.clamp(points.length / 18, 0, 1);
        const pathScore = this.clamp(pathLength / Math.max(1, radius * 3.35), 0, 1);
        const score = Math.round(100 * (
            radiusScore * 0.15 +
            angleScore * 0.22 +
            closureScore * 0.17 +
            radialScore * 0.18 +
            directionScore * 0.18 +
            durationScore * 0.04 +
            pointScore * 0.03 +
            pathScore * 0.03
        ));
        const passed = points.length >= 12 &&
            duration >= this.portalTraceMinDuration &&
            radius >= minRadius &&
            angleTravel >= Math.PI * 1.2 &&
            absoluteTravel >= Math.PI * 1.42 &&
            pathLength >= radius * 3.15 &&
            closureRatio <= 1.08 &&
            radialVariance <= 0.68 &&
            directionConsistency >= 0.36 &&
            score >= 54;

        return {
            center,
            radius,
            angleTravel: signedTravel,
            closureRatio,
            radialVariance,
            directionConsistency,
            score,
            passed
        };
    }

    private normalizeAngle(angle: number): number {
        let result = angle;
        while (result > Math.PI) result -= Math.PI * 2;
        while (result < -Math.PI) result += Math.PI * 2;
        return result;
    }

    private getPortalMinRadius(): number {
        const canvas = this.effectCanvas?.nativeElement;
        const base = canvas ? Math.min(canvas.width, canvas.height) : 720;
        return Math.max(32, base * this.portalMinRadiusRatio);
    }

    private openPortal(metrics: PortalCircleMetrics, scale: number, timestamp: number) {
        const canvas = this.effectCanvas?.nativeElement;
        const maxRadius = canvas ? Math.min(canvas.width, canvas.height) * 0.32 : metrics.radius;
        const radius = Math.max(this.getPortalMinRadius(), Math.min(metrics.radius, maxRadius));
        const spinDirection = metrics.angleTravel >= 0 ? 1 : -1;

        this.portalEffects.push({
            x: metrics.center.x,
            y: metrics.center.y,
            radius,
            life: 2400,
            maxLife: 2400,
            rotation: Math.random() * Math.PI * 2,
            spin: spinDirection * (0.018 + Math.random() * 0.008),
            scale
        });

        if (this.portalEffects.length > this.maxPortalEffects) {
            this.portalEffects.splice(0, this.portalEffects.length - this.maxPortalEffects);
        }

        this.emitPortalBurst(metrics.center, radius, scale);
        this.portalTrace = [];
        this.portalAnchorTrackId = null;
        this.portalDrawingTrackId = null;
        this.portalState = 'portalOpen';
        this.portalCooldownUntil = timestamp + 1800;
    }

    private hasOpenPortal(): boolean {
        return this.portalEffects.length > 0;
    }

    private cancelPortalDrawing() {
        const hasOpenPortal = this.hasOpenPortal();
        this.portalTrace = [];
        this.portalAnchorTrackId = null;
        this.portalDrawingTrackId = null;
        if (!hasOpenPortal) {
            this.portalCircleScore = 0;
        }
        this.portalState = hasOpenPortal ? 'portalOpen' : 'idle';
    }

    private resetPortalState() {
        this.portalTrace = [];
        this.portalSparks = [];
        this.portalEffects = [];
        this.portalAnchorTrackId = null;
        this.portalDrawingTrackId = null;
        this.portalCircleScore = 0;
        this.portalState = 'idle';
        this.portalCooldownUntil = 0;
    }

    private emitEnergyParticles(handIndex: number, center: CanvasPoint, scale: number, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const charge = this.fistChargeByHand[handIndex] || 0;
        const chargeProgress = Math.min(1, charge / 1800);
        const count = Math.ceil((4 + chargeProgress * 5) * frameScale);
        const spawnRadius = (44 + chargeProgress * 62) * scale;

        for (let i = 0; i < count; i++) {
            const angle = Math.random() * Math.PI * 2;
            const radius = spawnRadius * (0.65 + Math.random() * 0.55);
            const x = center.x + Math.cos(angle) * radius;
            const y = center.y + Math.sin(angle) * radius;
            const pull = 0.025 + chargeProgress * 0.026;

            this.energyParticles.push({
                handIndex,
                x,
                y,
                vx: (center.x - x) * pull + (Math.random() - 0.5) * 0.9 * scale,
                vy: (center.y - y) * pull + (Math.random() - 0.5) * 0.9 * scale,
                life: 28 + Math.random() * 24,
                maxLife: 52,
                size: (2.2 + Math.random() * 4.8 + chargeProgress * 2.4) * scale
            });
        }

        if (this.energyParticles.length > this.maxEnergyParticles) {
            this.energyParticles.splice(0, this.energyParticles.length - this.maxEnergyParticles);
        }
    }

    private launchEnergyProjectile(center: CanvasPoint, direction: CanvasPoint, scale: number, charge: number) {
        if (charge < 120) return;

        const power = Math.min(1, charge / 1800);
        const speed = (9.5 + power * 6.5) * scale;
        const launchDirection = Math.hypot(direction.x, direction.y) > 0.01 ? direction : { x: 0, y: -1 };

        this.energyProjectiles.push({
            x: center.x,
            y: center.y,
            vx: launchDirection.x * speed,
            vy: launchDirection.y * speed,
            life: 56 + power * 42,
            maxLife: 56 + power * 42,
            radius: (24 + power * 46) * scale,
            power
        });

        if (this.energyProjectiles.length > this.maxEnergyProjectiles) {
            this.energyProjectiles.splice(0, this.energyProjectiles.length - this.maxEnergyProjectiles);
        }
    }

    private cancelMissingFistCharges(detectedCount: number) {
        for (let handIndex = detectedCount; handIndex < this.fistActiveByHand.length; handIndex++) {
            if (this.fistActiveByHand[handIndex]) {
                this.cancelFistCharge(handIndex);
            }
        }

        this.fistActiveByHand.length = detectedCount;
        this.fistChargeByHand.length = detectedCount;
        this.fistCenterByHand.length = detectedCount;
        this.fistDirectionByHand.length = detectedCount;
        this.fistScaleByHand.length = detectedCount;
    }

    private cancelFistCharge(handIndex: number) {
        this.fistActiveByHand[handIndex] = false;
        this.fistChargeByHand[handIndex] = 0;
    }

    private releaseFistCharge(handIndex: number, launch: boolean) {
        const charge = this.fistChargeByHand[handIndex] || 0;
        const center = this.fistCenterByHand[handIndex];
        const direction = this.fistDirectionByHand[handIndex];
        const scale = this.fistScaleByHand[handIndex] || 1;

        if (launch && center && direction) {
            this.launchEnergyProjectile(center, direction, scale, charge);
        }

        this.fistActiveByHand[handIndex] = false;
        this.fistChargeByHand[handIndex] = 0;
    }

    private resetFistState() {
        this.fistActiveByHand = [];
        this.fistChargeByHand = [];
        this.fistCenterByHand = [];
        this.fistDirectionByHand = [];
        this.fistScaleByHand = [];
    }

    private cancelMissingAimStates(detectedCount: number) {
        for (let handIndex = detectedCount; handIndex < this.aimEffectsByHand.length; handIndex++) {
            this.cancelAim(handIndex);
        }

        this.aimActiveByHand.length = detectedCount;
    }

    private cancelAim(handIndex: number) {
        this.aimActiveByHand[handIndex] = false;
        const effect = this.aimEffectsByHand[handIndex];
        if (effect) {
            effect.active = false;
        }
    }

    private resetAimState() {
        this.aimActiveByHand = [];
        this.aimEffectsByHand = [];
    }

    private emitOrbCompressParticles(metrics: OrbCompressMetrics, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const count = Math.ceil((4 + metrics.compression * 7) * frameScale);
        const swirl = 0.62 + metrics.compression * 0.72;
        const pull = 0.018 + metrics.compression * 0.032;

        for (let i = 0; i < count; i++) {
            const angle = Math.random() * Math.PI * 2;
            const radius = metrics.radius * (1.05 + Math.random() * (1.05 - metrics.compression * 0.34));
            const x = metrics.center.x + Math.cos(angle) * radius;
            const y = metrics.center.y + Math.sin(angle) * radius;
            const tangentX = -Math.sin(angle);
            const tangentY = Math.cos(angle);
            const inwardX = metrics.center.x - x;
            const inwardY = metrics.center.y - y;
            const life = 24 + Math.random() * 28;

            this.orbCompressParticles.push({
                x,
                y,
                vx: inwardX * pull + tangentX * swirl * metrics.scale + (Math.random() - 0.5) * 0.5 * metrics.scale,
                vy: inwardY * pull + tangentY * swirl * metrics.scale + (Math.random() - 0.5) * 0.5 * metrics.scale,
                life,
                maxLife: life,
                size: (1.6 + Math.random() * 4.8 + metrics.compression * 2.4) * metrics.scale,
                hue: 178 + Math.random() * 62
            });
        }

        if (this.orbCompressParticles.length > this.maxOrbCompressParticles) {
            this.orbCompressParticles.splice(0, this.orbCompressParticles.length - this.maxOrbCompressParticles);
        }
    }

    private emitOrbCompressionPulse(metrics: OrbCompressMetrics) {
        this.orbCompressPulses.push({
            x: metrics.center.x,
            y: metrics.center.y,
            radius: metrics.radius * 0.55,
            maxRadius: metrics.radius * (2.3 + metrics.compression * 0.7),
            life: 28,
            maxLife: 28,
            intensity: metrics.intensity
        });

        if (this.orbCompressPulses.length > this.maxOrbCompressPulses) {
            this.orbCompressPulses.splice(0, this.orbCompressPulses.length - this.maxOrbCompressPulses);
        }

        const burstCount = 26;
        for (let i = 0; i < burstCount; i++) {
            const angle = (i / burstCount) * Math.PI * 2 + (Math.random() - 0.5) * 0.24;
            const speed = (1.6 + Math.random() * 3.4) * metrics.scale;
            const life = 18 + Math.random() * 22;

            this.orbCompressParticles.push({
                x: metrics.center.x + Math.cos(angle) * metrics.radius * 0.45,
                y: metrics.center.y + Math.sin(angle) * metrics.radius * 0.45,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                life,
                maxLife: life,
                size: (2.3 + Math.random() * 5.8) * metrics.scale,
                hue: 188 + Math.random() * 54
            });
        }

        if (this.orbCompressParticles.length > this.maxOrbCompressParticles) {
            this.orbCompressParticles.splice(0, this.orbCompressParticles.length - this.maxOrbCompressParticles);
        }
    }

    private drawOrbCompressEffects(context: CanvasRenderingContext2D, delta: number) {
        this.drawOrbCompressParticles(context, delta);
        this.drawOrbCompressCore(context, delta);
        this.drawOrbCompressPulses(context, delta);
    }

    private drawOrbCompressParticles(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const effect = this.orbCompressEffect;

        context.save();
        context.globalCompositeOperation = 'lighter';

        for (let i = this.orbCompressParticles.length - 1; i >= 0; i--) {
            const particle = this.orbCompressParticles[i];
            particle.life -= frameScale;

            if (particle.life <= 0) {
                this.orbCompressParticles.splice(i, 1);
                continue;
            }

            if (effect.alpha > 0.04) {
                const pull = 0.0038 + effect.compression * 0.0048;
                particle.vx += (effect.x - particle.x) * pull * frameScale;
                particle.vy += (effect.y - particle.y) * pull * frameScale;
            }

            particle.x += particle.vx * frameScale;
            particle.y += particle.vy * frameScale;
            particle.vx *= 0.976;
            particle.vy *= 0.976;

            const progress = particle.life / particle.maxLife;
            const alpha = Math.max(0, Math.min(0.88, progress * (0.78 + effect.compression * 0.32)));
            const radius = particle.size * (0.45 + progress * 0.9);
            const gradient = context.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, radius);

            gradient.addColorStop(0, `rgba(255, 255, 255, ${alpha})`);
            gradient.addColorStop(0.42, `hsla(${particle.hue}, 100%, 68%, ${alpha * 0.75})`);
            gradient.addColorStop(1, 'rgba(110, 84, 255, 0)');

            context.fillStyle = gradient;
            context.beginPath();
            context.arc(particle.x, particle.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private drawOrbCompressCore(context: CanvasRenderingContext2D, delta: number) {
        const effect = this.orbCompressEffect;
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        if (effect.active) {
            const follow = Math.min(1, 0.34 * frameScale);
            effect.x += (effect.targetX - effect.x) * follow;
            effect.y += (effect.targetY - effect.y) * follow;
            effect.radius += (effect.targetRadius - effect.radius) * Math.min(1, 0.28 * frameScale);
            effect.intensity += (effect.targetIntensity - effect.intensity) * Math.min(1, 0.24 * frameScale);
            effect.compression += (effect.targetCompression - effect.compression) * Math.min(1, 0.24 * frameScale);
            effect.alpha += (1 - effect.alpha) * Math.min(1, 0.22 * frameScale);
        } else {
            effect.alpha *= Math.pow(0.84, frameScale);
            effect.radius *= Math.pow(1.012, frameScale);
        }

        const alpha = this.clamp(effect.alpha, 0, 1);
        if (alpha <= 0.015 || effect.radius <= 0) return;

        const now = performance.now();
        const pulse = 1 + Math.sin(now / (104 - effect.compression * 36)) * (0.025 + effect.compression * 0.035);
        const radius = effect.radius * pulse;
        const coreRadius = Math.max(5 * effect.scale, radius * (0.24 + (1 - effect.compression) * 0.08));
        const glowRadius = radius * (1.82 - effect.compression * 0.32);
        const glowAlpha = this.clamp(alpha * effect.intensity, 0, 1);

        context.save();
        context.globalCompositeOperation = 'lighter';

        const glow = context.createRadialGradient(effect.x, effect.y, 0, effect.x, effect.y, glowRadius);
        glow.addColorStop(0, `rgba(255, 255, 255, ${0.88 * glowAlpha})`);
        glow.addColorStop(0.22, `rgba(142, 252, 255, ${0.68 * glowAlpha})`);
        glow.addColorStop(0.54, `rgba(125, 116, 255, ${0.34 * glowAlpha})`);
        glow.addColorStop(1, 'rgba(88, 68, 255, 0)');

        context.fillStyle = glow;
        context.beginPath();
        context.arc(effect.x, effect.y, glowRadius, 0, Math.PI * 2);
        context.fill();

        const core = context.createRadialGradient(effect.x, effect.y, 0, effect.x, effect.y, coreRadius);
        core.addColorStop(0, `rgba(255, 255, 255, ${0.95 * alpha})`);
        core.addColorStop(0.5, `rgba(187, 255, 252, ${0.86 * alpha})`);
        core.addColorStop(1, `rgba(112, 132, 255, ${0.18 * alpha})`);

        context.fillStyle = core;
        context.beginPath();
        context.arc(effect.x, effect.y, coreRadius, 0, Math.PI * 2);
        context.fill();

        const ringCount = 2 + Math.floor(effect.compression * 4);
        context.lineCap = 'round';
        for (let i = 0; i < ringCount; i++) {
            const ringRadius = radius * (0.58 + i * 0.16);
            const rotation = now / (460 - effect.compression * 160) + i * Math.PI * 0.46;
            const ringAlpha = alpha * (0.26 + effect.compression * 0.22) * (1 - i * 0.1);

            context.strokeStyle = `rgba(203, 252, 255, ${ringAlpha})`;
            context.shadowColor = `rgba(128, 234, 255, ${ringAlpha})`;
            context.shadowBlur = 16 * effect.scale;
            context.lineWidth = Math.max(1, (1.2 + effect.compression * 1.8) * effect.scale);
            context.beginPath();
            context.ellipse(
                effect.x,
                effect.y,
                ringRadius,
                ringRadius * (0.86 + i * 0.025),
                rotation,
                Math.PI * 0.12,
                Math.PI * 1.74
            );
            context.stroke();
        }

        const shardCount = 14 + Math.floor(effect.compression * 18);
        context.shadowBlur = 0;
        for (let i = 0; i < shardCount; i++) {
            const angle = now / 680 + (i / shardCount) * Math.PI * 2;
            const orbit = radius * (0.72 + Math.sin(now / 150 + i) * 0.08);
            const x = effect.x + Math.cos(angle) * orbit;
            const y = effect.y + Math.sin(angle) * orbit;
            const size = (1.2 + (i % 5) * 0.34 + effect.compression * 0.8) * effect.scale;

            context.fillStyle = `rgba(236, 255, 250, ${alpha * (0.34 + effect.compression * 0.32)})`;
            context.beginPath();
            context.arc(x, y, size, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private drawOrbCompressPulses(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        context.save();
        context.globalCompositeOperation = 'lighter';
        context.lineCap = 'round';

        for (let i = this.orbCompressPulses.length - 1; i >= 0; i--) {
            const pulse = this.orbCompressPulses[i];
            pulse.life -= frameScale;

            if (pulse.life <= 0) {
                this.orbCompressPulses.splice(i, 1);
                continue;
            }

            const progress = 1 - pulse.life / pulse.maxLife;
            const radius = this.lerp(pulse.radius, pulse.maxRadius, progress);
            const alpha = Math.max(0, (1 - progress) * pulse.intensity);

            context.strokeStyle = `rgba(206, 255, 255, ${0.46 * alpha})`;
            context.shadowColor = `rgba(126, 234, 255, ${0.6 * alpha})`;
            context.shadowBlur = 22;
            context.lineWidth = Math.max(1, 4.2 * (1 - progress));
            context.beginPath();
            context.arc(pulse.x, pulse.y, radius, 0, Math.PI * 2);
            context.stroke();
        }

        context.restore();
    }

    private drawEnergyEffects(context: CanvasRenderingContext2D, delta: number) {
        this.drawEnergyParticles(context, delta);
        this.drawChargingOrbs(context);
        this.drawEnergyProjectiles(context, delta);
    }

    private drawChargingOrbs(context: CanvasRenderingContext2D) {
        context.save();
        context.globalCompositeOperation = 'lighter';

        this.fistActiveByHand.forEach((isActive, handIndex) => {
            if (!isActive) return;

            const center = this.fistCenterByHand[handIndex];
            if (!center) return;

            const charge = this.fistChargeByHand[handIndex] || 0;
            const scale = this.fistScaleByHand[handIndex] || 1;
            const progress = Math.min(1, charge / 1800);
            const pulse = 0.94 + Math.sin(performance.now() / 110) * 0.06;
            const radius = (22 + progress * 48) * scale * pulse;
            const coreRadius = Math.max(6 * scale, radius * 0.35);
            const alpha = 0.44 + progress * 0.46;
            const gradient = context.createRadialGradient(center.x, center.y, 0, center.x, center.y, radius);

            gradient.addColorStop(0, `rgba(255, 255, 248, ${alpha})`);
            gradient.addColorStop(0.25, `rgba(132, 245, 255, ${alpha * 0.92})`);
            gradient.addColorStop(0.58, `rgba(83, 118, 255, ${alpha * 0.52})`);
            gradient.addColorStop(1, 'rgba(72, 74, 255, 0)');

            context.fillStyle = gradient;
            context.beginPath();
            context.arc(center.x, center.y, radius, 0, Math.PI * 2);
            context.fill();

            context.strokeStyle = `rgba(192, 250, 255, ${0.28 + progress * 0.34})`;
            context.lineWidth = Math.max(1, 2.4 * scale);
            context.beginPath();
            context.arc(center.x, center.y, coreRadius + progress * 16 * scale, 0, Math.PI * 2);
            context.stroke();
        });

        context.restore();
    }

    private drawEnergyParticles(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        context.save();
        context.globalCompositeOperation = 'lighter';

        for (let i = this.energyParticles.length - 1; i >= 0; i--) {
            const particle = this.energyParticles[i];
            const target = this.fistCenterByHand[particle.handIndex];

            particle.life -= frameScale;
            if (particle.life <= 0) {
                this.energyParticles.splice(i, 1);
                continue;
            }

            if (target && this.fistActiveByHand[particle.handIndex]) {
                particle.vx += (target.x - particle.x) * 0.006 * frameScale;
                particle.vy += (target.y - particle.y) * 0.006 * frameScale;
            }

            particle.x += particle.vx * frameScale;
            particle.y += particle.vy * frameScale;
            particle.vx *= 0.974;
            particle.vy *= 0.974;

            const progress = particle.life / particle.maxLife;
            const alpha = Math.max(0, Math.min(0.86, progress));
            const radius = particle.size * (0.65 + progress);
            const gradient = context.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, radius);

            gradient.addColorStop(0, `rgba(255, 255, 255, ${alpha})`);
            gradient.addColorStop(0.42, `rgba(116, 234, 255, ${alpha * 0.78})`);
            gradient.addColorStop(1, 'rgba(65, 96, 255, 0)');

            context.fillStyle = gradient;
            context.beginPath();
            context.arc(particle.x, particle.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private drawEnergyProjectiles(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const canvas = this.effectCanvas?.nativeElement;

        context.save();
        context.globalCompositeOperation = 'lighter';

        for (let i = this.energyProjectiles.length - 1; i >= 0; i--) {
            const projectile = this.energyProjectiles[i];

            projectile.life -= frameScale;
            projectile.x += projectile.vx * frameScale;
            projectile.y += projectile.vy * frameScale;

            if (projectile.life <= 0 || this.isOutsideCanvas(projectile, canvas)) {
                this.energyProjectiles.splice(i, 1);
                continue;
            }

            const progress = projectile.life / projectile.maxLife;
            const alpha = Math.max(0, Math.min(0.95, progress));
            const radius = projectile.radius * (0.78 + projectile.power * 0.38);
            const tailX = projectile.x - projectile.vx * 3.2;
            const tailY = projectile.y - projectile.vy * 3.2;
            const trail = context.createLinearGradient(tailX, tailY, projectile.x, projectile.y);

            trail.addColorStop(0, 'rgba(50, 90, 255, 0)');
            trail.addColorStop(0.55, `rgba(88, 216, 255, ${alpha * 0.38})`);
            trail.addColorStop(1, `rgba(255, 255, 246, ${alpha * 0.72})`);

            context.strokeStyle = trail;
            context.lineWidth = Math.max(6, radius * 0.32);
            context.lineCap = 'round';
            context.beginPath();
            context.moveTo(tailX, tailY);
            context.lineTo(projectile.x, projectile.y);
            context.stroke();

            const gradient = context.createRadialGradient(projectile.x, projectile.y, 0, projectile.x, projectile.y, radius);
            gradient.addColorStop(0, `rgba(255, 255, 255, ${alpha})`);
            gradient.addColorStop(0.32, `rgba(118, 246, 255, ${alpha * 0.9})`);
            gradient.addColorStop(0.7, `rgba(72, 92, 255, ${alpha * 0.44})`);
            gradient.addColorStop(1, 'rgba(72, 92, 255, 0)');

            context.fillStyle = gradient;
            context.beginPath();
            context.arc(projectile.x, projectile.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private emitAimParticles(tip: CanvasPoint, direction: CanvasPoint, scale: number, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const count = Math.ceil(3 * frameScale);
        const sideX = -direction.y;
        const sideY = direction.x;

        for (let i = 0; i < count; i++) {
            const distance = (18 + Math.random() * 76) * scale;
            const spread = (Math.random() - 0.5) * 18 * scale;
            const drift = 0.8 + Math.random() * 1.8;
            const x = tip.x + direction.x * distance + sideX * spread;
            const y = tip.y + direction.y * distance + sideY * spread;
            const life = 16 + Math.random() * 22;

            this.aimParticles.push({
                x,
                y,
                vx: direction.x * drift * scale + sideX * (Math.random() - 0.5) * 0.7 * scale,
                vy: direction.y * drift * scale + sideY * (Math.random() - 0.5) * 0.7 * scale,
                life,
                maxLife: life,
                size: (1.4 + Math.random() * 3.8) * scale
            });
        }

        if (this.aimParticles.length > this.maxAimParticles) {
            this.aimParticles.splice(0, this.aimParticles.length - this.maxAimParticles);
        }
    }

    private drawAimEffects(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const now = performance.now();

        context.save();
        context.globalCompositeOperation = 'lighter';

        for (const effect of this.aimEffectsByHand) {
            if (!effect) continue;

            if (effect.active) {
                const follow = Math.min(1, 0.38 * frameScale);
                const directionFollow = Math.min(1, 0.28 * frameScale);

                effect.x += (effect.targetX - effect.x) * follow;
                effect.y += (effect.targetY - effect.y) * follow;
                effect.dx += (effect.targetDx - effect.dx) * directionFollow;
                effect.dy += (effect.targetDy - effect.dy) * directionFollow;
                effect.alpha += (1 - effect.alpha) * Math.min(1, 0.24 * frameScale);
            } else {
                effect.alpha *= Math.pow(0.82, frameScale);
            }

            const alpha = Math.max(0, Math.min(1, effect.alpha));
            if (alpha <= 0.015) continue;

            const length = (74 + Math.sin(now / 120) * 7) * effect.scale;
            const glowLength = length * 1.28;
            const dx = effect.dx;
            const dy = effect.dy;
            const rayEndX = effect.x + dx * length;
            const rayEndY = effect.y + dy * length;
            const glowEndX = effect.x + dx * glowLength;
            const glowEndY = effect.y + dy * glowLength;
            const ray = context.createLinearGradient(effect.x, effect.y, glowEndX, glowEndY);

            ray.addColorStop(0, `rgba(255, 255, 245, ${0.92 * alpha})`);
            ray.addColorStop(0.42, `rgba(138, 242, 255, ${0.58 * alpha})`);
            ray.addColorStop(1, 'rgba(122, 176, 255, 0)');

            context.lineCap = 'round';
            context.strokeStyle = ray;
            context.lineWidth = Math.max(2, 5.2 * effect.scale) * alpha;
            context.beginPath();
            context.moveTo(effect.x, effect.y);
            context.lineTo(glowEndX, glowEndY);
            context.stroke();

            context.strokeStyle = `rgba(255, 255, 245, ${0.86 * alpha})`;
            context.lineWidth = Math.max(1, 1.7 * effect.scale) * alpha;
            context.beginPath();
            context.moveTo(effect.x, effect.y);
            context.lineTo(rayEndX, rayEndY);
            context.stroke();

            const radius = (12 + Math.sin(now / 95) * 2) * effect.scale;
            const core = context.createRadialGradient(effect.x, effect.y, 0, effect.x, effect.y, radius);

            core.addColorStop(0, `rgba(255, 255, 255, ${alpha})`);
            core.addColorStop(0.35, `rgba(168, 248, 255, ${0.72 * alpha})`);
            core.addColorStop(1, 'rgba(89, 166, 255, 0)');

            context.fillStyle = core;
            context.beginPath();
            context.arc(effect.x, effect.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        for (let i = this.aimParticles.length - 1; i >= 0; i--) {
            const particle = this.aimParticles[i];
            particle.life -= frameScale;

            if (particle.life <= 0) {
                this.aimParticles.splice(i, 1);
                continue;
            }

            particle.x += particle.vx * frameScale;
            particle.y += particle.vy * frameScale;
            particle.vx *= 0.985;
            particle.vy *= 0.985;

            const progress = particle.life / particle.maxLife;
            const alpha = Math.max(0, Math.min(0.9, progress));
            const radius = particle.size * (0.45 + progress * 0.9);
            const sparkle = context.createRadialGradient(particle.x, particle.y, 0, particle.x, particle.y, radius);

            sparkle.addColorStop(0, `rgba(255, 255, 255, ${alpha})`);
            sparkle.addColorStop(0.45, `rgba(162, 244, 255, ${0.72 * alpha})`);
            sparkle.addColorStop(1, 'rgba(110, 160, 255, 0)');

            context.fillStyle = sparkle;
            context.beginPath();
            context.arc(particle.x, particle.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private emitPortalSparks(point: CanvasPoint, scale: number, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const count = Math.ceil(2.4 * frameScale);

        for (let i = 0; i < count; i++) {
            const angle = Math.random() * Math.PI * 2;
            const speed = (0.55 + Math.random() * 1.5) * scale;
            const life = 14 + Math.random() * 18;

            this.portalSparks.push({
                x: point.x + (Math.random() - 0.5) * 8 * scale,
                y: point.y + (Math.random() - 0.5) * 8 * scale,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                life,
                maxLife: life,
                size: (1.6 + Math.random() * 3.6) * scale,
                hue: 38 + Math.random() * 18
            });
        }

        if (this.portalSparks.length > this.maxPortalSparks) {
            this.portalSparks.splice(0, this.portalSparks.length - this.maxPortalSparks);
        }
    }

    private emitPortalBurst(center: CanvasPoint, radius: number, scale: number) {
        const count = Math.min(64, Math.max(28, Math.floor(radius * 0.26)));

        for (let i = 0; i < count; i++) {
            const angle = (i / count) * Math.PI * 2 + (Math.random() - 0.5) * 0.18;
            const distance = radius * (0.86 + Math.random() * 0.28);
            const speed = (1 + Math.random() * 2.6) * scale;
            const life = 26 + Math.random() * 32;

            this.portalSparks.push({
                x: center.x + Math.cos(angle) * distance,
                y: center.y + Math.sin(angle) * distance,
                vx: Math.cos(angle) * speed + (Math.random() - 0.5) * 0.9 * scale,
                vy: Math.sin(angle) * speed + (Math.random() - 0.5) * 0.9 * scale,
                life,
                maxLife: life,
                size: (2 + Math.random() * 4.8) * scale,
                hue: 38 + Math.random() * 22
            });
        }

        if (this.portalSparks.length > this.maxPortalSparks) {
            this.portalSparks.splice(0, this.portalSparks.length - this.maxPortalSparks);
        }
    }

    private drawPortalEffects(context: CanvasRenderingContext2D, delta: number, hands: HandFrame[]) {
        this.drawPortalTrace(context);
        this.drawPortalSparks(context, delta);
        this.drawOpenPortals(context, delta);
        this.drawPortalDebugOverlay(context, hands);
    }

    private drawPortalDebugOverlay(context: CanvasRenderingContext2D, hands: HandFrame[]) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const scale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const panelX = 18 * scale;
        const panelY = 18 * scale;
        const panelWidth = 178 * scale;
        const lineHeight = 18 * scale;
        const panelHeight = 80 * scale;
        const openPalmCount = hands.filter((hand) => hand.palm.isOpen).length;
        const state = this.hasOpenPortal() ? 'portalOpen' : this.portalState;
        const lines = [
            `portal: ${state}`,
            `score: ${Math.round(this.portalCircleScore)}/100`,
            `open palms: ${Math.min(openPalmCount, 2)}/2`
        ];

        context.save();
        context.font = `${12 * scale}px sans-serif`;
        context.textBaseline = 'top';
        context.fillStyle = 'rgba(6, 7, 7, 0.64)';
        context.fillRect(panelX, panelY, panelWidth, panelHeight);
        context.strokeStyle = 'rgba(255, 210, 116, 0.28)';
        context.lineWidth = Math.max(1, scale);
        context.strokeRect(panelX, panelY, panelWidth, panelHeight);

        lines.forEach((line, index) => {
            context.fillStyle = index === 0 ? 'rgba(255, 232, 172, 0.95)' : 'rgba(247, 242, 232, 0.84)';
            context.fillText(line, panelX + 12 * scale, panelY + 11 * scale + index * lineHeight);
        });

        hands.forEach((hand) => {
            const isAnchor = this.portalAnchorTrackId === hand.trackId;
            const isDrawing = this.portalDrawingTrackId === hand.trackId;
            const color = isDrawing ?
                'rgba(255, 180, 64, 0.96)' :
                isAnchor ?
                    'rgba(119, 231, 255, 0.94)' :
                    hand.palm.isOpen ?
                        'rgba(126, 241, 178, 0.88)' :
                        'rgba(255, 255, 255, 0.58)';
            const radius = (isDrawing ? 12 : isAnchor ? 8 : 5) * scale;
            const label = isDrawing ? 'drawing palm' : isAnchor ? 'anchor palm' : 'palm center';

            context.shadowColor = color;
            context.shadowBlur = (isDrawing ? 16 : 10) * scale;
            context.fillStyle = color;
            context.beginPath();
            context.arc(hand.center.x, hand.center.y, radius, 0, Math.PI * 2);
            context.fill();

            context.shadowBlur = 0;
            context.strokeStyle = 'rgba(7, 8, 6, 0.72)';
            context.lineWidth = 2 * scale;
            context.stroke();
            if (isDrawing) {
                context.strokeStyle = 'rgba(255, 246, 202, 0.96)';
                context.lineWidth = 2.4 * scale;
                context.beginPath();
                context.arc(hand.center.x, hand.center.y, radius + 7 * scale, 0, Math.PI * 2);
                context.stroke();
                context.beginPath();
                context.moveTo(hand.center.x - (radius + 12 * scale), hand.center.y);
                context.lineTo(hand.center.x - (radius + 4 * scale), hand.center.y);
                context.moveTo(hand.center.x + (radius + 4 * scale), hand.center.y);
                context.lineTo(hand.center.x + (radius + 12 * scale), hand.center.y);
                context.moveTo(hand.center.x, hand.center.y - (radius + 12 * scale));
                context.lineTo(hand.center.x, hand.center.y - (radius + 4 * scale));
                context.moveTo(hand.center.x, hand.center.y + (radius + 4 * scale));
                context.lineTo(hand.center.x, hand.center.y + (radius + 12 * scale));
                context.stroke();
            }
            this.drawDebugLabel(context, label, hand.center.x + 10 * scale, hand.center.y - 9 * scale, scale);
        });

        context.restore();
    }

    private drawDebugLabel(context: CanvasRenderingContext2D, text: string, x: number, y: number, scale: number) {
        context.font = `${11 * scale}px sans-serif`;
        const paddingX = 5 * scale;
        const paddingY = 3 * scale;
        const width = context.measureText(text).width + paddingX * 2;
        const height = 16 * scale;

        context.fillStyle = 'rgba(5, 6, 5, 0.66)';
        context.fillRect(x, y, width, height);
        context.fillStyle = 'rgba(255, 246, 214, 0.92)';
        context.fillText(text, x + paddingX, y + paddingY);
    }

    private drawPortalTrace(context: CanvasRenderingContext2D) {
        if (this.portalTrace.length < 2) return;

        const canvas = this.effectCanvas?.nativeElement;
        const scale = canvas ? Math.max(1, Math.min(canvas.width, canvas.height) / 760) : 1;
        const last = this.portalTrace[this.portalTrace.length - 1];

        context.save();
        context.globalCompositeOperation = 'lighter';
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.shadowColor = 'rgba(255, 168, 48, 0.84)';
        context.shadowBlur = 22 * scale;
        context.strokeStyle = 'rgba(255, 184, 54, 0.84)';
        context.lineWidth = 6.2 * scale;
        context.beginPath();

        this.portalTrace.forEach((point, index) => {
            if (index === 0) context.moveTo(point.x, point.y);
            else context.lineTo(point.x, point.y);
        });

        context.stroke();

        context.shadowBlur = 0;
        context.strokeStyle = 'rgba(255, 250, 206, 0.92)';
        context.lineWidth = 2 * scale;
        context.stroke();

        const glow = context.createRadialGradient(last.x, last.y, 0, last.x, last.y, 24 * scale);
        glow.addColorStop(0, 'rgba(255, 255, 238, 0.95)');
        glow.addColorStop(0.42, 'rgba(255, 192, 75, 0.68)');
        glow.addColorStop(1, 'rgba(255, 128, 24, 0)');
        context.fillStyle = glow;
        context.beginPath();
        context.arc(last.x, last.y, 24 * scale, 0, Math.PI * 2);
        context.fill();

        context.strokeStyle = 'rgba(255, 252, 215, 0.95)';
        context.lineWidth = 2.4 * scale;
        context.beginPath();
        context.arc(last.x, last.y, 9 * scale, 0, Math.PI * 2);
        context.stroke();
        context.restore();
    }

    private drawPortalSparks(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        context.save();
        context.globalCompositeOperation = 'lighter';
        context.shadowColor = 'rgba(255, 156, 38, 0.72)';
        context.shadowBlur = 6;

        for (let i = this.portalSparks.length - 1; i >= 0; i--) {
            const spark = this.portalSparks[i];
            spark.life -= frameScale;

            if (spark.life <= 0) {
                this.portalSparks.splice(i, 1);
                continue;
            }

            spark.x += spark.vx * frameScale;
            spark.y += spark.vy * frameScale;
            spark.vx *= 0.966;
            spark.vy *= 0.966;

            const progress = spark.life / spark.maxLife;
            const alpha = Math.max(0, Math.min(0.92, progress));
            const radius = spark.size * (0.42 + progress * 0.82);

            context.fillStyle = `hsla(${spark.hue}, 100%, ${62 + progress * 22}%, ${alpha * 0.82})`;
            context.beginPath();
            context.arc(spark.x, spark.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private drawOpenPortals(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const now = performance.now();

        context.save();
        context.globalCompositeOperation = 'lighter';
        context.lineCap = 'round';

        for (let i = this.portalEffects.length - 1; i >= 0; i--) {
            const portal = this.portalEffects[i];
            portal.life -= delta;

            if (portal.life <= 0) {
                this.portalEffects.splice(i, 1);
                continue;
            }

            portal.rotation += portal.spin * frameScale;

            const age = portal.maxLife - portal.life;
            const openAlpha = Math.min(1, age / 360);
            const fadeAlpha = Math.min(1, portal.life / 650);
            const alpha = Math.max(0, Math.min(1, openAlpha * fadeAlpha));
            const pulse = 1 + Math.sin(now / 130 + portal.rotation) * 0.025;
            const radius = portal.radius * pulse;
            const innerRadius = radius * 0.68;
            const outerRadius = radius * 1.08;

            const core = context.createRadialGradient(portal.x, portal.y, innerRadius * 0.15, portal.x, portal.y, outerRadius);
            core.addColorStop(0, `rgba(255, 238, 168, ${0.08 * alpha})`);
            core.addColorStop(0.58, `rgba(255, 178, 54, ${0.14 * alpha})`);
            core.addColorStop(0.78, `rgba(255, 126, 22, ${0.28 * alpha})`);
            core.addColorStop(1, 'rgba(255, 92, 12, 0)');

            context.fillStyle = core;
            context.beginPath();
            context.arc(portal.x, portal.y, outerRadius, 0, Math.PI * 2);
            context.fill();

            this.drawPortalArcRing(context, portal, radius, alpha, 0, 0.9, 6);
            this.drawPortalArcRing(context, portal, radius * 0.86, alpha * 0.72, Math.PI * 0.18, -0.7, 5);
            this.drawPortalArcRing(context, portal, radius * 1.1, alpha * 0.42, Math.PI * 0.34, 1.15, 7);

            context.strokeStyle = `rgba(255, 243, 186, ${0.5 * alpha})`;
            context.lineWidth = Math.max(1, 1.5 * portal.scale);
            context.beginPath();
            context.arc(portal.x, portal.y, innerRadius, 0, Math.PI * 2);
            context.stroke();

            const sparkCount = 16;
            for (let j = 0; j < sparkCount; j++) {
                const angle = portal.rotation * 1.35 + (j / sparkCount) * Math.PI * 2;
                const jitter = Math.sin(now / 90 + j * 1.7) * 0.05;
                const sparkRadius = radius * (0.94 + jitter);
                const x = portal.x + Math.cos(angle) * sparkRadius;
                const y = portal.y + Math.sin(angle) * sparkRadius;
                const size = (1.4 + (j % 4) * 0.55) * portal.scale;

                context.fillStyle = `rgba(255, 238, 166, ${0.7 * alpha})`;
                context.beginPath();
                context.arc(x, y, size, 0, Math.PI * 2);
                context.fill();
            }
        }

        context.restore();

        if (this.portalEffects.length === 0 && this.portalState === 'portalOpen') {
            this.portalState = 'idle';
            this.portalCircleScore = 0;
        }
    }

    private drawPortalArcRing(
        context: CanvasRenderingContext2D,
        portal: PortalEffect,
        radius: number,
        alpha: number,
        offset: number,
        spinFactor: number,
        segments: number
    ) {
        const baseAngle = portal.rotation * spinFactor + offset;

        context.strokeStyle = `rgba(255, 188, 58, ${0.72 * alpha})`;
        context.shadowColor = `rgba(255, 132, 26, ${0.62 * alpha})`;
        context.shadowBlur = 12 * portal.scale;
        context.lineWidth = Math.max(1.5, 4.2 * portal.scale) * Math.max(0.35, alpha);

        for (let i = 0; i < segments; i++) {
            const start = baseAngle + (i / segments) * Math.PI * 2;
            const arcLength = Math.PI * (0.18 + (i % 3) * 0.028);

            context.beginPath();
            context.arc(portal.x, portal.y, radius, start, start + arcLength);
            context.stroke();
        }

        context.shadowBlur = 0;
        context.strokeStyle = `rgba(255, 248, 205, ${0.48 * alpha})`;
        context.lineWidth = Math.max(1, 1.6 * portal.scale) * Math.max(0.35, alpha);
        context.beginPath();
        context.arc(portal.x, portal.y, radius, 0, Math.PI * 2);
        context.stroke();
    }

    private isOutsideCanvas(projectile: EnergyProjectile, canvas?: HTMLCanvasElement): boolean {
        if (!canvas) return false;
        const margin = projectile.radius * 1.6;
        return projectile.x < -margin ||
            projectile.x > canvas.width + margin ||
            projectile.y < -margin ||
            projectile.y > canvas.height + margin;
    }

    private emitFlame(x: number, y: number, delta: number) {
        const canvas = this.effectCanvas?.nativeElement;
        if (!canvas) return;

        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));
        const sizeScale = Math.max(1, Math.min(canvas.width, canvas.height) / 760);
        const count = Math.ceil(7 * frameScale);

        for (let i = 0; i < count; i++) {
            const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.35;
            const speed = (1.15 + Math.random() * 2.6) * sizeScale;
            const life = 24 + Math.random() * 24;

            this.particles.push({
                x: x + (Math.random() - 0.5) * 14 * sizeScale,
                y: y + (Math.random() - 0.5) * 10 * sizeScale,
                vx: Math.cos(angle) * speed + (Math.random() - 0.5) * 0.8 * sizeScale,
                vy: Math.sin(angle) * speed - 0.4 * sizeScale,
                life,
                maxLife: life,
                size: (4 + Math.random() * 10) * sizeScale,
                hue: 22 + Math.random() * 26
            });
        }

        if (this.particles.length > this.maxParticles) {
            this.particles.splice(0, this.particles.length - this.maxParticles);
        }
    }

    private drawParticles(context: CanvasRenderingContext2D, delta: number) {
        const frameScale = Math.max(0.6, Math.min(2.4, delta / 16.67));

        context.save();
        context.globalCompositeOperation = 'lighter';

        for (let i = this.particles.length - 1; i >= 0; i--) {
            const particle = this.particles[i];
            particle.life -= frameScale;

            if (particle.life <= 0) {
                this.particles.splice(i, 1);
                continue;
            }

            particle.x += particle.vx * frameScale;
            particle.y += particle.vy * frameScale;
            particle.vy -= 0.035 * frameScale;
            particle.vx *= 0.985;

            const progress = particle.life / particle.maxLife;
            const alpha = Math.max(0, Math.min(0.92, progress));
            const radius = particle.size * (0.35 + progress * 0.95);
            const gradient = context.createRadialGradient(
                particle.x,
                particle.y,
                0,
                particle.x,
                particle.y,
                radius
            );

            gradient.addColorStop(0, `rgba(255, 255, 218, ${alpha})`);
            gradient.addColorStop(0.32, `hsla(${particle.hue}, 100%, 62%, ${alpha * 0.78})`);
            gradient.addColorStop(1, `rgba(255, 46, 0, 0)`);

            context.fillStyle = gradient;
            context.beginPath();
            context.arc(particle.x, particle.y, radius, 0, Math.PI * 2);
            context.fill();
        }

        context.restore();
    }

    private resetModeEffects() {
        this.particles = [];
        this.aimParticles = [];
        this.energyParticles = [];
        this.energyProjectiles = [];
        this.portalSparks = [];
        this.resetAimState();
        this.resetFistState();
        this.resetPortalState();
        this.resetOrbCompressState();
        this.resetDesktopPracticeState();
        this.resetRealDesktopGestureState();
        this.pinchActiveByHand = [];
        this.gestureArbiter.reset();
    }

    private updateDetectionState(handStatus: string, gestureStatus: string, spellStatus: string) {
        if (this.handStatus === handStatus &&
            this.gestureStatus === gestureStatus &&
            this.spellStatus === spellStatus) return;

        this.zone.run(() => {
            this.handStatus = handStatus;
            this.gestureStatus = gestureStatus;
            this.spellStatus = spellStatus;
            this.ref.detectChanges();
        });
    }

    private reportDetectionError(error: unknown) {
        void this.stopRealDesktopControl('손 인식 오류로 제어 중지');
        this.stopTracking();
        this.pinchActiveByHand = [];
        this.resetAimState();
        this.resetFistState();
        this.resetPortalState();
        this.resetOrbCompressState();
        this.resetDesktopPracticeState();
        this.gestureArbiter.reset();
        this.handTracks = [];

        this.zone.run(() => {
            this.errorMessage = '손 인식 중 오류가 발생했습니다. 정지 후 다시 시작해주세요.';
            this.handStatus = '인식 오류';
            this.gestureStatus = 'inactive';
            this.spellStatus = 'idle';
            this.ref.detectChanges();
        });
    }

    private handleStartError(error: unknown) {
        const code = error instanceof DOMException ? error.name : error instanceof Error ? error.message : '';

        if (code === 'NotAllowedError' || code === 'PermissionDeniedError') {
            this.hasPermission = false;
            this.setFailure('카메라 권한이 거부되었습니다. 브라우저 주소창의 권한 설정에서 카메라를 허용해주세요.');
            return;
        }

        if (code === 'NotFoundError' || code === 'DevicesNotFoundError' || code === 'NO_CAMERA') {
            this.setFailure('사용 가능한 카메라가 없습니다. Logitech USB 카메라 연결 상태를 확인해주세요.');
            return;
        }

        if (code === 'OverconstrainedError' || code === 'ConstraintNotSatisfiedError') {
            this.setFailure('선택한 카메라를 열 수 없습니다. 다른 카메라를 선택하거나 USB 연결을 확인해주세요.');
            return;
        }

        if (code === 'MODEL_LOAD_FAILED') {
            this.setFailure('손 인식 모델을 불러오지 못했습니다. 네트워크와 배포된 모델 파일을 확인해주세요.');
            return;
        }

        this.setFailure('카메라 또는 손 인식을 시작하지 못했습니다. 권한과 장치 연결을 확인해주세요.');
    }

    private setFailure(message: string) {
        this.errorMessage = message;
        this.cameraStatus = '오류';
        this.handStatus = '대기';
        this.gestureStatus = 'inactive';
        this.spellStatus = 'idle';
    }

    private stopActiveStream() {
        this.stopMediaStream(this.stream);
        this.stream = null;

        const video = this.videoElement?.nativeElement;
        if (video) {
            video.pause();
            video.srcObject = null;
        }

        this.activeCameraLabel = '';
    }

    private stopMediaStream(stream: MediaStream | null) {
        if (!stream) return;
        stream.getTracks().forEach((track) => track.stop());
    }

    private clearCanvas() {
        const canvas = this.effectCanvas?.nativeElement;
        const context = canvas?.getContext('2d');
        if (!canvas || !context) return;
        context.clearRect(0, 0, canvas.width, canvas.height);
    }
}

export default PageDashboardComponent;